import "./path0.daaba8e3.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3137"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3137"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $iuB9z = parcelRequire("iuB9z");

var $hA6FJ = parcelRequire("hA6FJ");

var $kdszX = parcelRequire("kdszX");
parcelRequire("3AV5l");

var $iuB9z = parcelRequire("iuB9z");

var $iuB9z = parcelRequire("iuB9z");
var $42e99abe49af6e6d$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";


var $e2ef54330f8e96e8$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}";



var $iuB9z = parcelRequire("iuB9z");


var $86cf6211eb4e3b5f$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uOffset;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture(uTexture, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample top right pixel\n    color += texture(uTexture, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample bottom right pixel\n    color += texture(uTexture, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Sample bottom left pixel\n    color += texture(uTexture, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Average\n    color *= 0.25;\n\n    finalColor = color;\n}";


var $3f0c4597053073e7$export$2e2bcd8739ae039 = "struct KawaseBlurUniforms {\n  uOffset:vec2<f32>,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> kawaseBlurUniforms : KawaseBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uOffset = kawaseBlurUniforms.uOffset;\n  var color: vec4<f32> = vec4<f32>(0.0);\n\n  // Sample top left pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x - uOffset.x, uv.y + uOffset.y));\n  // Sample top right pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x + uOffset.x, uv.y + uOffset.y));\n  // Sample bottom right pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x + uOffset.x, uv.y - uOffset.y));\n  // Sample bottom left pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x - uOffset.x, uv.y - uOffset.y));\n  // Average\n  color *= 0.25;\n\n  return color;\n}";


var $23d5233c08021932$export$2e2bcd8739ae039 = "\nprecision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uOffset;\n\nuniform vec4 uInputClamp;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample top right pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample bottom right pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample bottom left pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Average\n    color *= 0.25;\n\n    finalColor = color;\n}\n";


var $34eff41f1fc6abda$export$2e2bcd8739ae039 = "struct KawaseBlurUniforms {\n  uOffset:vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> kawaseBlurUniforms : KawaseBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uOffset = kawaseBlurUniforms.uOffset;\n  var color: vec4<f32> = vec4(0.0);\n\n  // Sample top left pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x - uOffset.x, uv.y + uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample top right pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x + uOffset.x, uv.y + uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample bottom right pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x + uOffset.x, uv.y - uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample bottom left pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x - uOffset.x, uv.y - uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Average\n  color *= 0.25;\n    \n  return color;\n}";


var $796709e102c69268$var$__defProp = Object.defineProperty;
var $796709e102c69268$var$__defNormalProp = (obj, key, value)=>key in obj ? $796709e102c69268$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $796709e102c69268$var$__publicField = (obj, key, value)=>{
    $796709e102c69268$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $796709e102c69268$var$_KawaseBlurFilter = class _KawaseBlurFilter extends (0, $iuB9z.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number" || Array.isArray(options)) {
            (0, $iuB9z.deprecation)("6.0.0", "KawaseBlurFilter constructor params are now options object. See params: { strength, quality, clamp, pixelSize }");
            options = {
                strength: options
            };
            if (args[1] !== void 0) options.quality = args[1];
            if (args[2] !== void 0) options.clamp = args[2];
        }
        options = {
            ..._KawaseBlurFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $iuB9z.GpuProgram).from({
            vertex: {
                source: (0, $e2ef54330f8e96e8$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: options?.clamp ? (0, $34eff41f1fc6abda$export$2e2bcd8739ae039) : (0, $3f0c4597053073e7$export$2e2bcd8739ae039),
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $iuB9z.GlProgram).from({
            vertex: $42e99abe49af6e6d$export$2e2bcd8739ae039,
            fragment: options?.clamp ? (0, $23d5233c08021932$export$2e2bcd8739ae039) : (0, $86cf6211eb4e3b5f$export$2e2bcd8739ae039),
            name: "kawase-blur-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                kawaseBlurUniforms: {
                    uOffset: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $796709e102c69268$var$__publicField(this, "uniforms");
        $796709e102c69268$var$__publicField(this, "_pixelSize", {
            x: 0,
            y: 0
        });
        $796709e102c69268$var$__publicField(this, "_clamp");
        $796709e102c69268$var$__publicField(this, "_kernels", []);
        $796709e102c69268$var$__publicField(this, "_blur");
        $796709e102c69268$var$__publicField(this, "_quality");
        this.uniforms = this.resources.kawaseBlurUniforms.uniforms;
        this.pixelSize = options.pixelSize ?? {
            x: 1,
            y: 1
        };
        if (Array.isArray(options.strength)) this.kernels = options.strength;
        else if (typeof options.strength === "number") {
            this._blur = options.strength;
            this.quality = options.quality ?? 3;
        }
        this._clamp = !!options.clamp;
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const uvX = this.pixelSizeX / input.source.width;
        const uvY = this.pixelSizeY / input.source.height;
        let offset;
        if (this._quality === 1 || this._blur === 0) {
            offset = this._kernels[0] + 0.5;
            this.uniforms.uOffset[0] = offset * uvX;
            this.uniforms.uOffset[1] = offset * uvY;
            filterManager.applyFilter(this, input, output, clearMode);
        } else {
            const renderTarget = (0, $iuB9z.TexturePool).getSameSizeTexture(input);
            let source2 = input;
            let target = renderTarget;
            let tmp;
            const last = this._quality - 1;
            for(let i = 0; i < last; i++){
                offset = this._kernels[i] + 0.5;
                this.uniforms.uOffset[0] = offset * uvX;
                this.uniforms.uOffset[1] = offset * uvY;
                filterManager.applyFilter(this, source2, target, true);
                tmp = source2;
                source2 = target;
                target = tmp;
            }
            offset = this._kernels[last] + 0.5;
            this.uniforms.uOffset[0] = offset * uvX;
            this.uniforms.uOffset[1] = offset * uvY;
            filterManager.applyFilter(this, source2, output, clearMode);
            (0, $iuB9z.TexturePool).returnTexture(renderTarget);
        }
    }
    /**
    * The amount of blur, value greater than `0`.
    * @default 4
    */ get strength() {
        return this._blur;
    }
    set strength(value) {
        this._blur = value;
        this._generateKernels();
    }
    /**
    * The quality of the filter, integer greater than `1`.
    * @default 3
    */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = Math.max(1, Math.round(value));
        this._generateKernels();
    }
    /**
    * The kernel size of the blur filter, for advanced usage
    * @default [0]
    */ get kernels() {
        return this._kernels;
    }
    set kernels(value) {
        if (Array.isArray(value) && value.length > 0) {
            this._kernels = value;
            this._quality = value.length;
            this._blur = Math.max(...value);
        } else {
            this._kernels = [
                0
            ];
            this._quality = 1;
        }
    }
    /**
    * The size of the pixels. Large size is blurrier. For advanced usage.
    * @default {x:1,y:1}
    */ get pixelSize() {
        return this._pixelSize;
    }
    set pixelSize(value) {
        if (typeof value === "number") {
            this.pixelSizeX = this.pixelSizeY = value;
            return;
        }
        if (Array.isArray(value)) {
            this.pixelSizeX = value[0];
            this.pixelSizeY = value[1];
            return;
        }
        this._pixelSize = value;
    }
    /**
    * The size of the pixels on the `x` axis. Large size is blurrier. For advanced usage.
    * @default 1
    */ get pixelSizeX() {
        return this.pixelSize.x;
    }
    set pixelSizeX(value) {
        this.pixelSize.x = value;
    }
    /**
    * The size of the pixels on the `y` axis. Large size is blurrier. For advanced usage.
    * @default 1
    */ get pixelSizeY() {
        return this.pixelSize.y;
    }
    set pixelSizeY(value) {
        this.pixelSize.y = value;
    }
    /**
    * Get the if the filter is clamped
    * @default false
    */ get clamp() {
        return this._clamp;
    }
    /** Update padding based on kernel data */ _updatePadding() {
        this.padding = Math.ceil(this._kernels.reduce((acc, v)=>acc + v + 0.5, 0));
    }
    /** Auto generate kernels by blur & quality */ _generateKernels() {
        const blur = this._blur;
        const quality = this._quality;
        const kernels = [
            blur
        ];
        if (blur > 0) {
            let k = blur;
            const step = blur / quality;
            for(let i = 1; i < quality; i++){
                k -= step;
                kernels.push(k);
            }
        }
        this._kernels = kernels;
        this._updatePadding();
    }
};
/** Default values for options. */ $796709e102c69268$var$__publicField($796709e102c69268$var$_KawaseBlurFilter, "DEFAULT_OPTIONS", {
    strength: 4,
    quality: 3,
    clamp: false,
    pixelSize: {
        x: 1,
        y: 1
    }
});
let $796709e102c69268$export$31164edf0fb20199 = $796709e102c69268$var$_KawaseBlurFilter;


var $7507079141999b96$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform sampler2D uMapTexture;\nuniform float uBloomScale;\nuniform float uBrightness;\n\nvoid main() {\n    vec4 color = texture(uTexture, vTextureCoord);\n    color.rgb *= uBrightness;\n    vec4 bloomColor = vec4(texture(uMapTexture, vTextureCoord).rgb, 0.0);\n    bloomColor.rgb *= uBloomScale;\n    finalColor = color + bloomColor;\n}\n";


var $6ea6ad9070fc75e1$export$2e2bcd8739ae039 = "struct AdvancedBloomUniforms {\n  uBloomScale: f32,\n  uBrightness: f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> advancedBloomUniforms : AdvancedBloomUniforms;\n@group(1) @binding(1) var uMapTexture: texture_2d<f32>;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  var color = textureSample(uTexture, uSampler, uv);\n  color = vec4<f32>(color.rgb * advancedBloomUniforms.uBrightness, color.a);\n\n  var bloomColor = vec4<f32>(textureSample(uMapTexture, uSampler, uv).rgb, 0.0);\n  bloomColor = vec4<f32>(bloomColor.rgb * advancedBloomUniforms.uBloomScale, bloomColor.a);\n  \n  return color + bloomColor;\n}\n";



var $iuB9z = parcelRequire("iuB9z");


var $6c50511ea11a5658$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uThreshold;\n\nvoid main() {\n    vec4 color = texture(uTexture, vTextureCoord);\n\n    // A simple & fast algorithm for getting brightness.\n    // It's inaccuracy , but good enought for this feature.\n    float _max = max(max(color.r, color.g), color.b);\n    float _min = min(min(color.r, color.g), color.b);\n    float brightness = (_max + _min) * 0.5;\n\n    if(brightness > uThreshold) {\n        finalColor = color;\n    } else {\n        finalColor = vec4(0.0, 0.0, 0.0, 0.0);\n    }\n}\n";


var $fb2688e4721e23b6$export$2e2bcd8739ae039 = "struct ExtractBrightnessUniforms {\n  uThreshold: f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> extractBrightnessUniforms : ExtractBrightnessUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  // A simple & fast algorithm for getting brightness.\n  // It's inaccurate, but good enough for this feature.\n  let max: f32 = max(max(color.r, color.g), color.b);\n  let min: f32 = min(min(color.r, color.g), color.b);\n  let brightness: f32 = (max + min) * 0.5;\n\n  return select(vec4<f32>(0.), color, brightness > extractBrightnessUniforms.uThreshold);\n}\n";


var $8a55b3de4c82ce11$var$__defProp = Object.defineProperty;
var $8a55b3de4c82ce11$var$__defNormalProp = (obj, key, value)=>key in obj ? $8a55b3de4c82ce11$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8a55b3de4c82ce11$var$__publicField = (obj, key, value)=>{
    $8a55b3de4c82ce11$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $8a55b3de4c82ce11$var$_ExtractBrightnessFilter = class _ExtractBrightnessFilter extends (0, $iuB9z.Filter) {
    constructor(options){
        options = {
            ..._ExtractBrightnessFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $iuB9z.GpuProgram).from({
            vertex: {
                source: (0, $e2ef54330f8e96e8$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $fb2688e4721e23b6$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $iuB9z.GlProgram).from({
            vertex: $42e99abe49af6e6d$export$2e2bcd8739ae039,
            fragment: $6c50511ea11a5658$export$2e2bcd8739ae039,
            name: "extract-brightness-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                extractBrightnessUniforms: {
                    uThreshold: {
                        value: options.threshold,
                        type: "f32"
                    }
                }
            }
        });
        $8a55b3de4c82ce11$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.extractBrightnessUniforms.uniforms;
    }
    /**
   * Defines how bright a color needs to be extracted.
   * @default 0.5
   */ get threshold() {
        return this.uniforms.uThreshold;
    }
    set threshold(value) {
        this.uniforms.uThreshold = value;
    }
};
/** Default values for options. */ $8a55b3de4c82ce11$var$__publicField($8a55b3de4c82ce11$var$_ExtractBrightnessFilter, "DEFAULT_OPTIONS", {
    threshold: 0.5
});
let $8a55b3de4c82ce11$export$3184aba1f05c290d = $8a55b3de4c82ce11$var$_ExtractBrightnessFilter;


var $13d2b0139ea22994$var$__defProp = Object.defineProperty;
var $13d2b0139ea22994$var$__defNormalProp = (obj, key, value)=>key in obj ? $13d2b0139ea22994$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $13d2b0139ea22994$var$__publicField = (obj, key, value)=>{
    $13d2b0139ea22994$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $13d2b0139ea22994$var$_AdvancedBloomFilter = class _AdvancedBloomFilter extends (0, $iuB9z.Filter) {
    /**
   * @param options - Options for the AdvancedBloomFilter constructor.
   */ constructor(options){
        options = {
            ..._AdvancedBloomFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $iuB9z.GpuProgram).from({
            vertex: {
                source: (0, $e2ef54330f8e96e8$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $6ea6ad9070fc75e1$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $iuB9z.GlProgram).from({
            vertex: $42e99abe49af6e6d$export$2e2bcd8739ae039,
            fragment: $7507079141999b96$export$2e2bcd8739ae039,
            name: "advanced-bloom-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                advancedBloomUniforms: {
                    uBloomScale: {
                        value: options.bloomScale,
                        type: "f32"
                    },
                    uBrightness: {
                        value: options.brightness,
                        type: "f32"
                    }
                },
                uMapTexture: (0, $iuB9z.Texture).WHITE
            }
        });
        $13d2b0139ea22994$var$__publicField(this, "uniforms");
        /** To adjust the strength of the bloom. Higher values is more intense brightness. */ $13d2b0139ea22994$var$__publicField(this, "bloomScale", 1);
        /** The brightness, lower value is more subtle brightness, higher value is blown-out. */ $13d2b0139ea22994$var$__publicField(this, "brightness", 1);
        $13d2b0139ea22994$var$__publicField(this, "_extractFilter");
        $13d2b0139ea22994$var$__publicField(this, "_blurFilter");
        this.uniforms = this.resources.advancedBloomUniforms.uniforms;
        this._extractFilter = new (0, $8a55b3de4c82ce11$export$3184aba1f05c290d)({
            threshold: options.threshold
        });
        this._blurFilter = new (0, $796709e102c69268$export$31164edf0fb20199)({
            strength: options.kernels ?? options.blur,
            quality: options.kernels ? void 0 : options.quality
        });
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const brightTarget = (0, $iuB9z.TexturePool).getSameSizeTexture(input);
        this._extractFilter.apply(filterManager, input, brightTarget, true);
        const bloomTarget = (0, $iuB9z.TexturePool).getSameSizeTexture(input);
        this._blurFilter.apply(filterManager, brightTarget, bloomTarget, true);
        this.uniforms.uBloomScale = this.bloomScale;
        this.uniforms.uBrightness = this.brightness;
        this.resources.uMapTexture = bloomTarget.source;
        filterManager.applyFilter(this, input, output, clearMode);
        (0, $iuB9z.TexturePool).returnTexture(bloomTarget);
        (0, $iuB9z.TexturePool).returnTexture(brightTarget);
    }
    /**
   * Defines how bright a color needs to be extracted.
   * @default 0.5
   */ get threshold() {
        return this._extractFilter.threshold;
    }
    set threshold(value) {
        this._extractFilter.threshold = value;
    }
    /** The kernels of the Blur Filter */ get kernels() {
        return this._blurFilter.kernels;
    }
    set kernels(value) {
        this._blurFilter.kernels = value;
    }
    /**
   * The strength of the Blur properties simultaneously
   * @default 2
   */ get blur() {
        return this._blurFilter.strength;
    }
    set blur(value) {
        this._blurFilter.strength = value;
    }
    /**
   * The quality of the Blur Filter
   * @default 4
   */ get quality() {
        return this._blurFilter.quality;
    }
    set quality(value) {
        this._blurFilter.quality = value;
    }
    /**
   * The pixel size of the Kawase Blur filter
   * @default {x:1,y:1}
   */ get pixelSize() {
        return this._blurFilter.pixelSize;
    }
    set pixelSize(value) {
        if (typeof value === "number") value = {
            x: value,
            y: value
        };
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this._blurFilter.pixelSize = value;
    }
    /**
   * The horizontal pixelSize of the Kawase Blur filter
   * @default 1
   */ get pixelSizeX() {
        return this._blurFilter.pixelSizeX;
    }
    set pixelSizeX(value) {
        this._blurFilter.pixelSizeX = value;
    }
    /**
   * The vertical pixel size of the Kawase Blur filter
   * @default 1
   */ get pixelSizeY() {
        return this._blurFilter.pixelSizeY;
    }
    set pixelSizeY(value) {
        this._blurFilter.pixelSizeY = value;
    }
};
/** Default values for options. */ $13d2b0139ea22994$var$__publicField($13d2b0139ea22994$var$_AdvancedBloomFilter, "DEFAULT_OPTIONS", {
    threshold: 0.5,
    bloomScale: 1,
    brightness: 1,
    blur: 8,
    quality: 4,
    pixelSize: {
        x: 1,
        y: 1
    }
});
let $13d2b0139ea22994$export$b970daeca74b07ea = $13d2b0139ea22994$var$_AdvancedBloomFilter;



var $e2Ri5 = parcelRequire("e2Ri5");

var $2oYNi = parcelRequire("2oYNi");

var $jd0t2 = parcelRequire("jd0t2");

var $9iM1N = parcelRequire("9iM1N");

var $fsTIF = parcelRequire("fsTIF");
// Filter settings
const $a50b9ffa17eb6abf$var$BLOOM_THRESHOLD = 0.4; // Brightness threshold for bloom effect
const $a50b9ffa17eb6abf$var$BLOOM_BRIGHTNESS = 1.0; // Overall brightness multiplier
const $a50b9ffa17eb6abf$var$BLOOM_BLUR = 4; // Blur amount for bloom
const $a50b9ffa17eb6abf$var$BLOOM_QUALITY = 8; // Render quality (higher = better quality, slower)
const $a50b9ffa17eb6abf$var$MIN_BLOOM_SCALE = 0.8; // Minimum bloom scale (how much bloom is applied at minimum)
const $a50b9ffa17eb6abf$var$MAX_BLOOM_SCALE = 1.2; // Maximum bloom scale (how much bloom is applied at maximum)
// Attack/decay behavior
const $a50b9ffa17eb6abf$var$BLOOM_DECAY_RATE = 0.8; // Per-frame decay multiplier (0.8 = 20% decay per frame)
// Music integration
const $a50b9ffa17eb6abf$var$MUSIC_INTENSITY_EFFECT = 0.5; // How much music intensity affects bloom (0 = none, 1 = full effect)
const $a50b9ffa17eb6abf$var$DOWNBEAT_MULTIPLIER = 1.8; // How much stronger downbeats are
const $a50b9ffa17eb6abf$var$INTENSITY_CURVE = 1.1; // Power curve applied to final intensity
class $a50b9ffa17eb6abf$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(){
        super(), this.id = "bloomController", this.tags = [
            "bloomController"
        ], this.pausable = false // Keep bloom effects during pause
        , this.persistenceLevel = (0, $e2Ri5.PersistenceLevel).Permanent, this.minBloomScale = $a50b9ffa17eb6abf$var$MIN_BLOOM_SCALE, this.maxBloomScale = $a50b9ffa17eb6abf$var$MAX_BLOOM_SCALE, this.decayRate = $a50b9ffa17eb6abf$var$BLOOM_DECAY_RATE // Per frame decay multiplier
        ;
        this.bloomFilter = new (0, $13d2b0139ea22994$export$b970daeca74b07ea)({
            threshold: $a50b9ffa17eb6abf$var$BLOOM_THRESHOLD,
            bloomScale: this.minBloomScale,
            brightness: $a50b9ffa17eb6abf$var$BLOOM_BRIGHTNESS,
            blur: $a50b9ffa17eb6abf$var$BLOOM_BLUR,
            quality: $a50b9ffa17eb6abf$var$BLOOM_QUALITY
        });
    }
    onAdd({ game: game }) {
        // Add bloom filter to stage
        game.renderer.addStageFilter(this.bloomFilter);
        // Set explicit filter area to cover entire viewport to prevent clipping
        this.updateFilterArea();
    }
    updateFilterArea() {
        if (!this.game) return;
        // This prevents Pixi from auto-calculating a smaller filter area based on object bounds
        this.game.renderer.stage.filterArea = new $iuB9z.Rectangle(0, 0, this.game.renderer.getWidth(), this.game.renderer.getHeight());
    }
    onWindowResize() {
        // Update filter area when window resizes to ensure bloom covers entire viewport
        this.updateFilterArea();
    }
    get musicGenerator() {
        const maybeMusicGenerator = this.game?.entities.getById("musicGenerator");
        if (maybeMusicGenerator instanceof (0, $9iM1N.default)) return maybeMusicGenerator;
        throw new Error("MusicGenerator entity is not available");
    }
    get tempoClock() {
        const maybeTempoClock = this.game?.entities.getById("tempoClock");
        if (maybeTempoClock instanceof (0, $fsTIF.TempoClock)) return maybeTempoClock;
        throw new Error("TempoClock entity is not available");
    }
    onTick() {
        // Find music generator and get tempo info every frame
        const tempoClock = this.tempoClock;
        if (tempoClock) {
            // Calculate beat intensity from beat phase - creates spiky pulsing effect with wide troughs
            const beatPhase = tempoClock.getBeatPhase();
            // Create a squared cosine wave for spiky peaks and wide troughs
            const cosineWave = Math.cos(beatPhase * Math.PI * 2); // -1 to 1, peaks at phase 0 (beat)
            const shiftedCosine = cosineWave + 1; // 0 to 2, peaks at phase 0
            const squaredCosine = shiftedCosine * shiftedCosine; // 0 to 4, spiky peaks at phase 0
            // Scale to bloom range: 0→0.2 (baseline), 4→1.0 (peak)
            const beatFactor = Math.max(0, Math.min(1, 0.2 + squaredCosine / 4 * 0.8));
            const isDownbeat = tempoClock.isDownbeat();
            const musicIntensity = this.musicGenerator.getParams().intensity;
            // Scale beat intensity by music intensity parameter
            // Mix between base beatFactor (when MUSIC_INTENSITY_EFFECT = 0) and music-modulated version (when = 1)
            const musicModulatedBeat = beatFactor * musicIntensity;
            const musicFactor = (0, $jd0t2.lerp)(beatFactor, musicModulatedBeat, $a50b9ffa17eb6abf$var$MUSIC_INTENSITY_EFFECT);
            let unshapedIntensity = musicFactor;
            // Make downbeat stronger
            if (isDownbeat) unshapedIntensity *= $a50b9ffa17eb6abf$var$DOWNBEAT_MULTIPLIER;
            // Apply curve to intensity
            const intensity = unshapedIntensity ** $a50b9ffa17eb6abf$var$INTENSITY_CURVE;
            // Calculate target bloom scale
            const targetBloomScale = (0, $jd0t2.lerp)(this.minBloomScale, this.maxBloomScale, intensity);
            // Attack/decay logic: fast attack, slow decay
            if (targetBloomScale > this.bloomFilter.bloomScale) // Attack: jump immediately to target
            this.bloomFilter.bloomScale = targetBloomScale;
            else // Decay: slowly approach target
            this.bloomFilter.bloomScale = (0, $jd0t2.lerp)(this.bloomFilter.bloomScale, targetBloomScale, 1 - this.decayRate);
        }
    }
    onDestroy({ game: game }) {
        game.renderer.removeStageFilter(this.bloomFilter);
        // Clean up filter area
        game.renderer.stage.filterArea = undefined;
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $c4Qw3 = parcelRequire("c4Qw3");
const $d8075dea9d554460$var$CROSSHAIR_SIZE = 24;
const $d8075dea9d554460$var$CROSSHAIR_GAP = 8;
const $d8075dea9d554460$var$CENTER_DOT_SIZE = 2;
const $d8075dea9d554460$var$CENTER_RING_SIZE = 8;
class $d8075dea9d554460$export$ae818792347e2c5a extends (0, $2oYNi.default) {
    constructor(){
        super(), this.pausable = false // Cursor should work even when game is paused
        ;
        // Create graphics for the crosshair
        this.sprite = (0, $c4Qw3.createGraphics)("cursor");
        this.drawCrosshair();
    }
    onAdd({ game: game }) {
        game.renderer.hideCursor();
    }
    onTick() {
        // Position the cursor at the current mouse position (screen coordinates)
        const mousePos = this.game.io.mousePosition;
        this.sprite.position.set(mousePos.x, mousePos.y);
    }
    drawCrosshair() {
        this.sprite.clear();
        // Main crosshair lines with gaps
        // Top line
        this.sprite.moveTo(0, -$d8075dea9d554460$var$CROSSHAIR_SIZE).lineTo(0, -$d8075dea9d554460$var$CROSSHAIR_GAP).stroke({
            color: (0, $hA6FJ.Colors).CYAN,
            width: (0, $hA6FJ.LineArt).LINE_WIDTH.STANDARD
        });
        // Bottom line
        this.sprite.moveTo(0, $d8075dea9d554460$var$CROSSHAIR_GAP).lineTo(0, $d8075dea9d554460$var$CROSSHAIR_SIZE).stroke({
            color: (0, $hA6FJ.Colors).CYAN,
            width: (0, $hA6FJ.LineArt).LINE_WIDTH.STANDARD
        });
        // Left line
        this.sprite.moveTo(-$d8075dea9d554460$var$CROSSHAIR_SIZE, 0).lineTo(-$d8075dea9d554460$var$CROSSHAIR_GAP, 0).stroke({
            color: (0, $hA6FJ.Colors).CYAN,
            width: (0, $hA6FJ.LineArt).LINE_WIDTH.STANDARD
        });
        // Right line
        this.sprite.moveTo($d8075dea9d554460$var$CROSSHAIR_GAP, 0).lineTo($d8075dea9d554460$var$CROSSHAIR_SIZE, 0).stroke({
            color: (0, $hA6FJ.Colors).CYAN,
            width: (0, $hA6FJ.LineArt).LINE_WIDTH.STANDARD
        });
        // Center elements
        // Outer ring (scaled up)
        this.sprite.circle(0, 0, $d8075dea9d554460$var$CENTER_RING_SIZE).stroke({
            color: (0, $hA6FJ.Colors).CYAN,
            width: (0, $hA6FJ.LineArt).LINE_WIDTH.STANDARD
        });
        // Center dot
        this.sprite.circle(0, 0, $d8075dea9d554460$var$CENTER_DOT_SIZE).fill({
            color: (0, $hA6FJ.Colors).CYAN
        });
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $cbsax = parcelRequire("cbsax");

var $iuB9z = parcelRequire("iuB9z");

var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $2oYNi = parcelRequire("2oYNi");

var $cbsax = parcelRequire("cbsax");

var $2oYNi = parcelRequire("2oYNi");

var $c4Qw3 = parcelRequire("c4Qw3");

var $cbsax = parcelRequire("cbsax");

var $cbsax = parcelRequire("cbsax");
function $686b22f01240f09f$export$34e53d4e8f1e555c(points, color, thickness = 1) {
    const segments = [];
    for(let i = 0; i < points.length; i++){
        const start = points[i];
        const end = points[(i + 1) % points.length];
        segments.push({
            start: start,
            end: end,
            color: color,
            thickness: thickness
        });
    }
    return segments;
}
function $686b22f01240f09f$export$36094440c00a73cf(characterSegments, color, thickness = 1, scale = 1, offset = (0, $cbsax.V)(0, 0)) {
    return characterSegments.map((segment)=>({
            start: (0, $cbsax.V)(segment.start[0] * scale + offset.x, segment.start[1] * scale + offset.y),
            end: (0, $cbsax.V)(segment.end[0] * scale + offset.x, segment.end[1] * scale + offset.y),
            color: color,
            thickness: thickness
        }));
}
function $686b22f01240f09f$export$96efaa5b70937ae2(pairs, color, thickness = 1) {
    return pairs.map(([start, end])=>({
            start: start,
            end: end,
            color: color,
            thickness: thickness
        }));
}
function $686b22f01240f09f$export$edf7938f162781dd(size, color, thickness = 1) {
    return [
        {
            start: (0, $cbsax.V)(-size, 0),
            end: (0, $cbsax.V)(size, 0),
            color: color,
            thickness: thickness
        },
        {
            start: (0, $cbsax.V)(0, -size),
            end: (0, $cbsax.V)(0, size),
            color: color,
            thickness: thickness
        }
    ];
}
function $686b22f01240f09f$export$6fd8e802d7936c81(size, color, thickness = 1) {
    return [
        {
            start: (0, $cbsax.V)(-size, -size),
            end: (0, $cbsax.V)(size, size),
            color: color,
            thickness: thickness
        },
        {
            start: (0, $cbsax.V)(-size, size),
            end: (0, $cbsax.V)(size, -size),
            color: color,
            thickness: thickness
        }
    ];
}
function $686b22f01240f09f$export$6cfcc7d70288d8c8(extractedSegments, colors, thickness = 1) {
    return extractedSegments.map((segment, i)=>({
            start: segment.start,
            end: segment.end,
            color: colors[i % colors.length],
            thickness: thickness
        }));
}
function $686b22f01240f09f$export$db03e73b10edbc92(baseSegments, colors) {
    return baseSegments.map((segment)=>({
            ...segment,
            color: colors[Math.floor(Math.random() * colors.length)]
        }));
}
function $686b22f01240f09f$export$dabb83e0f4c29b79(segments, scale) {
    return segments.map((segment)=>({
            ...segment,
            start: (0, $cbsax.V)(segment.start.x * scale, segment.start.y * scale),
            end: (0, $cbsax.V)(segment.end.x * scale, segment.end.y * scale)
        }));
}
function $686b22f01240f09f$export$131a897d1ea6bcc(segments, offset) {
    return segments.map((segment)=>({
            ...segment,
            start: (0, $cbsax.V)(segment.start.x + offset.x, segment.start.y + offset.y),
            end: (0, $cbsax.V)(segment.end.x + offset.x, segment.end.y + offset.y)
        }));
}


function $39e6ece9400a3f87$export$18df16d8331ad734(entity) {
    return entity != null && typeof entity === "object" && typeof entity.apply === "function";
}
class $39e6ece9400a3f87$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    /**
   * Create a new line segment renderer
   * @param segments Array of line segments to render
   * @param layerName Which rendering layer to place the segments in
   */ constructor(segments = [], layerName = "main"){
        super(), this.pausable = false, this.segments = [], this.lastRenderedSegmentHash = "";
        this.segments = [
            ...segments
        ]; // Copy to avoid mutation
        this.sprite = (0, $c4Qw3.createGraphics)(layerName);
    }
    /**
   * Create a LineSegmentRenderer from a polygon
   * @param points Polygon vertices
   * @param color Color for all segments
   * @param thickness Thickness for all segments
   * @param layerName Which rendering layer to place the segments in
   */ static fromPolygon(points, color, thickness, layerName = "main") {
        const segments = (0, $686b22f01240f09f$export$34e53d4e8f1e555c)(points, color, thickness);
        return new $39e6ece9400a3f87$export$2e2bcd8739ae039(segments, layerName);
    }
    /**
   * Create a LineSegmentRenderer from line segments
   * @param segments Array of line segments
   * @param layerName Which rendering layer to place the segments in
   */ static fromSegments(segments, layerName = "main") {
        return new $39e6ece9400a3f87$export$2e2bcd8739ae039(segments, layerName);
    }
    /**
   * Add a visual filter to this renderer as a child entity
   * The filter will be automatically applied during rendering
   */ addFilter(filter) {
        return this.addChild(filter);
    }
    /**
   * Update the segments to render
   */ setSegments(segments) {
        this.segments = [
            ...segments
        ];
    }
    /**
   * Get the current segments (before filter effects)
   */ getSegments() {
        return [
            ...this.segments
        ];
    }
    /**
   * Set the position of the renderer
   */ setPosition([x, y]) {
        if (this.sprite) this.sprite.position.set(x, y);
    }
    /**
   * Set the rotation of the renderer
   * @param angle Rotation angle in radians
   */ setRotation(angle) {
        if (this.sprite) this.sprite.rotation = angle;
    }
    /**
   * Get the current position of the renderer
   */ getPosition() {
        if (this.sprite) return (0, $cbsax.V)(this.sprite.position.x, this.sprite.position.y);
        return (0, $cbsax.V)(0, 0);
    }
    /**
   * Get the current rotation of the renderer
   */ getRotation() {
        return this.sprite?.rotation || 0;
    }
    /**
   * Set the alpha (transparency) of the renderer
   * @param alpha Alpha value (0 = transparent, 1 = opaque)
   */ setAlpha(alpha) {
        if (this.sprite) this.sprite.alpha = alpha;
    }
    /**
   * Get the current alpha of the renderer
   */ getAlpha() {
        return this.sprite?.alpha || 1;
    }
    /**
   * Get all vector filter children
   */ getVectorFilters() {
        return this.children.filter($39e6ece9400a3f87$export$18df16d8331ad734);
    }
    /**
   * Calculate final segments after applying all filters
   */ getFilteredSegments(dt) {
        let segments = [
            ...this.segments
        ];
        const context = {
            deltaTime: dt,
            totalTime: this.game?.elapsedUnpausedTime || 0,
            entityPosition: (0, $cbsax.V)(this.getPosition())
        };
        const filters = this.getVectorFilters();
        for (const filter of filters)segments = filter.apply(segments, context);
        return segments;
    }
    onRender(dt) {
        // Calculate final segments
        const segments = this.getFilteredSegments(dt);
        // Check if segments have changed to avoid unnecessary clear() calls
        const segmentHash = JSON.stringify(segments);
        if (segmentHash !== this.lastRenderedSegmentHash) {
            this.sprite.clear();
            for (const segment of segments)// Special case: if start and end are the same point, render as a circle
            if (segment.start.x === segment.end.x && segment.start.y === segment.end.y) this.sprite.circle(segment.start.x, segment.start.y, segment.thickness / 2).fill({
                color: segment.color,
                alpha: segment.alpha ?? 1
            });
            else // Normal line segment
            this.sprite.moveTo(segment.start.x, segment.start.y).lineTo(segment.end.x, segment.end.y).stroke({
                color: segment.color,
                width: segment.thickness,
                cap: "round",
                join: "round",
                alpha: segment.alpha ?? 1
            });
            this.lastRenderedSegmentHash = segmentHash;
        }
    }
}



const $a394de4d7d32006c$var$FONT_HEIGHT = 7;
const $a394de4d7d32006c$var$FONT_SPACING = 1;
const $a394de4d7d32006c$var$createCharacterMap = ()=>{
    const map = new Map();
    // A
    map.set("A", {
        segments: [
            {
                start: [
                    0,
                    7
                ],
                end: [
                    0,
                    2
                ]
            },
            {
                start: [
                    0,
                    2
                ],
                end: [
                    2,
                    0
                ]
            },
            {
                start: [
                    2,
                    0
                ],
                end: [
                    4,
                    2
                ]
            },
            {
                start: [
                    4,
                    2
                ],
                end: [
                    4,
                    7
                ]
            },
            {
                start: [
                    0,
                    4
                ],
                end: [
                    4,
                    4
                ]
            }
        ],
        width: 5
    });
    // B
    map.set("B", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    2
                ]
            },
            {
                start: [
                    4,
                    2
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    0,
                    3
                ]
            },
            {
                start: [
                    0,
                    3
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    4,
                    4
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    0,
                    7
                ]
            }
        ],
        width: 5
    });
    // C
    map.set("C", {
        segments: [
            {
                start: [
                    4,
                    1
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    0
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    4,
                    6
                ]
            }
        ],
        width: 5
    });
    // D
    map.set("D", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    0,
                    7
                ]
            }
        ],
        width: 5
    });
    // E
    map.set("E", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    0,
                    3
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    0,
                    7
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // F
    map.set("F", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    0,
                    3
                ],
                end: [
                    3,
                    3
                ]
            }
        ],
        width: 5
    });
    // G
    map.set("G", {
        segments: [
            {
                start: [
                    4,
                    1
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    0
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    4,
                    4
                ],
                end: [
                    2,
                    4
                ]
            }
        ],
        width: 5
    });
    // H
    map.set("H", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    4,
                    0
                ],
                end: [
                    4,
                    7
                ]
            },
            {
                start: [
                    0,
                    3
                ],
                end: [
                    4,
                    3
                ]
            }
        ],
        width: 5
    });
    // I
    map.set("I", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    2,
                    0
                ],
                end: [
                    2,
                    7
                ]
            },
            {
                start: [
                    0,
                    7
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // J
    map.set("J", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    3,
                    6
                ]
            },
            {
                start: [
                    3,
                    6
                ],
                end: [
                    2,
                    7
                ]
            },
            {
                start: [
                    2,
                    7
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    0,
                    6
                ]
            }
        ],
        width: 5
    });
    // K
    map.set("K", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    4,
                    0
                ],
                end: [
                    0,
                    3
                ]
            },
            {
                start: [
                    0,
                    3
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // L
    map.set("L", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    7
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // M
    map.set("M", {
        segments: [
            {
                start: [
                    0,
                    7
                ],
                end: [
                    0,
                    0
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    2,
                    2
                ]
            },
            {
                start: [
                    2,
                    2
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    4,
                    0
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // N
    map.set("N", {
        segments: [
            {
                start: [
                    0,
                    7
                ],
                end: [
                    0,
                    0
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    7
                ]
            },
            {
                start: [
                    4,
                    7
                ],
                end: [
                    4,
                    0
                ]
            }
        ],
        width: 5
    });
    // O
    map.set("O", {
        segments: [
            {
                start: [
                    1,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    0
                ]
            }
        ],
        width: 5
    });
    // P
    map.set("P", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    2
                ]
            },
            {
                start: [
                    4,
                    2
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    0,
                    3
                ]
            }
        ],
        width: 5
    });
    // Q
    map.set("Q", {
        segments: [
            {
                start: [
                    1,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    3,
                    5
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // R
    map.set("R", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    2
                ]
            },
            {
                start: [
                    4,
                    2
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    0,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // S
    map.set("S", {
        segments: [
            {
                start: [
                    4,
                    1
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    0
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    0,
                    2
                ]
            },
            {
                start: [
                    0,
                    2
                ],
                end: [
                    1,
                    3
                ]
            },
            {
                start: [
                    1,
                    3
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    4,
                    4
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    0,
                    6
                ]
            }
        ],
        width: 5
    });
    // T
    map.set("T", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    2,
                    0
                ],
                end: [
                    2,
                    7
                ]
            }
        ],
        width: 5
    });
    // U
    map.set("U", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    4,
                    0
                ]
            }
        ],
        width: 5
    });
    // V
    map.set("V", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    2,
                    7
                ]
            },
            {
                start: [
                    2,
                    7
                ],
                end: [
                    4,
                    0
                ]
            }
        ],
        width: 5
    });
    // W
    map.set("W", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    2,
                    5
                ]
            },
            {
                start: [
                    2,
                    5
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    4,
                    0
                ]
            }
        ],
        width: 5
    });
    // X
    map.set("X", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    7
                ]
            },
            {
                start: [
                    4,
                    0
                ],
                end: [
                    0,
                    7
                ]
            }
        ],
        width: 5
    });
    // Y
    map.set("Y", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    2,
                    3
                ]
            },
            {
                start: [
                    4,
                    0
                ],
                end: [
                    2,
                    3
                ]
            },
            {
                start: [
                    2,
                    3
                ],
                end: [
                    2,
                    7
                ]
            }
        ],
        width: 5
    });
    // Z
    map.set("Z", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    4,
                    0
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    7
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // 0
    map.set("0", {
        segments: [
            {
                start: [
                    1,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    1
                ],
                end: [
                    3,
                    6
                ]
            }
        ],
        width: 5
    });
    // 1
    map.set("1", {
        segments: [
            {
                start: [
                    1,
                    1
                ],
                end: [
                    2,
                    0
                ]
            },
            {
                start: [
                    2,
                    0
                ],
                end: [
                    2,
                    7
                ]
            },
            {
                start: [
                    0,
                    7
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // 2
    map.set("2", {
        segments: [
            {
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    3
                ]
            },
            {
                start: [
                    4,
                    3
                ],
                end: [
                    0,
                    7
                ]
            },
            {
                start: [
                    0,
                    7
                ],
                end: [
                    4,
                    7
                ]
            }
        ],
        width: 5
    });
    // 3
    map.set("3", {
        segments: [
            {
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    2
                ]
            },
            {
                start: [
                    4,
                    2
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    2,
                    3
                ]
            },
            {
                start: [
                    2,
                    3
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    4,
                    4
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    0,
                    6
                ]
            }
        ],
        width: 5
    });
    // 4
    map.set("4", {
        segments: [
            {
                start: [
                    3,
                    0
                ],
                end: [
                    0,
                    4
                ]
            },
            {
                start: [
                    0,
                    4
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    3,
                    7
                ]
            }
        ],
        width: 5
    });
    // 5
    map.set("5", {
        segments: [
            {
                start: [
                    4,
                    0
                ],
                end: [
                    0,
                    0
                ]
            },
            {
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    3
                ]
            },
            {
                start: [
                    0,
                    3
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    4,
                    4
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    0,
                    6
                ]
            }
        ],
        width: 5
    });
    // 6
    map.set("6", {
        segments: [
            {
                start: [
                    3,
                    0
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    0
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    4,
                    4
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    0,
                    3
                ]
            }
        ],
        width: 5
    });
    // 7
    map.set("7", {
        segments: [
            {
                start: [
                    0,
                    0
                ],
                end: [
                    4,
                    0
                ]
            },
            {
                start: [
                    4,
                    0
                ],
                end: [
                    2,
                    7
                ]
            }
        ],
        width: 5
    });
    // 8
    map.set("8", {
        segments: [
            {
                start: [
                    1,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    2
                ]
            },
            {
                start: [
                    4,
                    2
                ],
                end: [
                    3,
                    3
                ]
            },
            {
                start: [
                    3,
                    3
                ],
                end: [
                    1,
                    3
                ]
            },
            {
                start: [
                    1,
                    3
                ],
                end: [
                    0,
                    2
                ]
            },
            {
                start: [
                    0,
                    2
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    3
                ],
                end: [
                    0,
                    4
                ]
            },
            {
                start: [
                    0,
                    4
                ],
                end: [
                    0,
                    6
                ]
            },
            {
                start: [
                    0,
                    6
                ],
                end: [
                    1,
                    7
                ]
            },
            {
                start: [
                    1,
                    7
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    4,
                    4
                ]
            },
            {
                start: [
                    4,
                    4
                ],
                end: [
                    3,
                    3
                ]
            }
        ],
        width: 5
    });
    // 9
    map.set("9", {
        segments: [
            {
                start: [
                    4,
                    3
                ],
                end: [
                    1,
                    3
                ]
            },
            {
                start: [
                    1,
                    3
                ],
                end: [
                    0,
                    2
                ]
            },
            {
                start: [
                    0,
                    2
                ],
                end: [
                    0,
                    1
                ]
            },
            {
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                start: [
                    1,
                    0
                ],
                end: [
                    3,
                    0
                ]
            },
            {
                start: [
                    3,
                    0
                ],
                end: [
                    4,
                    1
                ]
            },
            {
                start: [
                    4,
                    1
                ],
                end: [
                    4,
                    6
                ]
            },
            {
                start: [
                    4,
                    6
                ],
                end: [
                    3,
                    7
                ]
            },
            {
                start: [
                    3,
                    7
                ],
                end: [
                    1,
                    7
                ]
            }
        ],
        width: 5
    });
    // . (period)
    map.set(".", {
        segments: [
            {
                start: [
                    1,
                    7
                ],
                end: [
                    1,
                    7
                ]
            }
        ],
        width: 2
    });
    // , (comma)
    map.set(",", {
        segments: [
            {
                start: [
                    1,
                    6
                ],
                end: [
                    1,
                    8
                ]
            }
        ],
        width: 2
    });
    return map;
};
const $a394de4d7d32006c$var$vectorFont = {
    characters: $a394de4d7d32006c$var$createCharacterMap(),
    height: $a394de4d7d32006c$var$FONT_HEIGHT,
    spacing: $a394de4d7d32006c$var$FONT_SPACING
};
var $a394de4d7d32006c$export$2e2bcd8739ae039 = $a394de4d7d32006c$var$vectorFont;


var $b061550ace257732$export$f299601a0229bca4 = /*#__PURE__*/ function(TextAnchor) {
    TextAnchor["LEFT"] = "left";
    TextAnchor["CENTER"] = "center";
    TextAnchor["RIGHT"] = "right";
    return TextAnchor;
}({});
var $b061550ace257732$export$9d7381bdbf04641c = /*#__PURE__*/ function(VerticalAnchor) {
    VerticalAnchor["TOP"] = "top";
    VerticalAnchor["CENTER"] = "center";
    VerticalAnchor["BOTTOM"] = "bottom";
    return VerticalAnchor;
}({});
class $b061550ace257732$export$8afd1fcb6a3a9ae4 extends (0, $2oYNi.default) {
    constructor(options){
        super(), this.pausable = false // Text should render even when game is paused
        , this.needsRedraw = true;
        this._text = options.text;
        this._scale = options.scale ?? 1;
        this._color = options.color ?? 0xffffff;
        this._strokeWidth = options.strokeWidth ?? 1;
        this._anchor = options.anchor ?? "left";
        this._verticalAnchor = options.verticalAnchor ?? "top";
        this.font = (0, $a394de4d7d32006c$export$2e2bcd8739ae039);
        // Create renderer with initial empty segments
        this.renderer = new (0, $39e6ece9400a3f87$export$2e2bcd8739ae039)([], options.layer);
        if (options.position) this.renderer.setPosition(options.position);
    }
    get text() {
        return this._text;
    }
    set text(value) {
        if (this._text !== value) {
            this._text = value;
            this.needsRedraw = true;
        }
    }
    get scale() {
        return this._scale;
    }
    set scale(value) {
        if (this._scale !== value) {
            this._scale = value;
            this.needsRedraw = true;
        }
    }
    get color() {
        return this._color;
    }
    set color(value) {
        if (this._color !== value) {
            this._color = value;
            this.needsRedraw = true;
        }
    }
    get strokeWidth() {
        return this._strokeWidth;
    }
    set strokeWidth(value) {
        if (this._strokeWidth !== value) {
            this._strokeWidth = value;
            this.needsRedraw = true;
        }
    }
    get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        if (this._anchor !== value) {
            this._anchor = value;
            this.needsRedraw = true;
        }
    }
    get verticalAnchor() {
        return this._verticalAnchor;
    }
    set verticalAnchor(value) {
        if (this._verticalAnchor !== value) {
            this._verticalAnchor = value;
            this.needsRedraw = true;
        }
    }
    get position() {
        return this.renderer.getPosition();
    }
    set position(value) {
        this.renderer.setPosition(value);
    }
    get textSprite() {
        return this.renderer.sprite;
    }
    onAdd() {
        // Add the renderer as a child entity
        this.addChild(this.renderer);
        this.redrawText();
    }
    onRender() {
        if (this.needsRedraw) this.redrawText();
    }
    redrawText() {
        if (!this._text) {
            this.renderer.setSegments([]);
            this.needsRedraw = false;
            return;
        }
        // Calculate the total width and height of the text for anchor positioning
        const textWidth = this.calculateTextWidth();
        const textHeight = this.calculateTextHeight();
        // Determine starting X offset based on horizontal anchor
        let startXOffset = 0;
        switch(this._anchor){
            case "left":
                startXOffset = 0;
                break;
            case "center":
                startXOffset = -textWidth / 2;
                break;
            case "right":
                startXOffset = -textWidth;
                break;
        }
        // Determine Y offset based on vertical anchor
        let yOffset = 0;
        switch(this._verticalAnchor){
            case "top":
                yOffset = 0;
                break;
            case "center":
                yOffset = -textHeight / 2;
                break;
            case "bottom":
                yOffset = -textHeight;
                break;
        }
        // Collect all segments for the text
        const allSegments = [];
        let xOffset = startXOffset;
        for(let i = 0; i < this._text.length; i++){
            const char = this._text[i].toUpperCase();
            if (char === " ") {
                xOffset += 3 * this._scale;
                continue;
            }
            const character = this.font.characters.get(char);
            if (!character) {
                xOffset += 3 * this._scale;
                continue;
            }
            // Create segments for this character
            const characterSegments = (0, $686b22f01240f09f$export$36094440c00a73cf)(character.segments, this._color, this._strokeWidth, this._scale, (0, $cbsax.V)(xOffset, yOffset));
            allSegments.push(...characterSegments);
            xOffset += (character.width + this.font.spacing) * this._scale;
        }
        // Update the renderer with all segments
        this.renderer.setSegments(allSegments);
        this.needsRedraw = false;
    }
    calculateTextWidth() {
        if (!this._text) return 0;
        let width = 0;
        for(let i = 0; i < this._text.length; i++){
            const char = this._text[i].toUpperCase();
            if (char === " ") {
                width += 3 * this._scale;
                continue;
            }
            const character = this.font.characters.get(char);
            if (!character) {
                width += 3 * this._scale;
                continue;
            }
            width += (character.width + this.font.spacing) * this._scale;
        }
        return width - this.font.spacing * this._scale;
    }
    calculateTextHeight() {
        return this.font.height * this._scale;
    }
}


class $285b9fda6215663d$export$b963714923cb1ea4 extends (0, $2oYNi.default) {
    constructor(options){
        super(), this.pausable = false // Buttons should work even when game is paused
        , this.isHovered = false, this.isPressed = false, // Button dimensions
        this.width = 0, this.height = 0, this.bounds = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        this.onClickCallback = options.onClick;
        this.style = options.style ?? "primary";
        this.size = options.size ?? "medium";
        this.disabled = options.disabled ?? false;
        this.customColor = options.color;
        // Create background graphics
        this.background = new (0, $iuB9z.Graphics)();
        if (options.layer) this.background.layerName = options.layer;
        // Create text
        const sizeConfig = this.getSizeConfig();
        this.text = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: options.text,
            scale: sizeConfig.fontSize / 10,
            strokeWidth: 2,
            color: this.getStyleConfig().textColor,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: options.layer
        });
        // Position the button
        if (options.position) this.updatePosition(options.position);
        // Calculate button dimensions
        this.calculateDimensions();
    }
    getSizeConfig() {
        switch(this.size){
            case "small":
                return {
                    padding: {
                        x: (0, $hA6FJ.Spacing).MD,
                        y: (0, $hA6FJ.Spacing).SM
                    },
                    fontSize: (0, $hA6FJ.Typography).FONT_SIZE.UI_TEXT,
                    minWidth: 80
                };
            case "medium":
                return {
                    padding: {
                        x: (0, $hA6FJ.Spacing).LG,
                        y: (0, $hA6FJ.Spacing).MD
                    },
                    fontSize: (0, $hA6FJ.Typography).FONT_SIZE.BUTTON_TEXT,
                    minWidth: 120
                };
            case "large":
                return {
                    padding: {
                        x: (0, $hA6FJ.Spacing).XL,
                        y: (0, $hA6FJ.Spacing).LG
                    },
                    fontSize: (0, $hA6FJ.Typography).FONT_SIZE.BUTTON_TEXT,
                    minWidth: 160
                };
        }
    }
    getStyleConfig() {
        // Use custom color if provided
        if (this.customColor !== undefined) return {
            borderColor: this.customColor,
            textColor: this.customColor,
            hoverFillColor: this.customColor,
            hoverBorderColor: this.customColor,
            pressedFillColor: this.customColor
        };
        switch(this.style){
            case "primary":
                return {
                    borderColor: (0, $hA6FJ.Colors).CYAN,
                    textColor: (0, $hA6FJ.Colors).CYAN,
                    hoverFillColor: (0, $hA6FJ.Colors).CYAN,
                    hoverBorderColor: (0, $hA6FJ.Colors).CYAN,
                    pressedFillColor: (0, $hA6FJ.Colors).CYAN
                };
            case "secondary":
                return {
                    borderColor: (0, $hA6FJ.Colors).CYAN,
                    textColor: (0, $hA6FJ.Colors).CYAN,
                    hoverFillColor: (0, $hA6FJ.Colors).CYAN,
                    hoverBorderColor: (0, $hA6FJ.Colors).CYAN,
                    pressedFillColor: (0, $hA6FJ.Colors).CYAN
                };
            case "neutral":
                return {
                    borderColor: (0, $hA6FJ.Colors).WHITE,
                    textColor: (0, $hA6FJ.Colors).WHITE,
                    hoverFillColor: (0, $hA6FJ.Colors).WHITE,
                    hoverBorderColor: (0, $hA6FJ.Colors).WHITE,
                    pressedFillColor: (0, $hA6FJ.Colors).WHITE
                };
        }
    }
    calculateDimensions() {
        const sizeConfig = this.getSizeConfig();
        const textWidth = this.text.calculateTextWidth();
        this.width = Math.max(sizeConfig.minWidth, textWidth + sizeConfig.padding.x * 2);
        this.height = this.text.calculateTextHeight() + sizeConfig.padding.y * 2;
        // Update bounds for hit testing
        this.updateBounds();
    }
    updateBounds() {
        // Only update bounds if we have a sprite (after onAdd is called)
        if (this.sprite) {
            const position = this.getPosition();
            this.bounds = {
                x: position.x - this.width / 2,
                y: position.y - this.height / 2,
                width: this.width,
                height: this.height
            };
        }
    }
    updatePosition(position) {
        this.background.position.set(position.x, position.y);
        this.text.position = position;
        this.updateBounds();
    }
    isPointInside(x, y) {
        return x >= this.bounds.x && x <= this.bounds.x + this.bounds.width && y >= this.bounds.y && y <= this.bounds.y + this.bounds.height;
    }
    redrawButton() {
        this.background.clear();
        if (this.disabled) this.drawDisabledButton();
        else if (this.isPressed) this.drawPressedButton();
        else if (this.isHovered) this.drawHoveredButton();
        else this.drawNormalButton();
    }
    drawNormalButton() {
        const styleConfig = this.getStyleConfig();
        // Draw border
        this.background.rect(-this.width / 2, -this.height / 2, this.width, this.height);
        this.background.stroke({
            color: styleConfig.borderColor,
            width: 2
        });
        // Reset text stroke to normal (thicker than default)
        this.text.strokeWidth = 2;
    }
    drawHoveredButton() {
        const styleConfig = this.getStyleConfig();
        // Draw thicker border for hover effect
        this.background.rect(-this.width / 2, -this.height / 2, this.width, this.height);
        this.background.stroke({
            color: styleConfig.hoverBorderColor,
            width: 4
        });
        // Add outer glow effect with even thicker stroke
        this.background.rect(-this.width / 2, -this.height / 2, this.width, this.height);
        this.background.stroke({
            color: styleConfig.hoverBorderColor,
            width: 6,
            alpha: 0.3
        });
        // Make the text even thicker on hover
        this.text.strokeWidth = 3;
    }
    drawPressedButton() {
        const styleConfig = this.getStyleConfig();
        // Draw thicker border for pressed effect
        this.background.rect(-this.width / 2, -this.height / 2, this.width, this.height);
        this.background.stroke({
            color: styleConfig.borderColor,
            width: 3
        });
        // Make text thicker when pressed
        this.text.strokeWidth = 3;
    }
    drawDisabledButton() {
        const styleConfig = this.getStyleConfig();
        // Draw border with reduced opacity
        this.background.rect(-this.width / 2, -this.height / 2, this.width, this.height);
        this.background.stroke({
            color: styleConfig.borderColor,
            width: 2,
            alpha: 0.3
        });
        // Reset text stroke to normal for disabled state
        this.text.strokeWidth = 2;
    }
    onAdd() {
        this.sprite = this.background;
        this.addChild(this.text);
        this.redrawButton();
    }
    onRender() {
        // Check if mouse position has changed and update hover state
        if (this.game && !this.disabled) {
            const mousePos = this.game.io.mousePosition;
            const wasHovered = this.isHovered;
            this.isHovered = this.isPointInside(mousePos.x, mousePos.y);
            if (wasHovered !== this.isHovered) this.redrawButton();
        }
    }
    onMouseDown() {
        if (this.disabled) return;
        if (this.game) {
            const mousePos = this.game.io.mousePosition;
            if (this.isPointInside(mousePos.x, mousePos.y)) {
                this.isPressed = true;
                this.redrawButton();
            }
        }
    }
    onMouseUp() {
        if (this.disabled) return;
        if (this.isPressed) {
            this.isPressed = false;
            this.redrawButton();
        }
    }
    onClick() {
        if (this.disabled) return;
        if (this.game) {
            const mousePos = this.game.io.mousePosition;
            if (this.isPointInside(mousePos.x, mousePos.y)) this.onClickCallback?.();
        }
    }
    // Public methods for updating button properties
    setText(text) {
        this.text.text = text;
        this.calculateDimensions();
        this.redrawButton();
    }
    setDisabled(disabled) {
        this.disabled = disabled;
        this.isHovered = false;
        this.isPressed = false;
        // Update text color
        const styleConfig = this.getStyleConfig();
        this.text.color = disabled ? (0, $hA6FJ.Colors).CYAN : styleConfig.textColor;
        this.redrawButton();
    }
    setStyle(style) {
        this.style = style;
        const styleConfig = this.getStyleConfig();
        this.text.color = this.disabled ? (0, $hA6FJ.Colors).CYAN : styleConfig.textColor;
        this.redrawButton();
    }
    setPosition(position) {
        this.updatePosition(position);
    }
    getSize() {
        return {
            width: this.width,
            height: this.height
        };
    }
}




var $e2Ri5 = parcelRequire("e2Ri5");

var $2oYNi = parcelRequire("2oYNi");

var $jd0t2 = parcelRequire("jd0t2");

var $hA6FJ = parcelRequire("hA6FJ");

var $c4Qw3 = parcelRequire("c4Qw3");

var $jd0t2 = parcelRequire("jd0t2");
// Real Earth land/water bitmap data generated from Natural Earth GeoJSON
// Format: 1 = land, 0 = water
// Size: 256x256 pixels representing Earth surface at high resolution
// Top rows = North pole, bottom rows = South pole
// Left columns = -180°, right columns = +180°
// Statistics: 21734 land pixels out of 65536 total (33.2% land)
const $adbb4dc3efd14bfb$export$682b5f7ea676b4e4 = 256;
const $adbb4dc3efd14bfb$export$9fe90f8219421d36 = [
    // Antarctic - mostly ice/land
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Far south - Chile, South Africa tip, Tasmania
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Southern temperate - Argentina, South Africa, Australia
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Southern tropical - Southern Africa, Australia, Southern Brazil
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
    ],
    // Equatorial - Amazon, Congo, Indonesia
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Tropical - Central Africa, South America, Indonesia
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Subtropical - North Africa, Arabia, India, Southeast Asia
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Mid-latitudes - Mediterranean, Middle East, Central Asia, Japan
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Northern temperate - US, Europe, China, Russia
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Mid-northern latitudes - Canada, Alaska, Scandinavia, Siberia
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Northern latitudes - Greenland, northern Canada, Siberia
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ],
    [
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    // Arctic Ocean - mostly water
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]
];



var $2oYNi = parcelRequire("2oYNi");
class $03951e13c89b8446$export$f3a7dc1d15b0c59c extends (0, $2oYNi.default) {
    /**
   * Gets the current GameFlowManager instance, if one exists.
   */ getGameFlowManager() {
        const gameFlowManager = this.game?.entities.getById("gameFlowManager");
        if (!gameFlowManager) return undefined;
        return gameFlowManager;
    }
}
class $03951e13c89b8446$export$fda5971927322b04 extends $03951e13c89b8446$export$f3a7dc1d15b0c59c {
    /**
   * Gets the current level instance, if one exists.
   * @returns The current level or undefined if no level is active
   */ getCurrentLevel() {
        const level = this.game?.entities.getById("currentLevel");
        if (!level) return undefined;
        return level;
    }
}


const $4957dda0a15a616e$export$938789a6994ad1a = 30;
const $4957dda0a15a616e$var$LINE_SPACING = 3; // distance between scan lines
const $4957dda0a15a616e$var$LINE_THICKNESS = 1.5;
const $4957dda0a15a616e$var$ROTATION_SPEED = 0.01; // radians per second
const $4957dda0a15a616e$var$TRANSITION_GAP = 0; // gap size at land/water boundaries
const $4957dda0a15a616e$var$MIN_SAMPLES = 128;
const $4957dda0a15a616e$var$SAMPLES_PER_PX = 8;
const $4957dda0a15a616e$var$RENDER_INTERVAL = 1 / 6; // render every 1/6 second (~20 frames at 120 FPS) to reduce memory pressure
class $4957dda0a15a616e$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super(), this.rotationAngle = 0;
        this.tags = [
            "earth"
        ];
        // Create graphics for Earth
        this.sprite = (0, $c4Qw3.createGraphics)("background"); // Use background layer so it appears behind everything
        this.sprite.cacheAsTexture(false);
        this.sprite.position.set(0, 0); // Center at origin
    }
    async onAdd() {
        // Render immediately when added
        this.renderScanLines();
        // Start the render loop
        this.scheduleNextRender();
    }
    async scheduleNextRender() {
        if (this.isDestroyed()) return;
        await this.waitRender($4957dda0a15a616e$var$RENDER_INTERVAL);
        this.renderScanLines();
        this.scheduleNextRender(); // Schedule the next render
    }
    onTick(dt) {
        // Update rotation angle
        this.rotationAngle += $4957dda0a15a616e$var$ROTATION_SPEED * dt;
    }
    renderScanLines() {
        this.sprite.clear();
        // Calculate how many lines we need based on radius
        const maxY = Math.ceil($4957dda0a15a616e$export$938789a6994ad1a / $4957dda0a15a616e$var$LINE_SPACING) * $4957dda0a15a616e$var$LINE_SPACING;
        // Draw lines at fixed spacing intervals
        for(let y = -maxY; y <= maxY; y += $4957dda0a15a616e$var$LINE_SPACING){
            const distanceFromCenter = Math.abs(y);
            // Only draw lines that are within the circle
            // if (distanceFromCenter <= EARTH_RADIUS) {
            // Calculate line half-width using circle equation: x = sqrt(r² - y²)
            const radiusSquared = $4957dda0a15a616e$export$938789a6994ad1a * $4957dda0a15a616e$export$938789a6994ad1a;
            const ySquared = distanceFromCenter * distanceFromCenter;
            // Ensure we don't get negative values due to floating point precision
            if (radiusSquared >= ySquared) {
                const halfWidth = Math.sqrt(radiusSquared - ySquared);
                this.drawScanLine(y, halfWidth);
            }
        // }
        }
    }
    drawScanLine(y, halfWidth) {
        // Sample the entire scan line at high resolution
        const samples = this.sampleScanLine(y, halfWidth);
        // Find runs of consecutive land/water
        const runs = this.findRuns(samples, halfWidth);
        // Draw each run as a single continuous line
        for (const run of runs){
            const color = run.isLand ? (0, $hA6FJ.Colors).GREEN : (0, $hA6FJ.Colors).BLUE;
            this.sprite.moveTo(run.startX, y).lineTo(run.endX, y).stroke({
                color: color,
                width: $4957dda0a15a616e$var$LINE_THICKNESS,
                cap: "round"
            });
        }
    }
    sampleScanLine(y, halfWidth) {
        // Sample at high resolution across the entire scan line
        const numSamples = Math.max($4957dda0a15a616e$var$MIN_SAMPLES, Math.floor(halfWidth * $4957dda0a15a616e$var$SAMPLES_PER_PX));
        const samples = [];
        for(let i = 0; i < numSamples; i++){
            const x = -halfWidth + i / (numSamples - 1) * (halfWidth * 2);
            samples.push(this.sampleEarth(x, y));
        }
        return samples;
    }
    findRuns(samples, halfWidth) {
        const runs = [];
        if (samples.length === 0) return runs;
        let currentType = samples[0];
        let runStart = 0;
        for(let i = 1; i < samples.length; i++)if (samples[i] !== currentType) {
            // End of current run, start of new run
            let startX = -halfWidth + runStart / (samples.length - 1) * (halfWidth * 2);
            let endX = -halfWidth + (i - 1) / (samples.length - 1) * (halfWidth * 2);
            // Add gap at transitions - shorten the run on both ends
            const runLength = endX - startX;
            if (runLength > $4957dda0a15a616e$var$TRANSITION_GAP * 2) {
                // Only add gaps if the run is long enough
                if (runStart > 0) // Not the first run, add gap at start
                startX += $4957dda0a15a616e$var$TRANSITION_GAP / 2;
                if (i < samples.length) // Not the last run, add gap at end
                endX -= $4957dda0a15a616e$var$TRANSITION_GAP / 2;
            }
            runs.push({
                startX: startX,
                endX: endX,
                isLand: currentType
            });
            currentType = samples[i];
            runStart = i;
        }
        // Handle the final run
        let startX = -halfWidth + runStart / (samples.length - 1) * (halfWidth * 2);
        let endX = halfWidth;
        // Add gap at start if this isn't the only run
        if (runStart > 0) startX += $4957dda0a15a616e$var$TRANSITION_GAP / 2;
        runs.push({
            startX: startX,
            endX: endX,
            isLand: currentType
        });
        return runs;
    }
    sampleEarth(x, y) {
        // Convert y-coordinate to latitude (flipped so north pole is at top)
        const normalizedY = y / $4957dda0a15a616e$export$938789a6994ad1a; // -1 to 1
        const bitmapY = Math.floor((1 - normalizedY) / 2 * (0, $adbb4dc3efd14bfb$export$682b5f7ea676b4e4));
        // Convert x-coordinate to longitude with horizontal rotation (globe spinning)
        const normalizedX = x / $4957dda0a15a616e$export$938789a6994ad1a / 2; // -1 to 1
        // Apply horizontal rotation as longitude shift
        // Each full rotation (2π) should scroll through the entire longitude range
        const longitudeShift = this.rotationAngle / (Math.PI * 2) * (0, $adbb4dc3efd14bfb$export$682b5f7ea676b4e4);
        const bitmapX = Math.floor((normalizedX + 1) / 2 * (0, $adbb4dc3efd14bfb$export$682b5f7ea676b4e4) + longitudeShift);
        // Wrap longitude coordinate to create seamless horizontal scrolling
        const wrappedX = (0, $jd0t2.mod)(bitmapX, (0, $adbb4dc3efd14bfb$export$682b5f7ea676b4e4));
        // Clamp latitude to valid bitmap coordinates
        const clampedY = (0, $jd0t2.clamp)(bitmapY, 0, (0, $adbb4dc3efd14bfb$export$682b5f7ea676b4e4) - 1);
        // Sample the bitmap (1 = land, 0 = water)
        return (0, $adbb4dc3efd14bfb$export$9fe90f8219421d36)[clampedY][wrappedX] === 1;
    }
}



var $jd0t2 = parcelRequire("jd0t2");

var $2JTRA = parcelRequire("2JTRA");

var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");

var $biKyI = parcelRequire("biKyI");
// Assign things to groups so that we can easily enable/disable collisions between different groups
/**
 * # Bitfield Collision System
 *
 * This module provides utilities for managing physics collision groups using bitfield operations.
 * Each collision group is represented as a power of 2 (single bit), allowing efficient collision
 * filtering using bitwise operations.
 *
 * ## How It Works:
 * - Each group gets a unique bit position: Group1 = 1, Group2 = 2, Group3 = 4, Group4 = 8...
 * - Collision masks are created by combining groups with bitwise OR: `Group1 | Group3 = 5`
 * - p2.js uses these masks to determine if two bodies should collide
 *
 * ## 32-Group Limitation:
 * JavaScript bitwise operations work on 32-bit integers, limiting us to 32 collision groups.
 * In practice, this is rarely a problem as most games need far fewer distinct collision types.
 *
 * ## Usage Examples:
 * ```typescript
 * // Define collision groups for your game
 * const CollisionGroups = makeCollisionGroups([
 *   "Player", "Enemy", "Projectile", "Wall", "Pickup"
 * ]);
 *
 * // Set up collision filtering
 * playerShape.collisionGroup = CollisionGroups.Player;
 * playerShape.collisionMask = CollisionGroups.Enemy | CollisionGroups.Wall | CollisionGroups.Pickup;
 *
 * wallShape.collisionGroup = CollisionGroups.Wall;
 * wallShape.collisionMask = CollisionGroups.All; // Collides with everything
 *
 * projectileShape.collisionGroup = CollisionGroups.Projectile;
 * projectileShape.collisionMask = CollisionGroups.Enemy | CollisionGroups.Wall; // Not players or pickups
 * ```
 *
 * ## Common Patterns:
 * - **Projectile Filtering**: Projectiles collide with enemies/walls but not the player who fired them
 * - **Layer Separation**: UI elements, background, foreground physics on different groups
 * - **Trigger Zones**: Sensors that detect specific entity types without blocking movement
 * - **Team-Based**: Different teams or factions that don't collide with each other
 */ let $e4ad2ad2bb1b9d9c$var$_collisionGroupIndex = 0;
function $e4ad2ad2bb1b9d9c$export$bb3f75bf81e4a625() {
    if ($e4ad2ad2bb1b9d9c$var$_collisionGroupIndex >= 32) throw new Error("Cannot create more than 32 collision groups due to JavaScript bitwise limitations");
    return 1 << $e4ad2ad2bb1b9d9c$var$_collisionGroupIndex++;
}
function $e4ad2ad2bb1b9d9c$export$91ad3a79f3a9cd95(groupNames) {
    const groups = {
        None: 0
    };
    for (const name of groupNames)groups[name] = $e4ad2ad2bb1b9d9c$export$bb3f75bf81e4a625();
    groups.All = Object.values(groups).filter((value)=>value !== 0).reduce((acc, group)=>acc | group, 0);
    return groups;
}



var $2JTRA = parcelRequire("2JTRA");
const $5cb9574f3b2dfe63$export$93c35edfe1e68454 = (0, $e4ad2ad2bb1b9d9c$export$91ad3a79f3a9cd95)([
    "Turret",
    "Enemy",
    "Bullet",
    "Bomb",
    "Explosion"
]);
const $5cb9574f3b2dfe63$var$groupNames = (0, $2JTRA.objectKeys)($5cb9574f3b2dfe63$export$93c35edfe1e68454).filter((name)=>name !== "All");
function $5cb9574f3b2dfe63$export$43a218787169d5f9(group) {
    if (group === $5cb9574f3b2dfe63$export$93c35edfe1e68454.All) return [
        "All"
    ];
    return $5cb9574f3b2dfe63$var$groupNames.filter((name)=>group & $5cb9574f3b2dfe63$export$93c35edfe1e68454[name]);
}
function $5cb9574f3b2dfe63$export$d41d774dcb8e51f0(...groups) {
    return groups.reduce((acc, group)=>acc | $5cb9574f3b2dfe63$export$93c35edfe1e68454[group], $5cb9574f3b2dfe63$export$93c35edfe1e68454.None);
}



var $hA6FJ = parcelRequire("hA6FJ");

var $jd0t2 = parcelRequire("jd0t2");

var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");

var $iuB9z = parcelRequire("iuB9z");

var $hA6FJ = parcelRequire("hA6FJ");

var $3of0i = parcelRequire("3of0i");

var $jd0t2 = parcelRequire("jd0t2");

var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");


const $7c2e27e1fc77ebd1$var$DEFAULT_PARTICLE_COUNT = 100;
const $7c2e27e1fc77ebd1$var$DEFAULT_EXPLOSION_SPEED = 150.0;
const $7c2e27e1fc77ebd1$var$PARTICLE_SIZE = 0.35;
const $7c2e27e1fc77ebd1$var$GRAVITY_STRENGTH = 1000;
const $7c2e27e1fc77ebd1$var$EARTH_RADIUS_OFFSET = 5; // Just make gravity a little more friendly
const $7c2e27e1fc77ebd1$var$DAMPING_FACTOR = 0.95; // How much velocity is retained each second
const $7c2e27e1fc77ebd1$var$MIN_PARTICLE_LIFETIME = 2.0; // seconds
const $7c2e27e1fc77ebd1$var$MAX_PARTICLE_LIFETIME = 30.0; // seconds
class $7c2e27e1fc77ebd1$export$79ac126fea2e1154 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor({ position: position, particleCount: particleCount = $7c2e27e1fc77ebd1$var$DEFAULT_PARTICLE_COUNT, explosionSpeed: explosionSpeed = $7c2e27e1fc77ebd1$var$DEFAULT_EXPLOSION_SPEED, color: color = (0, $hA6FJ.Colors).ORANGE, colors: colors, polygonVertices: polygonVertices, direction: direction }){
        super(), this.particles = [];
        for(let i = 0; i < particleCount; i++){
            let spawnPosition;
            // Choose spawn position based on polygon vertices if provided
            if (polygonVertices && polygonVertices.length >= 2) {
                const [vertex1, vertex2] = (0, $azFtk.chooseN)(2, polygonVertices);
                spawnPosition = (0, $jd0t2.lerpV2d)(vertex1, vertex2, (0, $azFtk.rUniform)(0, 1));
            } else // Fallback to center explosion (original behavior)
            spawnPosition = (0, $cbsax.V)(0, 0);
            let angle;
            if (direction) {
                // Bias particles toward the specified direction
                const baseAngle = direction.angle;
                const spreadAngle = Math.PI / 3; // 60 degree spread
                angle = baseAngle + (0, $azFtk.rUniform)(-spreadAngle, spreadAngle);
            } else // Random direction (original behavior)
            angle = (0, $azFtk.rDirection)();
            const speed = (0, $azFtk.rUniform)(0, explosionSpeed);
            const velocity = (0, $jd0t2.polarToVec)(angle, speed);
            const lifetime = (0, $azFtk.rUniform)($7c2e27e1fc77ebd1$var$MIN_PARTICLE_LIFETIME, $7c2e27e1fc77ebd1$var$MAX_PARTICLE_LIFETIME);
            // Choose color from colors array if provided, otherwise use single color
            const selectedColor = colors && colors.length > 0 ? (0, $azFtk.choose)(...colors) : color;
            // IMPORTANT: ParticleContainer seems to use BGR color format instead of RGB
            // So we need to swap red and blue channels for all colors
            const { r: r, g: g, b: b } = (0, $3of0i.hexToRgb)(selectedColor);
            const bgrColor = (0, $3of0i.rgbToHex)({
                r: b,
                g: g,
                b: r
            });
            // Create Pixi particle for rendering
            const pixiParticle = new (0, $iuB9z.Particle)({
                texture: (0, $iuB9z.Texture).WHITE,
                x: spawnPosition.x,
                y: spawnPosition.y,
                scaleX: $7c2e27e1fc77ebd1$var$PARTICLE_SIZE,
                scaleY: $7c2e27e1fc77ebd1$var$PARTICLE_SIZE,
                alpha: 1,
                tint: bgrColor
            });
            // pixiParticle.tint = bgrColor;
            // pixiParticle.alpha = 1.0;
            // Store in our data structure
            this.particles.push({
                particle: pixiParticle,
                velocity: velocity,
                lifetime: lifetime,
                age: 0
            });
        }
        // Create ParticleContainer with dynamic position and color
        this.sprite = new (0, $iuB9z.ParticleContainer)({
            dynamicProperties: {
                position: true,
                scale: false,
                rotation: false,
                color: true
            },
            particles: this.particles.map((p)=>p.particle)
        });
        this.sprite.cacheAsTexture(false);
        this.sprite.position.set(position.x, position.y);
        // Pre-calculate expected bounds to avoid clipping issues
        const maxSpeed = explosionSpeed;
        const maxLifetime = $7c2e27e1fc77ebd1$var$MAX_PARTICLE_LIFETIME;
        const maxDistance = maxSpeed * maxLifetime;
        // Set explicit bounds to prevent clipping
        this.sprite.bounds.minX = -maxDistance;
        this.sprite.bounds.minY = -maxDistance;
        this.sprite.bounds.maxX = maxDistance;
        this.sprite.bounds.maxY = maxDistance;
        this.sprite.cullable = false; // Disable culling to eliminate some weird clipping issues
        this.sprite.cullableChildren = false; // Disable culling for children too
        this.sprite.update();
    }
    onTick(dt) {
        const effectPosition = this.getPosition();
        const dampingFactor = Math.pow($7c2e27e1fc77ebd1$var$DAMPING_FACTOR, dt);
        // Update particles in reverse order for safe removal
        for(let i = this.particles.length - 1; i >= 0; i--){
            const dustParticle = this.particles[i];
            const pixiParticle = dustParticle.particle;
            dustParticle.age += dt;
            const worldPosition = effectPosition.add([
                pixiParticle.x,
                pixiParticle.y
            ]);
            if (// Remove particle if it's past its lifetime
            dustParticle.age >= dustParticle.lifetime || // Or has collided with the Earth
            worldPosition.magnitude < (0, $4957dda0a15a616e$export$938789a6994ad1a)) {
                this.sprite.removeParticle(pixiParticle);
                this.particles.splice(i, 1);
                continue;
            }
            const gravity = $7c2e27e1fc77ebd1$var$gravityAtPoint(worldPosition).imul(dt);
            dustParticle.velocity.iadd(gravity).imul(dampingFactor);
            const [dx, dy] = dustParticle.velocity.mul(dt);
            pixiParticle.x += dx;
            pixiParticle.y += dy;
            // Update alpha
            const t = dustParticle.age / dustParticle.lifetime;
            pixiParticle.alpha = (0, $jd0t2.clamp)((1 - t) ** 0.3);
        }
        // Destroy effect when all particles are gone
        if (this.particles.length === 0) this.destroy();
    }
}
/**
 * Calculate gravitational acceleration at a point.
 * a = -G * m / r (it should be r^2 in 3d, but just r feels better in 2d)
 */ function $7c2e27e1fc77ebd1$var$gravityAtPoint(position) {
    const distance = position.magnitude + $7c2e27e1fc77ebd1$var$EARTH_RADIUS_OFFSET;
    const gravityMagnitude = $7c2e27e1fc77ebd1$var$GRAVITY_STRENGTH / distance;
    return position.normalize(gravityMagnitude).imul(-1);
}



var $hA6FJ = parcelRequire("hA6FJ");

var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");
function $aa0a0f3c701f5a9a$export$e636e17021965266(sides, radius, rotationOffset = 0) {
    const points = [];
    for(let i = 0; i < sides; i++){
        const angle = i / sides * Math.PI * 2 + rotationOffset;
        const x = Math.cos(angle) * radius;
        const y = Math.sin(angle) * radius;
        points.push((0, $cbsax.V)(x, y));
    }
    return points;
}
function $aa0a0f3c701f5a9a$export$b32c4d26933d0880(points, scaleX, scaleY = scaleX) {
    return points.map((point)=>point.mulComponent([
            scaleX,
            scaleY
        ]));
}
function $aa0a0f3c701f5a9a$export$b5c4b052119a81d8(points, angle) {
    return points.map((point)=>point.rotate(angle));
}
function $aa0a0f3c701f5a9a$export$38c87b694f24be4e(points) {
    const segments = [];
    // Extract all segments including the closing one
    for(let i = 0; i < points.length; i++){
        const start = points[i];
        const end = points[(i + 1) % points.length]; // Wrap to first point for last segment
        const center = start.add(end).imul(0.5);
        const diff = end.sub(start);
        const length = diff.magnitude;
        const angle = diff.angle;
        segments.push({
            start: start,
            end: end,
            center: center,
            angle: angle,
            length: length
        });
    }
    return segments;
}
function $aa0a0f3c701f5a9a$export$de1047fb7134b830(points) {
    if (points.length === 0) return (0, $cbsax.V)(0, 0);
    let center = (0, $cbsax.V)(0, 0);
    for (const point of points)center = center.add(point);
    return center.imul(1 / points.length);
}
function $aa0a0f3c701f5a9a$export$ed1142a075ec6390(segment, polygonCenter = (0, $cbsax.V)(0, 0)) {
    // Vector from polygon center to segment center
    const toSegment = segment.center.sub(polygonCenter);
    // If segment is at center, use perpendicular to segment
    if (toSegment.magnitude < 0.001) return (0, $cbsax.V)(-Math.sin(segment.angle), Math.cos(segment.angle));
    return toSegment.normalize();
}



var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");
// Re-export all vector filter functionality

var $2oYNi = parcelRequire("2oYNi");
class $03334288d147b44f$export$3c45015dbff7fea5 extends (0, $2oYNi.default) {
}



class $72f9aa2601c20ef8$export$d1bfda47f236eecc extends (0, $03334288d147b44f$export$3c45015dbff7fea5) {
    constructor(omitProbability = 0.3, seed = Math.random() * 1000){
        super(), this.omitProbability = omitProbability, this.seed = seed;
    }
    apply(segments, context) {
        return segments.filter((_segment, i)=>{
            // Use deterministic random based on segment index and time
            const hash = (i * 1000 + this.seed + Math.floor(context.totalTime * 10)) % 1000;
            return hash / 1000 > this.omitProbability;
        });
    }
}



var $jd0t2 = parcelRequire("jd0t2");

class $6224414522095aec$export$5d7fbc7579ec29d0 extends (0, $03334288d147b44f$export$3c45015dbff7fea5) {
    constructor(frequency = 8, minAlpha = 0.3){
        super(), this.frequency = frequency, this.minAlpha = minAlpha, this.intensity = 0;
    }
    apply(segments, context) {
        if (this.intensity <= 0) return segments; // No flicker effect
        // Calculate flicker phase using sine wave
        const flickerPhase = Math.sin(context.totalTime * this.frequency * 2 * Math.PI);
        // When flickerPhase > 0, use full alpha. When < 0, use dimmed alpha
        // Intensity controls how much the effect is applied
        const alphaMultiplier = flickerPhase > 0 ? 1.0 : (0, $jd0t2.lerp)(1.0, 0, this.intensity);
        // Apply alpha modulation to all segments
        return segments.map((segment)=>({
                ...segment,
                alpha: (segment.alpha ?? 1.0) * alphaMultiplier
            }));
    }
}



var $cbsax = parcelRequire("cbsax");

class $8d6a68a01c252a32$export$caf87377e1d4d743 extends (0, $03334288d147b44f$export$3c45015dbff7fea5) {
    constructor(velocities){
        super(), this.velocities = velocities, this.accumulatedOffsets = [];
        // Initialize accumulated offsets to zero
        this.accumulatedOffsets = velocities.map(()=>(0, $cbsax.V)(0, 0));
    }
    setVelocities(velocities) {
        this.velocities = velocities;
        // Reset accumulated offsets when velocities change
        this.accumulatedOffsets = velocities.map(()=>(0, $cbsax.V)(0, 0));
    }
    onTick(dt) {
        // Accumulate movement over time
        this.accumulatedOffsets = this.accumulatedOffsets.map((offset, i)=>{
            const velocity = this.velocities[i] || (0, $cbsax.V)(0, 0);
            const movement = (0, $cbsax.V)(velocity).mul(dt);
            return (0, $cbsax.V)(offset).add(movement);
        });
    }
    apply(segments, _context) {
        return segments.map((segment, i)=>{
            const totalOffset = this.accumulatedOffsets[i] || (0, $cbsax.V)(0, 0);
            return {
                ...segment,
                start: (0, $cbsax.V)(segment.start).add(totalOffset),
                end: (0, $cbsax.V)(segment.end).add(totalOffset)
            };
        });
    }
}



class $96a77950dbebc930$export$761854c12ba66091 extends (0, $03334288d147b44f$export$3c45015dbff7fea5) {
    constructor(applyFunctions, lifespan){
        super();
        this.applyFunctions = Array.isArray(applyFunctions) ? applyFunctions : [
            applyFunctions
        ];
        if (lifespan) this.waitRender(lifespan).then(()=>{
            this.destroy();
        });
    }
    apply(segments, context) {
        // Apply all functions in sequence
        return this.applyFunctions.reduce((result, applyFn)=>applyFn(result, context), segments);
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $cbsax = parcelRequire("cbsax");
function $511204bfc17c1b95$export$2eef470e6a9eaa50(color) {
    return (segments)=>segments.map((segment)=>({
                ...segment,
                color: typeof color === "function" ? color(segment.color) : color
            }));
}
function $511204bfc17c1b95$export$8169ab519a488f4b(thickness) {
    return (segments)=>segments.map((segment)=>({
                ...segment,
                thickness: typeof thickness === "function" ? thickness(segment.thickness || 1) : thickness
            }));
}
function $511204bfc17c1b95$export$2faa1da9a27daaca(amplitude, frequency, seed = Math.random() * 1000) {
    return (segments, context)=>segments.map((segment, i)=>{
            const phaseOffset = (i * 0.7 + seed) * Math.PI;
            const wobbleX = Math.sin((context.totalTime + phaseOffset) * frequency * Math.PI * 2) * amplitude;
            const wobbleY = Math.cos((context.totalTime + phaseOffset * 1.3) * frequency * Math.PI * 2) * amplitude;
            const wobbleOffset = (0, $cbsax.V)(wobbleX, wobbleY);
            return {
                ...segment,
                start: (0, $cbsax.V)(segment.start.x + wobbleOffset.x, segment.start.y + wobbleOffset.y),
                end: (0, $cbsax.V)(segment.end.x + wobbleOffset.x, segment.end.y + wobbleOffset.y)
            };
        });
}
function $511204bfc17c1b95$export$81d2e72c19d98397(offset) {
    return (segments)=>segments.map((segment)=>({
                ...segment,
                start: (0, $cbsax.V)(segment.start.x + offset.x, segment.start.y + offset.y),
                end: (0, $cbsax.V)(segment.end.x + offset.x, segment.end.y + offset.y)
            }));
}
function $511204bfc17c1b95$export$ba29a7cfc794a535(scale) {
    return (segments)=>segments.map((segment)=>({
                ...segment,
                start: (0, $cbsax.V)(segment.start.x * scale, segment.start.y * scale),
                end: (0, $cbsax.V)(segment.end.x * scale, segment.end.y * scale)
            }));
}
const $511204bfc17c1b95$var$RAINBOW = [
    (0, $hA6FJ.Colors).RED,
    (0, $hA6FJ.Colors).ORANGE,
    (0, $hA6FJ.Colors).YELLOW,
    (0, $hA6FJ.Colors).GREEN,
    (0, $hA6FJ.Colors).BLUE,
    (0, $hA6FJ.Colors).PURPLE
];
function $511204bfc17c1b95$export$f8a1469674e6d2b(rainbow = $511204bfc17c1b95$var$RAINBOW) {
    return (segments)=>segments.map((segment, i)=>({
                ...segment,
                color: rainbow[i % rainbow.length]
            }));
}
function $511204bfc17c1b95$export$e497ea8c23033e0f(rainbow = $511204bfc17c1b95$var$RAINBOW, speed = 1.0) {
    return (segments, context)=>{
        // Calculate time-based offset for the rainbow pattern
        const timeOffset = Math.floor(context.totalTime * speed * rainbow.length);
        return segments.map((segment, i)=>({
                ...segment,
                color: rainbow[(i + timeOffset) % rainbow.length]
            }));
    };
}





var $iuB9z = parcelRequire("iuB9z");

var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");
class $e2325cc4ccd00a20$export$1538832b887d48e7 extends (0, $2oYNi.default) {
    constructor(options){
        super(), this.pausable = false // Sliders should work even when game is paused
        , this.trackHeight = 6, this.handleSize = 16, this.isDragging = false, this.isHovered = false, this.bounds = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        this._value = Math.max(0, Math.min(1, options.value));
        this.min = options.min ?? 0;
        this.max = options.max ?? 1;
        this.step = options.step ?? 0.1;
        this.sliderWidth = options.width ?? 200;
        this.onChangeCallback = options.onChange;
        // Create graphics components
        this.track = new (0, $iuB9z.Graphics)();
        this.fill = new (0, $iuB9z.Graphics)();
        this.handle = new (0, $iuB9z.Graphics)();
        if (options.layer) {
            this.track.layerName = options.layer;
            this.fill.layerName = options.layer;
            this.handle.layerName = options.layer;
        }
        if (options.position) this.updatePosition(options.position);
    }
    get value() {
        return this._value;
    }
    set value(newValue) {
        const clampedValue = Math.max(0, Math.min(1, newValue));
        if (this._value !== clampedValue) {
            this._value = clampedValue;
            this.redrawSlider();
            this.onChangeCallback?.(this._value);
        }
    }
    updatePosition(position) {
        this.track.position.set(position.x, position.y);
        this.fill.position.set(position.x, position.y);
        this.handle.position.set(position.x, position.y);
        this.updateBounds();
    }
    updateBounds() {
        if (this.sprite) {
            const position = this.getPosition();
            this.bounds = {
                x: position.x - this.sliderWidth / 2,
                y: position.y - this.handleSize / 2,
                width: this.sliderWidth,
                height: this.handleSize
            };
        }
    }
    isPointInside(x, y) {
        return x >= this.bounds.x && x <= this.bounds.x + this.bounds.width && y >= this.bounds.y && y <= this.bounds.y + this.bounds.height;
    }
    getValueFromX(x) {
        const relativeX = x - this.bounds.x;
        const percentage = Math.max(0, Math.min(1, relativeX / this.sliderWidth));
        // Apply step if specified
        if (this.step > 0) {
            const steps = Math.round(percentage / this.step);
            return steps * this.step;
        }
        return percentage;
    }
    redrawSlider() {
        // Clear all graphics
        this.track.clear();
        this.fill.clear();
        this.handle.clear();
        // Draw track (background)
        this.track.rect(-this.sliderWidth / 2, -this.trackHeight / 2, this.sliderWidth, this.trackHeight);
        this.track.stroke({
            color: (0, $hA6FJ.Colors).WHITE,
            width: 2
        });
        // Draw fill (active portion)
        const fillWidth = this.sliderWidth * this._value;
        if (fillWidth > 0) {
            this.fill.rect(-this.sliderWidth / 2, -this.trackHeight / 2, fillWidth, this.trackHeight);
            this.fill.stroke({
                color: (0, $hA6FJ.Colors).CYAN,
                width: 2
            });
        }
        // Draw handle
        const handleX = -this.sliderWidth / 2 + this.sliderWidth * this._value;
        const handleStrokeWidth = this.isDragging ? 4 : this.isHovered ? 3 : 2;
        this.handle.circle(handleX, 0, this.handleSize / 2);
        this.handle.stroke({
            color: (0, $hA6FJ.Colors).CYAN,
            width: handleStrokeWidth
        });
        // Add glow effect when hovered or dragging
        if (this.isHovered || this.isDragging) {
            this.handle.circle(handleX, 0, this.handleSize / 2);
            this.handle.stroke({
                color: (0, $hA6FJ.Colors).CYAN,
                width: 6,
                alpha: 0.3
            });
        }
    }
    onAdd() {
        this.sprite = this.track;
        this.sprites = [
            this.track,
            this.fill,
            this.handle
        ];
        this.redrawSlider();
    }
    onRender() {
        // Check hover state
        if (this.game && !this.isDragging) {
            const mousePos = this.game.io.mousePosition;
            const wasHovered = this.isHovered;
            this.isHovered = this.isPointInside(mousePos.x, mousePos.y);
            if (wasHovered !== this.isHovered) this.redrawSlider();
        }
        // Handle dragging
        if (this.isDragging && this.game) {
            const mousePos = this.game.io.mousePosition;
            const newValue = this.getValueFromX(mousePos.x);
            if (newValue !== this._value) {
                this._value = newValue;
                this.redrawSlider();
                this.onChangeCallback?.(this._value);
            }
        }
    }
    onMouseDown() {
        if (this.game) {
            const mousePos = this.game.io.mousePosition;
            if (this.isPointInside(mousePos.x, mousePos.y)) {
                this.isDragging = true;
                const newValue = this.getValueFromX(mousePos.x);
                if (newValue !== this._value) {
                    this._value = newValue;
                    this.redrawSlider();
                    this.onChangeCallback?.(this._value);
                }
            }
        }
    }
    onMouseUp() {
        if (this.isDragging) {
            this.isDragging = false;
            this.redrawSlider();
        }
    }
    onClick() {
    // Click handling is covered by mouseDown
    }
    setPosition(position) {
        this.updatePosition(position);
    }
    setValue(value) {
        this.value = value;
    }
}









const $3427e84844ca2b22$var$DEFAULT_LIFETIME = 2.0;
const $3427e84844ca2b22$var$DEFAULT_VELOCITY_SCALE = 50.0;
const $3427e84844ca2b22$var$PARTICLE_VELOCITY_MIN = 1;
const $3427e84844ca2b22$var$PARTICLE_VELOCITY_MAX = 2;
const $3427e84844ca2b22$var$PARTICLE_STROKE_WIDTH = 1;
class $3427e84844ca2b22$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor({ position: position, polygon: polygon, rotation: rotation = 0, lifetime: lifetime = $3427e84844ca2b22$var$DEFAULT_LIFETIME, velocityScale: velocityScale = $3427e84844ca2b22$var$DEFAULT_VELOCITY_SCALE, inheritedVelocity: inheritedVelocity, color: color = (0, $hA6FJ.Colors).WHITE, colors: colors }){
        super(), this.lifetime = $3427e84844ca2b22$var$DEFAULT_LIFETIME, this.currentTime = 0;
        this.lifetime = lifetime;
        // Apply rotation to polygon points if specified
        const rotatedPolygon = rotation !== 0 ? polygon.map((point)=>(0, $cbsax.V)(point).rotate(rotation)) : polygon;
        // Calculate the polygon center for proper outward movement
        const polygonCenter = (0, $aa0a0f3c701f5a9a$export$de1047fb7134b830)(rotatedPolygon);
        // Extract line segments from the rotated polygon
        const segments = (0, $aa0a0f3c701f5a9a$export$38c87b694f24be4e)(rotatedPolygon);
        // Use colors array if provided, otherwise use single color
        const particleColors = colors && colors.length > 0 ? colors : [
            color
        ];
        // Create line segments with randomized colors
        const lineSegments = (0, $686b22f01240f09f$export$6cfcc7d70288d8c8)(segments, particleColors, $3427e84844ca2b22$var$PARTICLE_STROKE_WIDTH);
        // Create the renderer
        this.renderer = new (0, $39e6ece9400a3f87$export$2e2bcd8739ae039)(lineSegments, "background");
        this.renderer.setPosition(position);
        // Calculate velocities for each segment
        const velocities = segments.map((segment)=>{
            const baseVelocity = (0, $azFtk.rUniform)($3427e84844ca2b22$var$PARTICLE_VELOCITY_MIN, $3427e84844ca2b22$var$PARTICLE_VELOCITY_MAX) * velocityScale;
            const outwardVelocity = (0, $aa0a0f3c701f5a9a$export$ed1142a075ec6390)(segment, polygonCenter).imul(baseVelocity).imul((0, $azFtk.rNormal)(1, 0.5));
            // Add inherited velocity if provided
            return inheritedVelocity ? outwardVelocity.add(inheritedVelocity) : outwardVelocity;
        });
        // Create and configure filters
        const movementFilter = new (0, $8d6a68a01c252a32$export$caf87377e1d4d743)(velocities);
        // Add filters to renderer
        this.renderer.addFilter(movementFilter);
    }
    onAdd() {
        // Add the renderer as a child entity
        this.addChild(this.renderer);
    }
    onTick(dt) {
        this.currentTime += dt;
        const progress = this.currentTime / this.lifetime;
        const alpha = (0, $jd0t2.clampUp)(1 - progress); // Fade out over time
        // Update fade filter
        this.renderer.setAlpha(alpha);
        // Destroy when lifetime is over
        if (this.currentTime >= this.lifetime) this.destroy();
    }
}






var $jd0t2 = parcelRequire("jd0t2");

var $azFtk = parcelRequire("azFtk");
var $7ea8b61c3c164d40$export$8f41e2a7b075abec = /*#__PURE__*/ function(AsteroidSize) {
    AsteroidSize[AsteroidSize["SMALL"] = 0] = "SMALL";
    AsteroidSize[AsteroidSize["MEDIUM"] = 1] = "MEDIUM";
    AsteroidSize[AsteroidSize["LARGE"] = 2] = "LARGE";
    AsteroidSize[AsteroidSize["XL"] = 3] = "XL";
    AsteroidSize[AsteroidSize["XXL"] = 4] = "XXL";
    return AsteroidSize;
}({});
const $7ea8b61c3c164d40$export$3f2c3f98c70ecf5a = {
    [0]: {
        health: 2,
        baseRadius: 8,
        radiusVariation: 2,
        vertexCount: [
            6,
            7,
            8
        ],
        fragmentCount: 0,
        points: 10
    },
    [1]: {
        health: 8,
        baseRadius: 13,
        radiusVariation: 3,
        vertexCount: [
            7,
            8,
            9
        ],
        fragmentCount: [
            2,
            3
        ],
        points: 20
    },
    [2]: {
        health: 12,
        baseRadius: 20,
        radiusVariation: 4,
        vertexCount: [
            8,
            9,
            10
        ],
        fragmentCount: [
            2,
            3
        ],
        points: 50
    },
    [3]: {
        health: 16,
        baseRadius: 28,
        radiusVariation: 5,
        vertexCount: [
            9,
            10,
            11
        ],
        fragmentCount: [
            2,
            3
        ],
        points: 100
    },
    [4]: {
        health: 24,
        baseRadius: 36,
        radiusVariation: 6,
        vertexCount: [
            10,
            11,
            12
        ],
        fragmentCount: [
            2,
            3
        ],
        points: 200
    }
};
function $7ea8b61c3c164d40$export$f433ed3e528f6783(size) {
    const config = $7ea8b61c3c164d40$export$3f2c3f98c70ecf5a[size];
    const vertexCount = (0, $azFtk.choose)(...config.vertexCount);
    const points = [];
    // Calculate physics radius (largest distance from center)
    let maxRadius = 0;
    for(let i = 0; i < vertexCount; i++){
        const angle = i / vertexCount * Math.PI * 2;
        // Add random variation to radius for irregular shape
        const radiusVariation = (0, $azFtk.rUniform)(-config.radiusVariation, config.radiusVariation);
        const radius = config.baseRadius + radiusVariation;
        maxRadius = Math.max(maxRadius, radius);
        // Add small angular variation for more natural look
        const angleVariation = (0, $azFtk.rUniform)(-0.3, 0.3);
        const finalAngle = angle + angleVariation;
        const point = (0, $jd0t2.polarToVec)(finalAngle, radius);
        points.push(point);
    }
    return {
        points: points,
        size: size,
        radius: maxRadius
    };
}
function $7ea8b61c3c164d40$export$6ad104a0d79fb6e3(currentSize) {
    switch(currentSize){
        case 0:
            return null; // Small asteroids don't fragment
        case 1:
            return 0;
        case 2:
            return 1;
        case 3:
            return 2;
        case 4:
            return 3;
        default:
            return null;
    }
}


// Asteroid physics constants
const $488d8131288bea22$var$ASTEROID_MASS = 100.0;
const $488d8131288bea22$var$GRAVITY_FORCE_STRENGTH = 4; // Force pulling toward turret
const $488d8131288bea22$var$INITIAL_VELOCITY_RANGE = 3; // Initial random velocity - reduced from 10
const $488d8131288bea22$var$ANGULAR_VELOCITY_RANGE = 1; // Random rotation speed - reduced from 2
const $488d8131288bea22$var$MAX_DISTANCE_FROM_CENTER = 500; // Destroy if too far away
const $488d8131288bea22$var$FRAGMENT_VELOCITY_BOOST = 15; // Extra velocity for fragments - reduced from 30
// Asteroid rendering constants
const $488d8131288bea22$var$STROKE_WIDTH = 1;
const $488d8131288bea22$var$FLASH_STROKE_WIDTH = 3;
const $488d8131288bea22$var$EXPLOSION_LIFETIME = 1.2;
const $488d8131288bea22$var$EXPLOSION_VELOCITY_SCALE = 20.0;
const $488d8131288bea22$var$FLASH_DURATION = 0.06;
// Dust trail constants
const $488d8131288bea22$var$DUST_SPAWN_INTERVAL_MIN = 0.2; // minimum seconds between dust spawns
const $488d8131288bea22$var$DUST_SPAWN_INTERVAL_MAX = 0.6; // maximum seconds between dust spawns
const $488d8131288bea22$var$DUST_PARTICLE_COUNT_MIN = 1; // minimum particles per spawn
const $488d8131288bea22$var$DUST_PARTICLE_COUNT_MAX = 2; // maximum particles per spawn
const $488d8131288bea22$var$DUST_EXPLOSION_SPEED = 4; // speed of dust particles (slower)
const $488d8131288bea22$var$MIN_VELOCITY_FOR_DUST = 3; // minimum asteroid velocity to spawn dust
class $488d8131288bea22$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(position, size, initialVelocity){
        super(), this.dustTimer = 0, this.nextDustInterval = (0, $azFtk.rUniform)($488d8131288bea22$var$DUST_SPAWN_INTERVAL_MIN, $488d8131288bea22$var$DUST_SPAWN_INTERVAL_MAX);
        this.tags = [
            "asteroid",
            "levelEntity"
        ];
        this.size = size;
        this.shape = (0, $7ea8b61c3c164d40$export$f433ed3e528f6783)(size);
        this.maxHealth = (0, $7ea8b61c3c164d40$export$3f2c3f98c70ecf5a)[size].health;
        this.currentHealth = this.maxHealth;
        // Create visual renderer
        this.renderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(this.shape.points, (0, $hA6FJ.Colors).WHITE, $488d8131288bea22$var$STROKE_WIDTH);
        this.addChild(this.renderer);
        // Create physics body with polygon collision that matches visual shape
        this.body = new (0, $biKyI.Body)({
            mass: $488d8131288bea22$var$ASTEROID_MASS
        });
        // Use fromPolygon since the shape might be concave
        this.body.fromPolygon(this.shape.points);
        for (const shape of this.body.shapes){
            shape.collisionGroup = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Enemy");
            shape.collisionMask = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Turret", "Bullet", "Explosion");
        }
        this.body.position = position.clone();
        // Set initial velocity - either provided or random
        this.body.velocity = initialVelocity ?? (0, $jd0t2.polarToVec)((0, $azFtk.rDirection)(), (0, $azFtk.rUniform)(0, $488d8131288bea22$var$INITIAL_VELOCITY_RANGE));
        // Random angular velocity for spinning
        this.body.angularVelocity = (0, $azFtk.rUniform)(-$488d8131288bea22$var$ANGULAR_VELOCITY_RANGE, $488d8131288bea22$var$ANGULAR_VELOCITY_RANGE);
    }
    onTick(dt) {
        // Apply gravity force toward turret (like gravity)
        this.body.applyForce((0, $cbsax.V)(this.body.position).imul(-1).imul($488d8131288bea22$var$GRAVITY_FORCE_STRENGTH));
        // Destroy asteroid if it gets too far from center
        const distanceToCenter = (0, $cbsax.V)(this.body.position).magnitude;
        if (distanceToCenter > $488d8131288bea22$var$MAX_DISTANCE_FROM_CENTER) {
            this.destroy();
            return;
        }
        // Update dust trail timer
        this.dustTimer += dt;
        if (this.dustTimer >= this.nextDustInterval) {
            this.dustTimer = 0;
            this.nextDustInterval = (0, $azFtk.rUniform)($488d8131288bea22$var$DUST_SPAWN_INTERVAL_MIN, $488d8131288bea22$var$DUST_SPAWN_INTERVAL_MAX);
            this.spawnDustTrail();
        }
    }
    onRender() {
        if (this.renderer) {
            this.renderer.setPosition(this.body.position);
            this.renderer.setRotation(this.body.angle);
        }
    }
    takeHit(damage) {
        this.currentHealth -= damage;
        if (this.currentHealth <= 0) this.die();
        else {
            this.renderer.addFilter(new (0, $96a77950dbebc930$export$761854c12ba66091)([
                (0, $511204bfc17c1b95$export$2eef470e6a9eaa50)((0, $hA6FJ.Colors).WHITE),
                (0, $511204bfc17c1b95$export$8169ab519a488f4b)($488d8131288bea22$var$FLASH_STROKE_WIDTH)
            ], $488d8131288bea22$var$FLASH_DURATION));
            // Dispatch impact event for non-fatal hit
            this.dispatch("bulletImpact", {
                targetType: "asteroid",
                position: this.getPosition(),
                damage: damage,
                remainingHealth: this.currentHealth
            });
        }
    }
    die(explodeDirection = (0, $cbsax.V)(0, 0)) {
        // Add score
        this.dispatch("scoreAdded", {
            points: (0, $7ea8b61c3c164d40$export$3f2c3f98c70ecf5a)[this.size].points
        });
        // Dispatch asteroid destroyed event for sound effects
        this.dispatch("asteroidDestroyed", {
            asteroidSize: this.size,
            points: (0, $7ea8b61c3c164d40$export$3f2c3f98c70ecf5a)[this.size].points
        });
        this.createDeathParticles(explodeDirection);
        this.createFragments(explodeDirection);
        this.destroy();
    }
    createDeathParticles(explodeDirection = (0, $cbsax.V)(0, 0)) {
        // Create rotated points for explosion effect
        const currentRotation = this.body?.angle || 0;
        const rotatedPoints = this.shape.points.map((point)=>point.rotate(currentRotation));
        // Get current velocity for inheritance
        const currentVelocity = (0, $cbsax.V)(this.body.velocity);
        const position = this.getPosition();
        const currentLevel = this.getCurrentLevel();
        // Create explosion using asteroid's rotated shape and white color
        const explosion = new (0, $3427e84844ca2b22$export$2e2bcd8739ae039)({
            position: position,
            polygon: rotatedPoints,
            color: (0, $hA6FJ.Colors).WHITE,
            lifetime: $488d8131288bea22$var$EXPLOSION_LIFETIME,
            velocityScale: $488d8131288bea22$var$EXPLOSION_VELOCITY_SCALE,
            inheritedVelocity: currentVelocity
        });
        // Add explosion to the current level
        currentLevel?.addChild(explosion);
        // Create dust explosion effect with size-based particle count
        const particleCount = (()=>{
            switch(this.size){
                case (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).SMALL:
                    return 100;
                case (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).MEDIUM:
                    return 150;
                case (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).LARGE:
                    return 200;
                case (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).XL:
                    return 300;
                case (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).XXL:
                    return 400;
                default:
                    return 100;
            }
        })();
        const dustExplosion = new (0, $7c2e27e1fc77ebd1$export$79ac126fea2e1154)({
            position: position,
            particleCount: particleCount,
            color: (0, $hA6FJ.Colors).WHITE,
            polygonVertices: rotatedPoints
        });
        currentLevel?.addChild(dustExplosion);
    }
    createFragments(explodeDirection = (0, $cbsax.V)(0, 0)) {
        const smallerSize = (0, $7ea8b61c3c164d40$export$6ad104a0d79fb6e3)(this.size);
        const currentLevel = this.getCurrentLevel();
        if (currentLevel && smallerSize !== null) {
            const fragmentCount = (0, $azFtk.choose)(2, 3, 3, 4, 4, 5);
            const position = this.getPosition();
            const currentVelocity = (0, $cbsax.V)(this.body?.velocity || [
                0,
                0
            ]);
            for(let i = 0; i < fragmentCount; i++){
                // Create random velocity for fragment (inherit some + add random)
                const randomAngle = (0, $azFtk.rDirection)();
                const randomSpeed = (0, $azFtk.rUniform)($488d8131288bea22$var$FRAGMENT_VELOCITY_BOOST * 0.5, $488d8131288bea22$var$FRAGMENT_VELOCITY_BOOST);
                const fragmentVelocity = currentVelocity.mul(0.3).iadd((0, $jd0t2.polarToVec)(randomAngle, randomSpeed)).iadd(explodeDirection);
                // Create fragment asteroid
                currentLevel.addChild(new $488d8131288bea22$export$2e2bcd8739ae039(position, smallerSize, fragmentVelocity));
            }
        }
    }
    spawnDustTrail() {
        const velocity = (0, $cbsax.V)(this.body.velocity);
        // Only spawn dust if asteroid is moving fast enough
        if (velocity.magnitude < $488d8131288bea22$var$MIN_VELOCITY_FOR_DUST) return;
        const position = this.getPosition();
        const currentLevel = this.getCurrentLevel();
        if (!currentLevel) return;
        // Get current rotation and create rotated polygon vertices for edge spawning
        const currentRotation = this.body?.angle || 0;
        const rotatedVertices = this.shape.points.map((point)=>point.rotate(currentRotation));
        // Create dust particles trailing behind the asteroid from its edges
        const dustDirection = velocity.normalize(-1); // Opposite direction of movement
        // Random particle count for natural variation
        const particleCount = Math.floor((0, $azFtk.rUniform)($488d8131288bea22$var$DUST_PARTICLE_COUNT_MIN, $488d8131288bea22$var$DUST_PARTICLE_COUNT_MAX + 1));
        const dustExplosion = new (0, $7c2e27e1fc77ebd1$export$79ac126fea2e1154)({
            position: position,
            particleCount: particleCount,
            explosionSpeed: $488d8131288bea22$var$DUST_EXPLOSION_SPEED,
            color: (0, $hA6FJ.Colors).WHITE,
            direction: dustDirection,
            polygonVertices: rotatedVertices
        });
        currentLevel.addChild(dustExplosion);
    }
    // ShieldDamager interface implementation
    getShieldDamage() {
        return 1; // Asteroids deal 1 damage to shield
    }
    onShieldHit() {
        this.die(this.getPosition());
    }
}




var $biKyI = parcelRequire("biKyI");


var $hA6FJ = parcelRequire("hA6FJ");

var $biKyI = parcelRequire("biKyI");

var $jd0t2 = parcelRequire("jd0t2");
class $a548dd5c609041d2$export$2e2bcd8739ae039 extends (0, $biKyI.RotationalSpring) {
    constructor(bodyA, options){
        const { stiffness: stiffness = 10, damping: damping = 1 } = options || {};
        super(bodyA, null, {
            damping: damping,
            stiffness: stiffness,
            restAngle: 0
        });
    }
    applyForce() {
        const body = this.bodyA;
        const displacement = (0, $jd0t2.angleDelta)(this.restAngle, body.angle);
        let torque = -this.stiffness * displacement - this.damping * body.angularVelocity;
        // Apply a non-linear power curve to the torque
        torque = Math.sign(torque) * Math.abs(torque) ** 0.6 * 100;
        body.angularForce += torque;
    }
}



var $cbsax = parcelRequire("cbsax");






const $64cf1b418814e07b$var$POLYGON_STROKE_WIDTH = 1;
const $64cf1b418814e07b$var$DEFAULT_EXPLOSION_LIFETIME = 1.4;
const $64cf1b418814e07b$var$DEFAULT_EXPLOSION_VELOCITY_SCALE = 50.0;
const $64cf1b418814e07b$var$HIT_FLASH_DURATION = 0.06;
const $64cf1b418814e07b$var$HIT_FLASH_COLOR = (0, $hA6FJ.Colors).WHITE;
class $64cf1b418814e07b$export$b52f0fdf00738bd0 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(position, config){
        super();
        this.tags = [
            "enemy",
            "levelEntity"
        ];
        this.initialPosition = position;
        this.config = config;
        // Initialize health
        this.currentHealth = this.config.health;
        // Initialize movement parameters with defaults
        this.maxSpeed = config.movement?.maxSpeed ?? 100;
        this.acceleration = config.movement?.acceleration ?? 80;
        this.damping = config.movement?.damping ?? -0.5;
        // Create line segment renderer for visual
        this.vectorSprite = this.addChild(new (0, $39e6ece9400a3f87$export$2e2bcd8739ae039)((0, $686b22f01240f09f$export$34e53d4e8f1e555c)(config.visualConfig.points, config.visualConfig.color, config.visualConfig.strokeWidth || $64cf1b418814e07b$var$POLYGON_STROKE_WIDTH), "main"));
        // Create the physics body now that visual config is available
        this.body = this.createBody(this.initialPosition);
        // Create aim spring for rotation control
        this.aimSpring = new (0, $a548dd5c609041d2$export$2e2bcd8739ae039)(this.body, {
            stiffness: 10,
            damping: 1
        });
        this.springs = [
            this.aimSpring
        ];
    }
    createBody(position) {
        const body = new (0, $biKyI.Body)({
            mass: this.config.mass,
            collisionResponse: false,
            position: position.clone()
        });
        // Create physics body from polygon
        const success = body.fromPolygon(this.config.visualConfig.points, {
            optimalDecomp: false,
            removeCollinearPoints: false
        });
        if (!success) {
            console.warn(`Failed to create physics body from polygon for ${this.constructor.name}`);
            // Fallback to a simple circle if polygon creation fails
            body.addShape(new (0, $biKyI.Circle)({
                radius: 10
            }));
        }
        // Set collision properties
        for (const shape of body.shapes){
            shape.collisionGroup = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Enemy");
            shape.collisionMask = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Bullet", "Explosion", "Turret");
        }
        return body;
    }
    onRender(dt) {
        if (this.body && this.vectorSprite) {
            // Update renderer position and rotation from physics body
            this.vectorSprite.setPosition(this.body.position);
            this.vectorSprite.setRotation(this.body.angle);
        }
    }
    takeDamage(damage) {
        if (this.isDestroyed()) return;
        this.currentHealth -= damage;
        if (this.currentHealth <= 0) this.die();
        else {
            // Start flash effect with a new flash filter
            this.vectorSprite.addFilter(new (0, $96a77950dbebc930$export$761854c12ba66091)((0, $511204bfc17c1b95$export$2eef470e6a9eaa50)($64cf1b418814e07b$var$HIT_FLASH_COLOR), $64cf1b418814e07b$var$HIT_FLASH_DURATION));
            // Dispatch impact event for non-fatal hit
            this.dispatch("bulletImpact", {
                targetType: "enemy",
                position: this.getPosition(),
                damage: damage,
                remainingHealth: this.currentHealth
            });
        }
    }
    takeHit(damage) {
        this.takeDamage(damage);
    }
    die() {
        if (this.isDestroyed()) return;
        // Create explosion effect
        this.createExplosion();
        // Award points
        this.dispatch("scoreAdded", {
            points: this.config.killPoints
        });
        // Dispatch enemy destroyed event for sound effects
        this.dispatch("enemyDestroyed", {
            enemyType: this.constructor.name.replace("Enemy", "").toLowerCase(),
            points: this.config.killPoints
        });
        // Allow subclasses to add custom death behavior
        this.onDeath();
        this.destroy();
    }
    onDeath() {
    // Override in subclasses for custom death behavior
    }
    createExplosion() {
        const visualConfig = this.config.visualConfig;
        const position = this.getPosition();
        // Get current velocity for inheritance
        const currentVelocity = this.body ? (0, $cbsax.V)(this.body.velocity) : undefined;
        // Get current rotation from renderer
        const currentRotation = this.vectorSprite?.sprite?.rotation || 0;
        // Create broken expand effect (debris)
        this.getCurrentLevel()?.addChild(new (0, $3427e84844ca2b22$export$2e2bcd8739ae039)({
            position: position,
            polygon: visualConfig.points,
            rotation: currentRotation,
            colors: [
                visualConfig.color,
                visualConfig.secondaryColor || visualConfig.color
            ],
            lifetime: $64cf1b418814e07b$var$DEFAULT_EXPLOSION_LIFETIME,
            velocityScale: $64cf1b418814e07b$var$DEFAULT_EXPLOSION_VELOCITY_SCALE,
            inheritedVelocity: currentVelocity
        }));
        // Create dust explosion effect
        this.getCurrentLevel()?.addChild(new (0, $7c2e27e1fc77ebd1$export$79ac126fea2e1154)({
            position: position,
            color: visualConfig.color,
            polygonVertices: visualConfig.points
        }));
    }
    getPosition() {
        return this.body ? (0, $cbsax.V)(this.body.position) : (0, $cbsax.V)(0, 0);
    }
    // ShieldDamager interface implementation
    getShieldDamage() {
        return 1; // Standard damage to shield when enemy collides
    }
    onShieldHit() {
        this.die(); // Enemies die when they hit the shield
    }
    //===========================================================================
    // AIM CONVENIENCE METHODS - Common rotation patterns for enemies
    //===========================================================================
    /**
   * Aim at a specific angle
   * @param angle Target angle in radians
   */ aim(angle) {
        this.aimSpring.restAngle = angle;
    }
    /**
   * Aim "down" toward the center/earth
   * Useful for bombers and enemies that need to face the planet
   */ aimDown() {
        const position = (0, $cbsax.V)(this.body.position);
        const toCenter = (0, $cbsax.V)(0, 0).sub(position);
        const angleToCenter = Math.atan2(toCenter.y, toCenter.x);
        // Add PI/2 to make "down" face the center
        this.aimSpring.restAngle = angleToCenter + Math.PI / 2;
    }
    /**
   * Aim in the direction of movement
   * Most common for enemies that should face where they're going
   */ aimWithMovement() {
        const velocity = (0, $cbsax.V)(this.body.velocity);
        if (velocity.magnitude > 0.5) this.aimSpring.restAngle = Math.atan2(velocity.y, velocity.x);
    }
    //===========================================================================
    // MOVEMENT CONVENIENCE METHODS - Common movement patterns for enemies
    //===========================================================================
    /**
   * Seek a target position with steering behavior
   * @param target Target position to move toward
   * @param arrivalRadius Optional radius to start slowing down (smooth arrival)
   */ seekPosition(target, arrivalRadius) {
        const position = (0, $cbsax.V)(this.body.position);
        const velocity = (0, $cbsax.V)(this.body.velocity);
        // Calculate desired velocity
        const toTarget = target.sub(position);
        const distance = toTarget.magnitude;
        if (distance < 0.01) return; // Already at target
        let desiredSpeed = this.maxSpeed;
        // Slow down when approaching target (arrival behavior)
        if (arrivalRadius && distance < arrivalRadius) desiredSpeed = this.maxSpeed * (distance / arrivalRadius);
        const desiredVelocity = toTarget.normalize().mul(desiredSpeed);
        // Calculate steering force
        const steeringForce = desiredVelocity.sub(velocity);
        const forceMagnitude = Math.min(steeringForce.magnitude, this.acceleration);
        const force = steeringForce.normalize().mul(forceMagnitude * this.body.mass);
        this.body.applyForce([
            force.x,
            force.y
        ]);
    }
    /**
   * Move in a specific direction
   * @param direction Direction vector (will be normalized)
   * @param speed Optional speed multiplier (0-1, default 1)
   */ moveInDirection(direction, speed = 1) {
        const normalizedDir = direction.normalize();
        const force = normalizedDir.mul(this.acceleration * this.body.mass * speed);
        this.body.applyForce([
            force.x,
            force.y
        ]);
    }
    /**
   * Apply braking force to slow down
   * @param strength Brake strength multiplier (default 1)
   */ brake(strength = 1) {
        const velocity = (0, $cbsax.V)(this.body.velocity);
        if (velocity.magnitude < 0.1) {
            this.body.velocity = [
                0,
                0
            ];
            return;
        }
        const brakeForce = velocity.normalize().mul(-this.acceleration * this.body.mass * strength);
        this.body.applyForce([
            brakeForce.x,
            brakeForce.y
        ]);
    }
    /**
   * Maintain a specific speed (accelerate or decelerate as needed)
   * @param targetSpeed Target speed to maintain (default: maxSpeed)
   */ maintainSpeed(targetSpeed) {
        const velocity = (0, $cbsax.V)(this.body.velocity);
        const currentSpeed = velocity.magnitude;
        const desiredSpeed = targetSpeed ?? this.maxSpeed;
        if (currentSpeed < 0.1) return; // Not moving
        const speedDiff = desiredSpeed - currentSpeed;
        if (Math.abs(speedDiff) < 1) return; // Close enough
        const direction = velocity.normalize();
        const force = direction.mul(speedDiff * this.acceleration * 0.1 * this.body.mass);
        this.body.applyForce([
            force.x,
            force.y
        ]);
    }
    /**
   * Apply velocity damping based on configured damping factor
   */ applyDamping() {
        const velocity = (0, $cbsax.V)(this.body.velocity);
        const dampingForce = velocity.mul(this.damping);
        this.body.applyForce([
            dampingForce.x,
            dampingForce.y
        ]);
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $jd0t2 = parcelRequire("jd0t2");


var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");

var $biKyI = parcelRequire("biKyI");


var $hA6FJ = parcelRequire("hA6FJ");

var $jd0t2 = parcelRequire("jd0t2");


var $cbsax = parcelRequire("cbsax");



var $cbsax = parcelRequire("cbsax");

var $biKyI = parcelRequire("biKyI");


var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");

var $dcc338a8816f0aac$export$31e26a3201c91bbb = /*#__PURE__*/ function(HitType) {
    HitType[HitType["Bullet"] = 0] = "Bullet";
    HitType[HitType["Explosion"] = 1] = "Explosion";
    return HitType;
}({});
function $dcc338a8816f0aac$export$7aa19ba7efd56036(entity) {
    return Boolean(entity) && typeof entity === "object" && entity !== null && "takeHit" in entity && typeof entity.takeHit === "function";
}



// Line circle effect constants
const $371ed54d4d862ccb$var$DEFAULT_LIFETIME = 1.5; // seconds
const $371ed54d4d862ccb$var$DEFAULT_RADIUS = 20; // radius of the circle
const $371ed54d4d862ccb$var$LINE_SPACING = 3; // fixed Y distance between lines
const $371ed54d4d862ccb$var$DEFAULT_LINE_THICKNESS = 2; // stroke width of lines
const $371ed54d4d862ccb$var$DAMAGE = 10; // damage per tick.
const $371ed54d4d862ccb$var$FADE_CURVE = (t)=>{
    return (0, $jd0t2.clamp)((0, $jd0t2.lerp)(2, 0, t));
};
const $371ed54d4d862ccb$var$RADIUS_CURVE = (t)=>{
    return t ** 0.5;
};
class $371ed54d4d862ccb$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(position, color = 0xffffff, radius = $371ed54d4d862ccb$var$DEFAULT_RADIUS, lifetime = $371ed54d4d862ccb$var$DEFAULT_LIFETIME){
        super(), this.lifetime = $371ed54d4d862ccb$var$DEFAULT_LIFETIME;
        this.color = color;
        this.maxRadius = radius;
        this.lifetime = lifetime;
        // Create line segment renderer with empty segments initially
        this.renderer = new (0, $39e6ece9400a3f87$export$2e2bcd8739ae039)([], "main");
        this.addChild(this.renderer);
        this.renderer.setPosition(position);
        this.body = new (0, $biKyI.Body)({
            mass: 0,
            type: (0, $biKyI.Body).KINEMATIC,
            position: position.clone()
        });
        this.body.addShape(new (0, $biKyI.Circle)({
            radius: 1,
            sensor: true,
            collisionGroup: (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Explosion"),
            collisionMask: (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Enemy", "Bomb")
        }));
    }
    get shape() {
        return this.body.shapes[0];
    }
    async onAdd() {
        await this.wait(this.lifetime, (dt, t)=>{
            const radius = $371ed54d4d862ccb$var$RADIUS_CURVE(t) * this.maxRadius + 0.01; // Add small offset to avoid zero radius
            this.renderer.setAlpha($371ed54d4d862ccb$var$FADE_CURVE(t));
            this.shape.radius = radius;
            this.shape.updateArea();
            this.shape.updateBoundingRadius();
            this.body.updateAABB();
        });
        this.destroy();
    }
    onRender() {
        const radius = this.shape.radius;
        const segments = [];
        // Generate line segments at fixed spacing intervals
        for(let y = -radius; y <= radius; y += $371ed54d4d862ccb$var$LINE_SPACING){
            // Calculate line half-width using circle equation: x = sqrt(r² - y²)
            const radiusSquared = radius ** 2;
            const ySquared = y ** 2;
            // Ensure we don't get negative values due to floating point precision
            if (radiusSquared >= ySquared) {
                const halfWidth = Math.sqrt(radiusSquared - ySquared);
                // Add the line segment
                segments.push({
                    start: (0, $cbsax.V)(-halfWidth, y),
                    end: (0, $cbsax.V)(halfWidth, y),
                    color: this.color,
                    thickness: $371ed54d4d862ccb$var$DEFAULT_LINE_THICKNESS
                });
            }
        }
        // Update renderer with new segments
        this.renderer.setSegments(segments);
    }
    onContacting({ other: other }) {
        if ((0, $dcc338a8816f0aac$export$7aa19ba7efd56036)(other)) other.takeHit($371ed54d4d862ccb$var$DAMAGE, (0, $dcc338a8816f0aac$export$31e26a3201c91bbb).Explosion);
    }
}



const $f99fab462ba2bee7$var$MAX_DISTANCE_FROM_CENTER = 400;
var $f99fab462ba2bee7$export$4b63755fcb155410 = /*#__PURE__*/ function(MunitionType) {
    MunitionType["BOMB"] = "bomb";
    MunitionType["MISSILE"] = "missile";
    MunitionType["BIG_BOMB"] = "bigBomb";
    return MunitionType;
}({});
class $f99fab462ba2bee7$export$ebb779659660811c extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(position){
        super(), this.exploded = false;
        // Create physics body - let subclass define the shape
        this.body = this.createBody(position);
        // Set up visual representation - let subclass handle this
        this.setupVisual();
    }
    onAdd() {
        // Initialize after construction when all properties are set
        this.initializeMunition();
    }
    initializeMunition() {
        // Get movement behavior from subclass
        this.movement = this.getMovementBehavior();
    }
    onTick(dt) {
        if (!this.body || this.exploded || !this.movement) return;
        // Update movement behavior
        this.movement.update(this, dt);
        // Destroy if too far from center
        const distanceToCenter = (0, $cbsax.V)(this.body.position).magnitude;
        if (distanceToCenter > $f99fab462ba2bee7$var$MAX_DISTANCE_FROM_CENTER) this.destroy();
    }
    onRender(dt) {
        // Update visual position - subclasses can override for custom rendering
        this.updateVisualPosition();
    }
    explode() {
        if (this.exploded) return;
        this.exploded = true;
        const explosionConfig = this.getExplosionConfig();
        // Create explosion effect
        this.createExplosion(explosionConfig);
        // Allow subclasses to add custom explosion behavior
        this.onExplode();
        this.destroy();
    }
    createExplosion(config) {
        // Dispatch explosion event for sound effects
        this.dispatch("explosion", {
            explosionType: this.getExplosionType(),
            position: this.getPosition(),
            radius: config.radius,
            lifetime: config.lifetime
        });
        // Create explosion effect with damage
        const explosion = new (0, $371ed54d4d862ccb$export$2e2bcd8739ae039)(this.getPosition(), config.color, config.radius, config.lifetime);
        // Add explosion to current level
        this.getCurrentLevel()?.addChild(explosion);
    }
    onExplode() {
    // Override in subclasses for custom explosion behavior
    }
    takeHit(damage) {
        this.explode();
    }
    // ShieldDamager interface implementation
    getShieldDamage() {
        return this.damage;
    }
    onShieldHit() {
        this.explode();
    }
    onBeginContact(eventData) {
        if (!eventData.other || this.exploded) return;
        // Explode on contact with turret (shield collision is handled by ShieldDamager interface)
        if (eventData.other.tags?.includes("turret")) this.explode();
    }
    getPosition() {
        return this.body ? (0, $cbsax.V)(this.body.position) : (0, $cbsax.V)(0, 0);
    }
}



var $cbsax = parcelRequire("cbsax");
const $ab37fbc46984111b$var$GRAVITY_FORCE_STRENGTH = 10;
class $ab37fbc46984111b$export$e4141852802c2c80 {
    update(munition, dt) {
        if (!munition.body) return;
        // Apply gravity toward center (like the turret is a planet)
        const gravityDirection = (0, $cbsax.V)(0, 0).sub(munition.body.position).normalize();
        const gravityForce = gravityDirection.imul($ab37fbc46984111b$var$GRAVITY_FORCE_STRENGTH).imul(munition.body.mass);
        munition.body.applyForce([
            gravityForce.x,
            gravityForce.y
        ]);
    }
}


// BigBomb physics constants
const $136eb7a42ae5ab76$var$BIG_BOMB_MASS = 3;
const $136eb7a42ae5ab76$var$INITIAL_VELOCITY_MULTIPLIER = 1;
// BigBomb rendering constants
const $136eb7a42ae5ab76$var$BIG_BOMB_STROKE_WIDTH = 1.5;
const $136eb7a42ae5ab76$var$BIG_BOMB_ROTATION_LERP = 0.15; // Smooth rotation interpolation factor
// BigBomb explosion constants
const $136eb7a42ae5ab76$var$BIG_BOMB_EXPLOSION_RADIUS = 50;
const $136eb7a42ae5ab76$var$BIG_BOMB_EXPLOSION_LIFETIME = 2.0; // seconds
const $136eb7a42ae5ab76$var$BIG_BOMB_DAMAGE = 2;
// BigBomb health system
const $136eb7a42ae5ab76$var$BIG_BOMB_MAX_HEALTH = 10;
const $136eb7a42ae5ab76$var$BOMB_POLYGON = (0, $aa0a0f3c701f5a9a$export$b32c4d26933d0880)([
    (0, $cbsax.V)(-3, -2),
    (0, $cbsax.V)(-2, -2),
    (0, $cbsax.V)(-1, -1),
    (0, $cbsax.V)(0, -0.75),
    (0, $cbsax.V)(1, -2),
    (0, $cbsax.V)(3, -2),
    (0, $cbsax.V)(4, -1),
    (0, $cbsax.V)(4, 1),
    (0, $cbsax.V)(3, 2),
    (0, $cbsax.V)(1, 2),
    (0, $cbsax.V)(0, 0.75),
    (0, $cbsax.V)(-1, 1),
    (0, $cbsax.V)(-2, 2),
    (0, $cbsax.V)(-3, 2)
], 2);
class $136eb7a42ae5ab76$export$e35b65c41e9877e0 extends (0, $f99fab462ba2bee7$export$ebb779659660811c) {
    constructor(position){
        super(position), this.munitionType = (0, $f99fab462ba2bee7$export$4b63755fcb155410).BIG_BOMB, this.damage = $136eb7a42ae5ab76$var$BIG_BOMB_DAMAGE, // Health system for BigBomb
        this.currentHealth = $136eb7a42ae5ab76$var$BIG_BOMB_MAX_HEALTH;
        this.tags = [
            "bigBomb",
            "bomb",
            "levelEntity"
        ]; // Include "bomb" for compatibility
    }
    createBody(position) {
        const body = new (0, $biKyI.Body)({
            mass: $136eb7a42ae5ab76$var$BIG_BOMB_MASS
        });
        body.fromPolygon($136eb7a42ae5ab76$var$BOMB_POLYGON, {
            optimalDecomp: false,
            removeCollinearPoints: false
        });
        for (const shape of body.shapes){
            shape.collisionGroup = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Bomb");
            shape.collisionMask = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Turret", "Bullet", "Explosion");
        }
        body.position = [
            position.x,
            position.y
        ];
        // Add slower initial velocity toward center
        const directionToCenter = (0, $cbsax.V)(0, 0).sub(position).normalize().imul($136eb7a42ae5ab76$var$INITIAL_VELOCITY_MULTIPLIER);
        body.velocity = [
            directionToCenter.x,
            directionToCenter.y
        ];
        return body;
    }
    setupVisual() {
        const visualConfig = this.getVisualConfig();
        this.renderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(visualConfig.points, visualConfig.strokeColor, visualConfig.strokeWidth || 1);
        // Add moving rainbow color filter to make BigBomb distinctive
        this.renderer.addFilter(new (0, $96a77950dbebc930$export$761854c12ba66091)((0, $511204bfc17c1b95$export$e497ea8c23033e0f)(undefined, 2.0)));
        this.addChild(this.renderer);
    }
    getMovementBehavior() {
        this.gravityMovement = new (0, $ab37fbc46984111b$export$e4141852802c2c80)();
        return this.gravityMovement;
    }
    getVisualConfig() {
        // Create precise 14-segment bomb shape: 7 nose + 2 body + 5 tail
        return {
            points: $136eb7a42ae5ab76$var$BOMB_POLYGON,
            strokeColor: (0, $hA6FJ.Colors).WHITE,
            strokeWidth: $136eb7a42ae5ab76$var$BIG_BOMB_STROKE_WIDTH
        };
    }
    getExplosionConfig() {
        return {
            radius: $136eb7a42ae5ab76$var$BIG_BOMB_EXPLOSION_RADIUS,
            lifetime: $136eb7a42ae5ab76$var$BIG_BOMB_EXPLOSION_LIFETIME,
            color: (0, $hA6FJ.Colors).PINK,
            damage: this.damage
        };
    }
    updateVisualPosition() {
        if (this.body && this.renderer) {
            this.renderer.setPosition(this.body.position);
            // Smooth rotation toward movement direction
            const velocity = (0, $cbsax.V)(this.body.velocity);
            if (velocity.magnitude > 0.1) {
                const targetAngle = velocity.angle;
                const angleDiff = (0, $jd0t2.angleDelta)(this.body.angle, targetAngle);
                // Smoothly interpolate rotation
                this.body.angle = (0, $jd0t2.lerpOrSnap)(this.body.angle, this.body.angle + angleDiff, $136eb7a42ae5ab76$var$BIG_BOMB_ROTATION_LERP, 0.01);
                this.renderer.setRotation(this.body.angle);
            }
        }
    }
    getExplosionType() {
        return "bigBomb";
    }
    // Override takeHit to implement health system
    takeHit(damage) {
        this.currentHealth -= damage;
        if (this.currentHealth <= 0) this.explode();
        else // Dispatch impact event for non-fatal hit
        this.dispatch("bulletImpact", {
            targetType: "bigBomb",
            position: this.getPosition(),
            damage: damage,
            remainingHealth: this.currentHealth
        });
    }
    /**
   * Get the renderer for applying visual effects
   */ getRenderer() {
        return this.renderer;
    }
}



//=============================================================================
// BOMBER CONFIGURATION - All tweakable values in one place
//=============================================================================
const $842e2007bfa800ea$var$BOMBER_CONFIG = {
    // Basic stats
    health: 100,
    killPoints: 50,
    mass: 3,
    // Visual
    color: (0, $hA6FJ.Colors).CORAL,
    secondaryColor: (0, $hA6FJ.Colors).DARK_CORAL,
    strokeWidth: 2,
    size: 12,
    shape: (0, $aa0a0f3c701f5a9a$export$e636e17021965266)(6, 12),
    // Orbital movement
    orbitRadius: 200,
    numWaypoints: 6,
    reachDistance: 40,
    // Movement speeds
    maxSpeed: 80,
    acceleration: 40,
    deceleration: 30,
    minStopSpeed: 5,
    // Bombing behavior
    pauseTime: 1.5,
    bombBurstSize: 1,
    bombSpreadRadius: 0,
    bombingDelay: 0.5
};
class $842e2007bfa800ea$export$bf780699f43fa3dd extends (0, $64cf1b418814e07b$export$b52f0fdf00738bd0) {
    constructor(position){
        super(position, {
            health: $842e2007bfa800ea$var$BOMBER_CONFIG.health,
            killPoints: $842e2007bfa800ea$var$BOMBER_CONFIG.killPoints,
            mass: $842e2007bfa800ea$var$BOMBER_CONFIG.mass,
            visualConfig: {
                points: [
                    ...$842e2007bfa800ea$var$BOMBER_CONFIG.shape
                ],
                color: $842e2007bfa800ea$var$BOMBER_CONFIG.color,
                secondaryColor: $842e2007bfa800ea$var$BOMBER_CONFIG.secondaryColor,
                strokeWidth: $842e2007bfa800ea$var$BOMBER_CONFIG.strokeWidth
            }
        }), // Orbital waypoint state
        this.waypoints = [], this.currentWaypointIndex = 0, this.isPaused = false, this.pauseTimer = 0, this.hasDroppedBombs = false;
        this.generateOrbitalWaypoints();
    }
    //===========================================================================
    // MAIN BEHAVIOR - Clear orbital movement with bombing
    //===========================================================================
    onTick(dt) {
        if (!this.body || this.waypoints.length === 0) return;
        this.rotateToFaceDownward();
        if (this.isPaused) this.handlePauseAtWaypoint(dt);
        else {
            this.moveTowardCurrentWaypoint();
            this.checkWaypointArrival();
        }
    }
    //===========================================================================
    // MOVEMENT LOGIC - Broken into clear, understandable pieces
    //===========================================================================
    generateOrbitalWaypoints() {
        // Generate waypoints in a higher orbit pattern
        for(let i = 0; i < $842e2007bfa800ea$var$BOMBER_CONFIG.numWaypoints; i++){
            const angle = i / $842e2007bfa800ea$var$BOMBER_CONFIG.numWaypoints * Math.PI * 2;
            const waypoint = (0, $jd0t2.polarToVec)(angle, $842e2007bfa800ea$var$BOMBER_CONFIG.orbitRadius);
            this.waypoints.push(waypoint);
        }
        // Start at a random waypoint index for varied orbital direction
        this.currentWaypointIndex = (0, $azFtk.rInteger)(0, this.waypoints.length);
    }
    rotateToFaceDownward() {
        // Use base class method to face downward
        this.aimDown();
    }
    moveTowardCurrentWaypoint() {
        const currentPos = (0, $cbsax.V)(this.body.position);
        const targetWaypoint = this.waypoints[this.currentWaypointIndex];
        const currentVelocity = (0, $cbsax.V)(this.body.velocity);
        const currentSpeed = currentVelocity.magnitude;
        // Calculate desired movement
        const toWaypoint = targetWaypoint.sub(currentPos);
        const desiredDirection = toWaypoint.normalize();
        const desiredVelocity = desiredDirection.mul($842e2007bfa800ea$var$BOMBER_CONFIG.maxSpeed);
        // Calculate steering force
        const steeringForce = desiredVelocity.sub(currentVelocity);
        // Apply acceleration (reduced when near max speed for smoother movement)
        const forceMultiplier = currentSpeed < $842e2007bfa800ea$var$BOMBER_CONFIG.maxSpeed * 0.9 ? $842e2007bfa800ea$var$BOMBER_CONFIG.acceleration : $842e2007bfa800ea$var$BOMBER_CONFIG.acceleration * 0.3;
        const limitedForce = steeringForce.normalize().mul(forceMultiplier * this.body.mass);
        this.body.applyForce([
            limitedForce.x,
            limitedForce.y
        ]);
    }
    checkWaypointArrival() {
        const currentPos = (0, $cbsax.V)(this.body.position);
        const targetWaypoint = this.waypoints[this.currentWaypointIndex];
        const distanceToWaypoint = targetWaypoint.sub(currentPos).magnitude;
        if (distanceToWaypoint < $842e2007bfa800ea$var$BOMBER_CONFIG.reachDistance) this.startPauseAtWaypoint();
    }
    startPauseAtWaypoint() {
        this.isPaused = true;
        this.pauseTimer = $842e2007bfa800ea$var$BOMBER_CONFIG.pauseTime;
        this.hasDroppedBombs = false;
    }
    handlePauseAtWaypoint(dt) {
        this.pauseTimer -= dt;
        // Decelerate to a stop
        this.decelerateToStop();
        // Drop bombs partway through the pause
        const bombingTime = $842e2007bfa800ea$var$BOMBER_CONFIG.pauseTime * $842e2007bfa800ea$var$BOMBER_CONFIG.bombingDelay;
        if (!this.hasDroppedBombs && this.pauseTimer <= $842e2007bfa800ea$var$BOMBER_CONFIG.pauseTime - bombingTime) {
            this.dropBombs();
            this.hasDroppedBombs = true;
        }
        // Move to next waypoint after pause
        if (this.pauseTimer <= 0) this.moveToNextWaypoint();
    }
    decelerateToStop() {
        const currentVelocity = (0, $cbsax.V)(this.body.velocity);
        const currentSpeed = currentVelocity.magnitude;
        if (currentSpeed > 0.1) {
            const decelerationForce = currentVelocity.normalize().mul(-$842e2007bfa800ea$var$BOMBER_CONFIG.deceleration * this.body.mass);
            this.body.applyForce([
                decelerationForce.x,
                decelerationForce.y
            ]);
            // Snap to full stop when very slow
            if (currentSpeed < $842e2007bfa800ea$var$BOMBER_CONFIG.minStopSpeed) this.body.velocity = [
                0,
                0
            ];
        } else this.body.velocity = [
            0,
            0
        ];
    }
    moveToNextWaypoint() {
        this.currentWaypointIndex = (0, $jd0t2.mod)(this.currentWaypointIndex + 1, this.waypoints.length);
        this.isPaused = false;
    }
    //===========================================================================
    // BOMBING - Simple and clear
    //===========================================================================
    dropBombs() {
        if (!this.game) return;
        const currentLevel = this.getCurrentLevel();
        if (!currentLevel) return;
        for(let i = 0; i < $842e2007bfa800ea$var$BOMBER_CONFIG.bombBurstSize; i++){
            // Create bombs in a spread pattern (currently just single bomb)
            const angle = i / $842e2007bfa800ea$var$BOMBER_CONFIG.bombBurstSize * Math.PI * 2;
            const offset = (0, $jd0t2.polarToVec)(angle, $842e2007bfa800ea$var$BOMBER_CONFIG.bombSpreadRadius);
            const bombPos = (0, $cbsax.V)(this.body.position).add(offset);
            const bomb = new (0, $136eb7a42ae5ab76$export$e35b65c41e9877e0)(bombPos);
            currentLevel.addChild(bomb);
        }
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $jd0t2 = parcelRequire("jd0t2");

var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");


var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");


var $hA6FJ = parcelRequire("hA6FJ");

var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");


var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");
class $2268ccc6fbd20d8c$export$9943f49a2c1c3cc7 {
    /**
   * Seek behavior - applies force toward target position
   */ static seek(enemy, target, maxForce) {
        if (!enemy.body) return {
            force: (0, $cbsax.V)(0, 0),
            arrived: false
        };
        const position = (0, $cbsax.V)(enemy.body.position);
        const velocity = (0, $cbsax.V)(enemy.body.velocity);
        // Calculate desired velocity (toward target at max speed)
        const desired = target.sub(position).normalize().imul(120); // max speed
        // Calculate steering force
        const steer = desired.sub(velocity);
        // Limit force magnitude
        const forceMagnitude = Math.min(steer.magnitude, maxForce);
        const force = steer.normalize().imul(forceMagnitude);
        return {
            force: force,
            arrived: false
        };
    }
    /**
   * Wander behavior - smooth random movement with containment
   */ static wander(enemy, maxForce, wanderRadius = 30, wanderDistance = 40, containmentRadius = 200) {
        if (!enemy.body) return {
            force: (0, $cbsax.V)(0, 0),
            arrived: false
        };
        const velocity = (0, $cbsax.V)(enemy.body.velocity);
        const position = (0, $cbsax.V)(enemy.body.position);
        const distanceFromCenter = position.magnitude;
        // If too far from center, steer back toward center instead of wandering
        if (distanceFromCenter > containmentRadius) {
            const centerPos = (0, $cbsax.V)(0, 0);
            return this.seek(enemy, centerPos, maxForce);
        }
        // Get current wander angle or initialize it
        if (!enemy.wanderAngle) enemy.wanderAngle = Math.random() * Math.PI * 2;
        // Update wander angle with small random changes
        const angleChange = (Math.random() - 0.5) * 0.3; // Max change of ~17 degrees
        enemy.wanderAngle += angleChange;
        // Calculate circle center in front of velocity
        const circleCenter = velocity.normalize().imul(wanderDistance);
        // Calculate target point on circle
        const wanderTarget = circleCenter.add((0, $jd0t2.polarToVec)(enemy.wanderAngle, wanderRadius));
        // Add to current position to get world target
        const worldTarget = position.add(wanderTarget);
        return this.seek(enemy, worldTarget, maxForce);
    }
    /**
   * Separation behavior - avoid crowding neighbors
   */ static separate(enemy, neighbors, maxForce, separationRadius = 50) {
        if (!enemy.body) return {
            force: (0, $cbsax.V)(0, 0),
            arrived: false
        };
        const position = (0, $cbsax.V)(enemy.body.position);
        let separationForce = (0, $cbsax.V)(0, 0);
        let count = 0;
        // Avoid other enemies
        for (const neighbor of neighbors){
            if (neighbor === enemy || !neighbor.body || neighbor.isDestroyed()) continue;
            const neighborPos = (0, $cbsax.V)(neighbor.body.position);
            const distance = position.sub(neighborPos).magnitude;
            if (distance > 0 && distance < separationRadius) {
                // Calculate force away from neighbor
                const diff = position.sub(neighborPos).normalize();
                // Weight by distance (closer = stronger force)
                const weight = (separationRadius - distance) / separationRadius;
                separationForce = separationForce.add(diff.imul(weight));
                count++;
            }
        }
        // Avoid center obstacle (turret/shield/earth) - much stronger avoidance
        const distanceFromCenter = position.magnitude;
        const centerAvoidanceRadius = 60; // Larger radius around center to avoid
        if (distanceFromCenter < centerAvoidanceRadius) {
            const awayFromCenter = position.normalize();
            const weight = (centerAvoidanceRadius - distanceFromCenter) / centerAvoidanceRadius;
            // Much stronger avoidance force (5x) and exponential scaling
            const exponentialWeight = weight * weight * 5;
            separationForce = separationForce.add(awayFromCenter.imul(exponentialWeight));
            count++;
        }
        if (count > 0) separationForce = separationForce.imul(1 / count).normalize().imul(maxForce);
        return {
            force: separationForce,
            arrived: false
        };
    }
}


//=============================================================================
// INTERCEPTOR CONFIGURATION - All tweakable values in one place
//=============================================================================
const $443fd421ad38d228$var$INTERCEPTOR_CONFIG = {
    // Basic stats
    health: 1,
    killPoints: 5,
    mass: 0.3,
    // Visual
    color: (0, $hA6FJ.Colors).RED,
    secondaryColor: (0, $hA6FJ.Colors).DARK_RED,
    strokeWidth: 1,
    size: 4,
    shape: [
        (0, $cbsax.V)(-4, -4),
        (0, $cbsax.V)(4, 0),
        (0, $cbsax.V)(-4, 4)
    ],
    // Movement speeds
    maxSpeed: 120,
    cruiseSpeed: 100,
    approachSpeed: 96,
    // Force strengths
    approachForce: 150,
    wanderForce: 80,
    speedBoostForce: 120,
    shieldAvoidanceForce: 160,
    separationForce: 40,
    containmentForce: 32,
    // Distances and radii
    splitDistance: 150,
    shieldAvoidanceRadius: 70,
    wanderContainmentRadius: 150,
    separationRadius: 25,
    waypointReachDistance: 10,
    // Behavior parameters
    velocityDamping: -0.1,
    wanderRadius: 30,
    wanderDistance: 50,
    flockRadius: 120
};
class $443fd421ad38d228$export$c401965227b9be00 extends (0, $64cf1b418814e07b$export$b52f0fdf00738bd0) {
    constructor(position, waypoints){
        super(position, {
            health: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.health,
            killPoints: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.killPoints,
            mass: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.mass,
            visualConfig: {
                points: [
                    ...$443fd421ad38d228$var$INTERCEPTOR_CONFIG.shape
                ],
                color: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.color,
                secondaryColor: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.secondaryColor,
                strokeWidth: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.strokeWidth
            },
            movement: {
                maxSpeed: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.maxSpeed,
                acceleration: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.approachForce,
                damping: $443fd421ad38d228$var$INTERCEPTOR_CONFIG.velocityDamping
            }
        }), // Behavior state
        this.phase = "approaching", this.currentWaypointIndex = 0;
        this.waypoints = waypoints;
        const toCenter = (0, $cbsax.V)(0, 0).sub((0, $cbsax.V)(this.body.position)).normalize();
        this.body.velocity = toCenter.imul($443fd421ad38d228$var$INTERCEPTOR_CONFIG.maxSpeed * 0.5);
        // Customize aim spring for more responsive rotation
        this.aimSpring.stiffness = 15;
        this.aimSpring.damping = 0.8;
    }
    onTick() {
        this.applyVelocityDamping();
        this.updatePhase();
        switch(this.phase){
            case "approaching":
                this.handleApproachPhase();
                break;
            case "splitting":
                this.handleSplittingPhase();
                break;
        }
        this.aimWithMovement();
    }
    updatePhase() {
        const position = (0, $cbsax.V)(this.body.position);
        const distanceFromCenter = position.magnitude;
        if (this.phase === "approaching" && distanceFromCenter < $443fd421ad38d228$var$INTERCEPTOR_CONFIG.splitDistance) this.initiateSplit();
    }
    initiateSplit() {
        this.phase = "splitting";
        // Pick a random perpendicular direction to split
        const position = (0, $cbsax.V)(this.body.position);
        const velocity = (0, $cbsax.V)(this.body.velocity);
        const toCenter = (0, $cbsax.V)(0, 0).sub(position).normalize();
        // Randomly choose left or right split direction
        this.splitDirection = (0, $azFtk.rBool)(0.5) ? toCenter.rotate90cw() : toCenter.rotate90ccw();
        // Blend split direction with current velocity for smooth transition
        const blendedDirection = velocity.normalize().lerp(this.splitDirection, 0.5).normalize();
        // Initialize wander angle for smooth transition
        this.wanderAngle = blendedDirection.angle;
    }
    //===========================================================================
    // APPROACH PHASE - Follow waypoints or go straight to center
    //===========================================================================
    handleApproachPhase() {
        if (!this.body) return;
        const position = (0, $cbsax.V)(this.body.position);
        // Follow waypoints if available, otherwise go straight to center
        if (this.waypoints && this.currentWaypointIndex < this.waypoints.length) this.followWaypoints(position);
        else this.approachCenter(position);
    }
    followWaypoints(position) {
        const targetWaypoint = this.waypoints[this.currentWaypointIndex];
        const toWaypoint = targetWaypoint.sub(position);
        const distanceToWaypoint = toWaypoint.magnitude;
        // Move to next waypoint if close enough
        if (distanceToWaypoint < $443fd421ad38d228$var$INTERCEPTOR_CONFIG.waypointReachDistance) this.currentWaypointIndex++;
        // Use seek behavior to maintain speed through waypoints
        const result = (0, $2268ccc6fbd20d8c$export$9943f49a2c1c3cc7).seek(this, targetWaypoint, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.approachForce);
        this.body.applyForce([
            result.force.x,
            result.force.y
        ]);
    }
    approachCenter(position) {
        // Use base class seek method to approach center
        const centerPos = (0, $cbsax.V)(0, 0);
        this.seekPosition(centerPos);
    }
    //===========================================================================
    // SPLITTING PHASE - Aggressive swarm behavior with multiple forces
    //===========================================================================
    handleSplittingPhase() {
        if (!this.body) return;
        const position = (0, $cbsax.V)(this.body.position);
        const velocity = (0, $cbsax.V)(this.body.velocity);
        const currentSpeed = velocity.magnitude;
        let totalForce = (0, $cbsax.V)(0, 0);
        // 1. Speed maintenance - highest priority
        totalForce = totalForce.add(this.calculateSpeedBoostForce(velocity, currentSpeed));
        // 2. Aggressive wandering for unpredictability
        totalForce = totalForce.add(this.calculateWanderForce());
        // 3. Shield avoidance - critical for survival
        totalForce = totalForce.add(this.calculateShieldAvoidanceForce(position));
        // 4. Separation from other interceptors
        totalForce = totalForce.add(this.calculateSeparationForce());
        // 5. Containment to stay in play area
        totalForce = totalForce.add(this.calculateContainmentForce(position));
        this.body.applyForce([
            totalForce.x,
            totalForce.y
        ]);
    }
    calculateSpeedBoostForce(velocity, currentSpeed) {
        // Maintain high speed in current direction
        if (currentSpeed < $443fd421ad38d228$var$INTERCEPTOR_CONFIG.cruiseSpeed) {
            const currentDirection = velocity.magnitude > 0.1 ? velocity.normalize() : (0, $cbsax.V)(1, 0);
            return currentDirection.mul($443fd421ad38d228$var$INTERCEPTOR_CONFIG.speedBoostForce * 1.5);
        }
        return (0, $cbsax.V)(0, 0);
    }
    calculateWanderForce() {
        // Aggressive wander for unpredictable movement
        const wanderResult = (0, $2268ccc6fbd20d8c$export$9943f49a2c1c3cc7).wander(this, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.wanderForce * 0.8, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.wanderRadius, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.wanderDistance, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.wanderContainmentRadius);
        return wanderResult.force;
    }
    calculateShieldAvoidanceForce(position) {
        // Strong shield avoidance - highest priority
        const distanceFromCenter = position.magnitude;
        if (distanceFromCenter < $443fd421ad38d228$var$INTERCEPTOR_CONFIG.shieldAvoidanceRadius) {
            const awayFromCenter = position.normalize();
            const weight = ($443fd421ad38d228$var$INTERCEPTOR_CONFIG.shieldAvoidanceRadius - distanceFromCenter) / $443fd421ad38d228$var$INTERCEPTOR_CONFIG.shieldAvoidanceRadius;
            // Very strong exponential avoidance force
            return awayFromCenter.mul(weight * weight * $443fd421ad38d228$var$INTERCEPTOR_CONFIG.shieldAvoidanceForce * 2);
        }
        return (0, $cbsax.V)(0, 0);
    }
    calculateSeparationForce() {
        // Minimal separation - only avoid very close neighbors
        const nearbyInterceptors = this.getNearbyInterceptors();
        if (nearbyInterceptors.length > 0) {
            const separationResult = (0, $2268ccc6fbd20d8c$export$9943f49a2c1c3cc7).separate(this, nearbyInterceptors, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.separationForce, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.separationRadius);
            return separationResult.force;
        }
        return (0, $cbsax.V)(0, 0);
    }
    calculateContainmentForce(position) {
        // Containment - but allow them to get closer to edges
        const distanceFromCenter = position.magnitude;
        if (distanceFromCenter > $443fd421ad38d228$var$INTERCEPTOR_CONFIG.wanderContainmentRadius * 0.8) {
            const centerPos = (0, $cbsax.V)(0, 0);
            const containmentResult = (0, $2268ccc6fbd20d8c$export$9943f49a2c1c3cc7).seek(this, centerPos, $443fd421ad38d228$var$INTERCEPTOR_CONFIG.containmentForce);
            return containmentResult.force;
        }
        return (0, $cbsax.V)(0, 0);
    }
    //===========================================================================
    // HELPER METHODS - Support functions for behavior
    //===========================================================================
    applyVelocityDamping() {
        // Use base class damping method
        this.applyDamping();
    }
    getNearbyInterceptors() {
        if (!this.game) return [];
        const position = (0, $cbsax.V)(this.body?.position || [
            0,
            0
        ]);
        const nearbyInterceptors = [];
        // Get all interceptor enemies from the game
        const interceptors = this.game.entities.getTagged("enemy").filter((entity)=>entity.tags.includes("enemy") && entity !== this && entity.body);
        for (const interceptor of interceptors){
            if (!interceptor.body) continue;
            const interceptorPos = (0, $cbsax.V)(interceptor.body.position);
            const distance = position.sub(interceptorPos).magnitude;
            if (distance < $443fd421ad38d228$var$INTERCEPTOR_CONFIG.flockRadius) nearbyInterceptors.push(interceptor);
        }
        return nearbyInterceptors;
    }
}


const $ef66e81f19b42991$var$INTERCEPTORS_PER_SWARM = 12;
const $ef66e81f19b42991$var$SPAWN_DELAY = 0.1; // Seconds between spawning each interceptor
const $ef66e81f19b42991$var$SPLIT_DISTANCE = 150; // Distance from center when interceptors split
var $ef66e81f19b42991$var$PathType = /*#__PURE__*/ function(PathType) {
    PathType["SINE"] = "sine";
    PathType["SPIRAL"] = "spiral";
    PathType["FIGURE8"] = "figure8";
    PathType["ZIGZAG"] = "zigzag";
    PathType["HELIX"] = "helix";
    return PathType;
}($ef66e81f19b42991$var$PathType || {});
class $ef66e81f19b42991$export$c797e43a25ed5f59 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(spawnPosition){
        super(), this.tags = [
            "interceptorSwarm"
        ], this.interceptors = [], this.waypoints = [];
        this.spawnPosition = spawnPosition.clone();
        // Randomly select path type for variety
        this.pathType = (0, $azFtk.choose)("sine", "spiral", "figure8", "zigzag", "helix");
    }
    async onAdd() {
        // Generate waypoints for the swarm's approach path
        this.generateWaypoints();
        // Spawn all interceptors with delay
        for(let i = 0; i < $ef66e81f19b42991$var$INTERCEPTORS_PER_SWARM; i++){
            this.spawnInterceptor();
            if (i < $ef66e81f19b42991$var$INTERCEPTORS_PER_SWARM - 1) await this.wait($ef66e81f19b42991$var$SPAWN_DELAY);
        }
        // Monitor for all interceptors being destroyed
        await this.waitUntil(()=>this.interceptors.every((i)=>i.isDestroyed()));
        this.destroy();
    }
    generateWaypoints() {
        // Sample many points along the path for smooth movement
        const numWaypoints = 50;
        for(let i = 0; i <= numWaypoints; i++){
            const t = i / numWaypoints; // 0 to 1
            const waypoint = this.getPathPoint(t);
            this.waypoints.push(waypoint);
        }
    }
    getPathPoint(t) {
        const toCenter = (0, $cbsax.V)(0, 0).sub(this.spawnPosition);
        const distance = toCenter.magnitude;
        const direction = toCenter.normalize();
        const perpendicular = direction.rotate90cw();
        const totalDistance = distance - $ef66e81f19b42991$var$SPLIT_DISTANCE;
        const forwardProgress = totalDistance * t;
        const basePoint = this.spawnPosition.add(direction.mul(forwardProgress));
        switch(this.pathType){
            case "sine":
                // Original smooth S-curves
                const lateralOffset = Math.sin(t * Math.PI * 2) * 60;
                return basePoint.add(perpendicular.mul(lateralOffset));
            case "spiral":
                // Spiral inward
                const radius = totalDistance * (1 - t); // Decreasing radius
                const angle = t * Math.PI * 4; // 2 full rotations
                const spiralOffset = (0, $cbsax.V)(Math.cos(angle) * radius * 0.3, Math.sin(angle) * radius * 0.3);
                return basePoint.add(spiralOffset);
            case "figure8":
                // Figure-8 using Lissajous curve
                const lateralFig8 = Math.sin(t * Math.PI * 2) * 60;
                const verticalFig8 = Math.sin(t * Math.PI * 4) * 30;
                return basePoint.add(perpendicular.mul(lateralFig8)).add(direction.rotate90cw().mul(verticalFig8));
            case "zigzag":
                // Sharp zigzag
                const zigzagPhase = Math.floor(t * 6); // 6 zigs
                const zigzagDirection = zigzagPhase % 2 === 0 ? 1 : -1;
                const zigzagOffset = zigzagDirection * 80;
                return basePoint.add(perpendicular.mul(zigzagOffset));
            case "helix":
                // 3D helix projected to 2D
                const helixAngle = t * Math.PI * 6; // 3 full rotations
                const helixRadius = 40 * (1 - t * 0.5); // Tightening helix
                const helixOffset = (0, $cbsax.V)(Math.cos(helixAngle) * helixRadius, Math.sin(helixAngle) * helixRadius);
                return basePoint.add(helixOffset);
            default:
                return basePoint;
        }
    }
    spawnInterceptor() {
        if (!this.game) return;
        const interceptor = new (0, $443fd421ad38d228$export$c401965227b9be00)(this.spawnPosition, this.waypoints);
        this.interceptors.push(interceptor);
        // Add to level
        this.getCurrentLevel()?.addChild(interceptor);
    }
}


//=============================================================================
// CARRIER CONFIGURATION - All tweakable values in one place
//=============================================================================
const $f212e463ad5bea6d$var$CARRIER_CONFIG = {
    // Basic stats
    health: 150,
    killPoints: 100,
    mass: 5,
    // Visual
    color: (0, $hA6FJ.Colors).CRIMSON,
    secondaryColor: (0, $hA6FJ.Colors).DARK_CRIMSON,
    strokeWidth: 4,
    crossThickArmLength: 18,
    crossThinArmLength: 12,
    // Orbital movement
    orbitRadius: 200,
    numWaypoints: 6,
    waypointReachDistance: 40,
    // Movement speeds
    maxSpeed: 60,
    acceleration: 30,
    deceleration: 20,
    minStopSpeed: 5,
    // Spawning behavior
    pauseTime: 4.0,
    spawnDelay: 0.5
};
class $f212e463ad5bea6d$export$ca565857877400fb extends (0, $64cf1b418814e07b$export$b52f0fdf00738bd0) {
    constructor(position){
        const crossShape = $f212e463ad5bea6d$export$ca565857877400fb.createCrossShape();
        super(position, {
            health: $f212e463ad5bea6d$var$CARRIER_CONFIG.health,
            killPoints: $f212e463ad5bea6d$var$CARRIER_CONFIG.killPoints,
            mass: $f212e463ad5bea6d$var$CARRIER_CONFIG.mass,
            visualConfig: {
                points: [
                    ...crossShape
                ],
                color: $f212e463ad5bea6d$var$CARRIER_CONFIG.color,
                secondaryColor: $f212e463ad5bea6d$var$CARRIER_CONFIG.secondaryColor,
                strokeWidth: $f212e463ad5bea6d$var$CARRIER_CONFIG.strokeWidth
            }
        }), // Orbital waypoint state
        this.waypoints = [], this.currentWaypointIndex = 0, this.isPaused = false, this.pauseTimer = 0, this.hasSpawnedSwarm = false;
        this.generateOrbitalWaypoints();
    }
    //===========================================================================
    // SHAPE GENERATION - Create the cross shape for the carrier
    //===========================================================================
    static createCrossShape() {
        const thick = $f212e463ad5bea6d$var$CARRIER_CONFIG.crossThickArmLength;
        const thin = $f212e463ad5bea6d$var$CARRIER_CONFIG.crossThinArmLength;
        return [
            (0, $cbsax.V)(-thin, -thick),
            (0, $cbsax.V)(thin, -thick),
            (0, $cbsax.V)(thin, -thin),
            (0, $cbsax.V)(thick, -thin),
            (0, $cbsax.V)(thick, thin),
            (0, $cbsax.V)(thin, thin),
            (0, $cbsax.V)(thin, thick),
            (0, $cbsax.V)(-thin, thick),
            (0, $cbsax.V)(-thin, thin),
            (0, $cbsax.V)(-thick, thin),
            (0, $cbsax.V)(-thick, -thin),
            (0, $cbsax.V)(-thin, -thin)
        ];
    }
    //===========================================================================
    // MAIN BEHAVIOR - Clear orbital movement with spawning
    //===========================================================================
    onTick(dt) {
        if (!this.body || this.waypoints.length === 0) return;
        this.rotateToFaceDownward();
        if (this.isPaused) this.handlePauseAtWaypoint(dt);
        else {
            this.moveTowardCurrentWaypoint();
            this.checkWaypointArrival();
        }
    }
    //===========================================================================
    // MOVEMENT LOGIC - Broken into clear, understandable pieces
    //===========================================================================
    generateOrbitalWaypoints() {
        // Generate waypoints in a higher orbit pattern
        for(let i = 0; i < $f212e463ad5bea6d$var$CARRIER_CONFIG.numWaypoints; i++){
            const angle = i / $f212e463ad5bea6d$var$CARRIER_CONFIG.numWaypoints * Math.PI * 2;
            const waypoint = (0, $jd0t2.polarToVec)(angle, $f212e463ad5bea6d$var$CARRIER_CONFIG.orbitRadius);
            this.waypoints.push(waypoint);
        }
        // Start at a random waypoint index for varied orbital direction
        this.currentWaypointIndex = (0, $azFtk.rInteger)(0, this.waypoints.length);
    }
    rotateToFaceDownward() {
        // Always rotate to keep earth "down" relative to the carrier
        const currentPos = (0, $cbsax.V)(this.body.position);
        const toCenter = (0, $cbsax.V)(0, 0).sub(currentPos);
        const angleToCenter = Math.atan2(toCenter.y, toCenter.x);
        this.body.angle = angleToCenter + Math.PI / 2;
    }
    moveTowardCurrentWaypoint() {
        const currentPos = (0, $cbsax.V)(this.body.position);
        const targetWaypoint = this.waypoints[this.currentWaypointIndex];
        const currentVelocity = (0, $cbsax.V)(this.body.velocity);
        const currentSpeed = currentVelocity.magnitude;
        // Calculate desired movement
        const toWaypoint = targetWaypoint.sub(currentPos);
        const desiredDirection = toWaypoint.normalize();
        const desiredVelocity = desiredDirection.mul($f212e463ad5bea6d$var$CARRIER_CONFIG.maxSpeed);
        // Calculate steering force
        const steeringForce = desiredVelocity.sub(currentVelocity);
        // Apply acceleration (reduced when near max speed for smoother movement)
        const forceMultiplier = currentSpeed < $f212e463ad5bea6d$var$CARRIER_CONFIG.maxSpeed * 0.9 ? $f212e463ad5bea6d$var$CARRIER_CONFIG.acceleration : $f212e463ad5bea6d$var$CARRIER_CONFIG.acceleration * 0.3;
        const limitedForce = steeringForce.normalize().mul(forceMultiplier * this.body.mass);
        this.body.applyForce([
            limitedForce.x,
            limitedForce.y
        ]);
    }
    checkWaypointArrival() {
        const currentPos = (0, $cbsax.V)(this.body.position);
        const targetWaypoint = this.waypoints[this.currentWaypointIndex];
        const distanceToWaypoint = targetWaypoint.sub(currentPos).magnitude;
        if (distanceToWaypoint < $f212e463ad5bea6d$var$CARRIER_CONFIG.waypointReachDistance) this.startPauseAtWaypoint();
    }
    startPauseAtWaypoint() {
        this.isPaused = true;
        this.pauseTimer = $f212e463ad5bea6d$var$CARRIER_CONFIG.pauseTime;
        this.hasSpawnedSwarm = false;
    }
    handlePauseAtWaypoint(dt) {
        this.pauseTimer -= dt;
        // Decelerate to a stop
        this.decelerateToStop();
        // Spawn interceptor swarm partway through the pause
        const spawnTime = $f212e463ad5bea6d$var$CARRIER_CONFIG.pauseTime * $f212e463ad5bea6d$var$CARRIER_CONFIG.spawnDelay;
        if (!this.hasSpawnedSwarm && this.pauseTimer <= $f212e463ad5bea6d$var$CARRIER_CONFIG.pauseTime - spawnTime) {
            this.spawnInterceptorSwarm();
            this.hasSpawnedSwarm = true;
        }
        // Move to next waypoint after pause
        if (this.pauseTimer <= 0) this.moveToNextWaypoint();
    }
    decelerateToStop() {
        const currentVelocity = (0, $cbsax.V)(this.body.velocity);
        const currentSpeed = currentVelocity.magnitude;
        if (currentSpeed > 0.1) {
            const decelerationForce = currentVelocity.normalize().mul(-$f212e463ad5bea6d$var$CARRIER_CONFIG.deceleration * this.body.mass);
            this.body.applyForce([
                decelerationForce.x,
                decelerationForce.y
            ]);
            // Snap to full stop when very slow
            if (currentSpeed < $f212e463ad5bea6d$var$CARRIER_CONFIG.minStopSpeed) this.body.velocity = [
                0,
                0
            ];
        } else this.body.velocity = [
            0,
            0
        ];
    }
    moveToNextWaypoint() {
        this.currentWaypointIndex = (0, $jd0t2.mod)(this.currentWaypointIndex + 1, this.waypoints.length);
        this.isPaused = false;
    }
    //===========================================================================
    // SPAWNING - Simple and clear
    //===========================================================================
    spawnInterceptorSwarm() {
        if (!this.game) return;
        const currentLevel = this.getCurrentLevel();
        if (!currentLevel) return;
        // Spawn interceptor swarm at carrier's position
        const spawnPos = (0, $cbsax.V)(this.body.position);
        const swarm = new (0, $ef66e81f19b42991$export$c797e43a25ed5f59)(spawnPos);
        currentLevel.addChild(swarm);
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");


var $cbsax = parcelRequire("cbsax");

//=============================================================================
// FIGHTER CONFIGURATION - All tweakable values in one place
//=============================================================================
const $b007bb8463b67521$var$FIGHTER_CONFIG = {
    // Basic stats
    health: 1,
    mass: 0.8,
    killPoints: 15,
    // Movement
    maxSpeed: 100,
    maxForce: 80,
    arrivalThreshold: 5,
    escapeDistance: 580,
    // Behavior
    dampingFactor: -0.5,
    // Visual
    strokeWidth: 1,
    shape: [
        (0, $cbsax.V)(0, -4),
        (0, $cbsax.V)(4, 4),
        (0, $cbsax.V)(-4, 4)
    ]
};
class $b007bb8463b67521$export$6323ef829a4caa30 extends (0, $64cf1b418814e07b$export$b52f0fdf00738bd0) {
    constructor(position, waypoints, color, munitionType){
        super(position, {
            health: $b007bb8463b67521$var$FIGHTER_CONFIG.health,
            killPoints: $b007bb8463b67521$var$FIGHTER_CONFIG.killPoints,
            mass: $b007bb8463b67521$var$FIGHTER_CONFIG.mass,
            visualConfig: {
                points: [
                    ...$b007bb8463b67521$var$FIGHTER_CONFIG.shape
                ],
                color: color,
                secondaryColor: color,
                strokeWidth: $b007bb8463b67521$var$FIGHTER_CONFIG.strokeWidth
            },
            movement: {
                maxSpeed: $b007bb8463b67521$var$FIGHTER_CONFIG.maxSpeed,
                acceleration: $b007bb8463b67521$var$FIGHTER_CONFIG.maxForce,
                damping: $b007bb8463b67521$var$FIGHTER_CONFIG.dampingFactor
            }
        }), // Behavior state
        this.phase = "approach", this.waypointIndex = 0, this.reachedFormation = false;
        this.waypoints = waypoints;
    }
    //===========================================================================
    // MAIN BEHAVIOR - Phase-based squadron behavior
    //===========================================================================
    onTick(dt) {
        if (!this.body) return;
        this.applyDamping();
        switch(this.phase){
            case "approach":
                this.handleApproach();
                break;
            case "bombing":
                this.handleBombing(dt);
                break;
            case "retreat":
                this.handleRetreat();
                break;
        }
    }
    handleApproach() {
        if (this.waypointIndex >= this.waypoints.length) {
            this.reachedFormation = true;
            return;
        }
        const currentPos = (0, $cbsax.V)(this.body.position);
        const targetWaypoint = this.waypoints[this.waypointIndex];
        const distance = targetWaypoint.sub(currentPos).magnitude;
        if (distance < $b007bb8463b67521$var$FIGHTER_CONFIG.arrivalThreshold) {
            this.waypointIndex++;
            if (this.waypointIndex >= this.waypoints.length) this.reachedFormation = true;
            return;
        }
        // Use base class seek method
        this.seekPosition(targetWaypoint, $b007bb8463b67521$var$FIGHTER_CONFIG.arrivalThreshold * 3);
        // Face movement direction
        this.aimWithMovement();
    }
    handleBombing(dt) {
        // Stay in formation and face downward
        this.aimDown();
    // TODO: Add bombing logic if needed
    }
    handleRetreat() {
        // Simple retreat - move away from center
        const currentPos = (0, $cbsax.V)(this.body.position);
        const awayFromCenter = currentPos.normalize();
        const escapeTarget = awayFromCenter.mul($b007bb8463b67521$var$FIGHTER_CONFIG.escapeDistance);
        const distance = escapeTarget.sub(currentPos).magnitude;
        if (distance < 50) {
            this.destroy();
            return;
        }
        // Use base class seek method to escape
        this.seekPosition(escapeTarget);
    }
    //===========================================================================
    // SQUADRON INTERFACE - Called by FighterSquadron
    //===========================================================================
    setPhase(phase) {
        this.phase = phase;
    }
    setRetreatPath(waypoints) {
        this.waypoints = waypoints;
        this.waypointIndex = 0;
    }
    hasReachedFormation() {
        return this.reachedFormation;
    }
    onDeath() {
    // Fighter destroyed - squadron will detect this automatically
    }
}



var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");
class $bf8fb1cb9da5c630$export$83f4c5f2a5687007 {
    /**
   * Generate formation positions arranged in rows with golden ratio proportions.
   * Middle rows are larger, formation is rotated to face earth at (0,0).
   */ static generateRectangularFormation(centerPosition, fighterCount, spacing = 30) {
        if (fighterCount === 1) return [
            centerPosition
        ];
        // Calculate optimal rows using golden ratio (width:height ≈ 1.61:1)
        const idealRows = Math.round(Math.sqrt(fighterCount / (0, $jd0t2.GOLDEN_RATIO)));
        const rows = Math.max(1, Math.min(idealRows, fighterCount));
        // Distribute fighters across rows, making middle rows larger
        const rowSizes = this.distributeIntoRows(fighterCount, rows);
        // Calculate rotation to face earth (0,0)
        const toEarth = (0, $cbsax.V)(0, 0).sub(centerPosition);
        const rotationAngle = Math.atan2(toEarth.y, toEarth.x) + Math.PI / 2; // +90° so "down" faces earth
        const positions = [];
        const rowSpacing = spacing * 1.2; // Slightly more space between rows
        // Calculate starting Y offset to center all rows
        const totalHeight = (rows - 1) * rowSpacing;
        const startY = -totalHeight / 2;
        for(let row = 0; row < rows; row++){
            const rowSize = rowSizes[row];
            const y = startY + row * rowSpacing;
            // Calculate starting X offset to center this row
            const rowWidth = (rowSize - 1) * spacing;
            const startX = -rowWidth / 2;
            for(let col = 0; col < rowSize; col++){
                const x = startX + col * spacing;
                let position = (0, $cbsax.V)(x, y);
                // Rotate the position to face earth
                position = position.rotate(rotationAngle);
                // Add to center position
                positions.push(centerPosition.add(position));
            }
        }
        return positions;
    }
    /**
   * Distribute fighters into rows with middle rows being larger.
   */ static distributeIntoRows(fighterCount, rows) {
        const baseSize = Math.floor(fighterCount / rows);
        const remainder = fighterCount % rows;
        const rowSizes = new Array(rows).fill(baseSize);
        // Distribute remainder to middle rows first
        if (remainder > 0) {
            const middleStart = Math.floor((rows - remainder) / 2);
            for(let i = 0; i < remainder; i++)rowSizes[middleStart + i]++;
        }
        return rowSizes;
    }
    /**
   * Generate approach waypoints from spawn position to formation position.
   * Simple direct approach - no fancy patterns.
   */ static generateApproachWaypoints(spawnPosition, formationPosition, waypointCount = 2) {
        const waypoints = [];
        for(let i = 0; i < waypointCount; i++){
            const t = i / (waypointCount - 1); // 0 to 1
            const position = spawnPosition.lerp(formationPosition, t);
            waypoints.push(position);
        }
        return waypoints;
    }
}


const $40c250bb64114ce6$var$FIGHTERS_PER_SQUADRON = 16;
const $40c250bb64114ce6$var$SPAWN_DELAY = 0.2; // Seconds between spawning each fighter
const $40c250bb64114ce6$var$FORMATION_DISTANCE = 150; // Distance from center for bombing formation
const $40c250bb64114ce6$var$BOMBING_DURATION = 16; // Seconds to stay in bombing formation
const $40c250bb64114ce6$var$CASUALTY_RETREAT_THRESHOLD = 0.4; // Retreat when 40% casualties
const $40c250bb64114ce6$var$ESCAPE_DISTANCE = 600; // Distance to escape before self-destruct
const $40c250bb64114ce6$var$FORMATION_SPACING = 10; // Spacing between fighters in formation
var $40c250bb64114ce6$var$SquadronPhase = /*#__PURE__*/ function(SquadronPhase) {
    SquadronPhase["APPROACH"] = "approach";
    SquadronPhase["BOMBING"] = "bombing";
    SquadronPhase["RETREAT"] = "retreat";
    return SquadronPhase;
}($40c250bb64114ce6$var$SquadronPhase || {});
class $40c250bb64114ce6$export$45bbdbcdcdc2153a extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(spawnPosition){
        super(), this.tags = [
            "fighterSquadron"
        ], this.fighters = [], this.phase = "approach", this.initialSquadronSize = $40c250bb64114ce6$var$FIGHTERS_PER_SQUADRON, this.formationPositions = [];
        this.spawnPosition = spawnPosition.clone();
        // All fighters in squadron will share these characteristics
        this.squadronConfig = {
            color: (0, $azFtk.choose)((0, $hA6FJ.Colors).PINK, (0, $hA6FJ.Colors).MAGENTA),
            munitionType: (0, $azFtk.choose)("bomb", "missile")
        };
        // Generate formation positions using utility
        const center = (0, $cbsax.V)(0, 0);
        const angleToSpawn = Math.atan2(spawnPosition.y, spawnPosition.x);
        const formationCenter = center.add((0, $cbsax.V)(Math.cos(angleToSpawn), Math.sin(angleToSpawn)).mul($40c250bb64114ce6$var$FORMATION_DISTANCE));
        this.formationPositions = (0, $bf8fb1cb9da5c630$export$83f4c5f2a5687007).generateRectangularFormation(formationCenter, $40c250bb64114ce6$var$FIGHTERS_PER_SQUADRON, $40c250bb64114ce6$var$FORMATION_SPACING);
    }
    async onAdd() {
        // Spawn all fighters with delay
        for(let i = 0; i < $40c250bb64114ce6$var$FIGHTERS_PER_SQUADRON; i++){
            await this.spawnFighter(i);
            if (i < $40c250bb64114ce6$var$FIGHTERS_PER_SQUADRON - 1) await this.wait($40c250bb64114ce6$var$SPAWN_DELAY);
        }
        // Monitor squadron lifecycle
        this.monitorSquadron();
    }
    async spawnFighter(index) {
        if (!this.game) return;
        // Get formation position for this fighter
        const formationPos = this.formationPositions[index];
        const approachWaypoints = (0, $bf8fb1cb9da5c630$export$83f4c5f2a5687007).generateApproachWaypoints(this.spawnPosition, formationPos, 40);
        const fighter = new (0, $b007bb8463b67521$export$6323ef829a4caa30)(this.spawnPosition, approachWaypoints, this.squadronConfig.color, this.squadronConfig.munitionType);
        this.fighters.push(fighter);
        this.getCurrentLevel()?.addChild(fighter);
    }
    async monitorSquadron() {
        if (!this.game) return;
        // Wait for all fighters to reach formation
        await this.waitUntil(()=>this.fighters.every((f)=>f.isDestroyed() || f.hasReachedFormation()));
        // Start bombing phase
        this.phase = "bombing";
        this.bombingStartTime = this.game.elapsedTime;
        // Notify all fighters of phase change
        for (const fighter of this.fighters)fighter.setPhase("bombing");
        // Wait for bombing phase to end
        await this.waitUntil(()=>{
            if (!this.game) return true;
            const survivingFighters = this.fighters.filter((f)=>!f.isDestroyed());
            const casualtyRate = 1 - survivingFighters.length / this.initialSquadronSize;
            const bombingDuration = this.game.elapsedTime - this.bombingStartTime;
            return casualtyRate >= $40c250bb64114ce6$var$CASUALTY_RETREAT_THRESHOLD || bombingDuration >= $40c250bb64114ce6$var$BOMBING_DURATION;
        });
        // Start retreat phase
        this.phase = "retreat";
        this.startRetreat();
        // Wait for all fighters to escape or be destroyed
        await this.waitUntil(()=>this.fighters.every((f)=>f.isDestroyed()));
        this.destroy();
    }
    startRetreat() {
        this.fighters.forEach((fighter, index)=>{
            if (!fighter.isDestroyed()) {
                const retreatWaypoints = this.generateRetreatPath(fighter, index);
                fighter.setRetreatPath(retreatWaypoints);
                fighter.setPhase("retreat");
            }
        });
    }
    generateRetreatPath(fighter, index) {
        if (!fighter.body) return [];
        const currentPos = (0, $cbsax.V)(fighter.body.position);
        // Exit in opposite direction from center
        const awayFromCenter = currentPos.normalize();
        const exitPoint = awayFromCenter.mul($40c250bb64114ce6$var$ESCAPE_DISTANCE);
        // Generate simple direct retreat waypoints with slight variation per fighter
        return (0, $bf8fb1cb9da5c630$export$83f4c5f2a5687007).generateApproachWaypoints(currentPos, exitPoint, 30);
    }
    getCurrentPhase() {
        return this.phase;
    }
}



var $hA6FJ = parcelRequire("hA6FJ");


var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");

//=============================================================================
// GHOST CONFIGURATION - All tweakable values in one place
//=============================================================================
const $27769911a4fb2955$var$GHOST_CONFIG = {
    // Basic stats
    health: 3,
    killPoints: 20,
    mass: 1.2,
    // Visual
    color: (0, $hA6FJ.Colors).CYAN,
    secondaryColor: (0, $hA6FJ.Colors).DARK_CYAN,
    strokeWidth: 2,
    sides: 8,
    size: 10,
    // Phasing behavior
    initialPhaseDuration: 2.0,
    phaseDuration: 3.0,
    visibleDuration: 4.0,
    // Movement
    maxSpeed: 70,
    acceleration: 35,
    changeDirectionInterval: 1.5,
    velocityDamping: -0.2,
    // Teleportation
    teleportDistance: 120,
    teleportChance: 0.3
};
class $27769911a4fb2955$export$607bf81307654a64 extends (0, $64cf1b418814e07b$export$b52f0fdf00738bd0) {
    constructor(position){
        super(position, {
            health: $27769911a4fb2955$var$GHOST_CONFIG.health,
            killPoints: $27769911a4fb2955$var$GHOST_CONFIG.killPoints,
            mass: $27769911a4fb2955$var$GHOST_CONFIG.mass,
            visualConfig: {
                points: [
                    ...(0, $aa0a0f3c701f5a9a$export$e636e17021965266)($27769911a4fb2955$var$GHOST_CONFIG.sides, $27769911a4fb2955$var$GHOST_CONFIG.size)
                ],
                color: $27769911a4fb2955$var$GHOST_CONFIG.color,
                secondaryColor: $27769911a4fb2955$var$GHOST_CONFIG.secondaryColor,
                strokeWidth: $27769911a4fb2955$var$GHOST_CONFIG.strokeWidth
            }
        }), // Phasing state
        this.phase = "phasing_in", this.phaseTimer = $27769911a4fb2955$var$GHOST_CONFIG.initialPhaseDuration, // Movement state
        this.directionChangeTimer = 0, this.currentDirection = (0, $cbsax.V)(0, 0);
        // Start with random direction
        this.generateRandomDirection();
    }
    //===========================================================================
    // MAIN BEHAVIOR - Phasing and movement
    //===========================================================================
    onTick(dt) {
        if (!this.body) return;
        this.updatePhasing(dt);
        this.updateMovement(dt);
        this.applyVelocityDamping();
    }
    //===========================================================================
    // PHASING LOGIC - Visibility cycles
    //===========================================================================
    updatePhasing(dt) {
        this.phaseTimer -= dt;
        // Handle phase transitions
        if (this.phaseTimer <= 0) switch(this.phase){
            case "phasing_in":
                this.phase = "visible";
                this.phaseTimer = $27769911a4fb2955$var$GHOST_CONFIG.visibleDuration;
                this.setVisibility(true);
                break;
            case "visible":
                this.phase = "phasing_in";
                this.phaseTimer = $27769911a4fb2955$var$GHOST_CONFIG.phaseDuration;
                this.setVisibility(false);
                this.teleportRandomly(); // Teleport when becoming invisible
                break;
        }
    }
    setVisibility(visible) {
        this.vectorSprite?.setAlpha(visible ? 1.0 : 0.3);
        // Enable/disable collision when invisible
        if (this.body?.shapes) for (const shape of this.body.shapes)shape.sensor = !visible; // Sensor shapes don't collide
    }
    //===========================================================================
    // MOVEMENT LOGIC - Random direction changes with teleportation
    //===========================================================================
    updateMovement(dt) {
        this.directionChangeTimer -= dt;
        // Change direction periodically
        if (this.directionChangeTimer <= 0) {
            this.changeDirection();
            this.directionChangeTimer = $27769911a4fb2955$var$GHOST_CONFIG.changeDirectionInterval;
        }
        // Apply movement force
        this.applyMovementForce();
    }
    changeDirection() {
        // Chance to teleport instead of changing direction
        if (Math.random() < $27769911a4fb2955$var$GHOST_CONFIG.teleportChance) this.teleportRandomly();
        this.generateRandomDirection();
    }
    generateRandomDirection() {
        // Generate random direction
        const angle = (0, $azFtk.rUniform)(0, Math.PI * 2);
        this.currentDirection = (0, $cbsax.V)(Math.cos(angle), Math.sin(angle));
    }
    applyMovementForce() {
        if (!this.body) return;
        const currentVelocity = (0, $cbsax.V)(this.body.velocity);
        const desiredVelocity = this.currentDirection.mul($27769911a4fb2955$var$GHOST_CONFIG.maxSpeed);
        const steeringForce = desiredVelocity.sub(currentVelocity);
        // Apply acceleration
        const force = steeringForce.normalize().mul($27769911a4fb2955$var$GHOST_CONFIG.acceleration * this.body.mass);
        this.body.applyForce([
            force.x,
            force.y
        ]);
    }
    applyVelocityDamping() {
        if (!this.body) return;
        const velocity = (0, $cbsax.V)(this.body.velocity);
        const dampingForce = velocity.mul($27769911a4fb2955$var$GHOST_CONFIG.velocityDamping);
        this.body.applyForce([
            dampingForce.x,
            dampingForce.y
        ]);
    }
    //===========================================================================
    // TELEPORTATION - Random position changes
    //===========================================================================
    teleportRandomly() {
        if (!this.body || !this.game) return;
        // Get current position
        const currentPos = (0, $cbsax.V)(this.body.position);
        // Generate random teleport direction
        const angle = (0, $azFtk.rUniform)(0, Math.PI * 2);
        const teleportDirection = (0, $cbsax.V)(Math.cos(angle), Math.sin(angle));
        const teleportOffset = teleportDirection.mul($27769911a4fb2955$var$GHOST_CONFIG.teleportDistance);
        // Calculate new position
        const newPosition = currentPos.add(teleportOffset);
        // Apply position change
        this.body.position = [
            newPosition.x,
            newPosition.y
        ];
        // Reset velocity to avoid weird physics
        this.body.velocity = [
            0,
            0
        ];
    }
    //===========================================================================
    // PUBLIC INTERFACE - For debugging or external control
    //===========================================================================
    /**
   * Check if ghost is currently visible and can be hit
   */ isCurrentlyVisible() {
        return this.phase === "visible";
    }
    /**
   * Override take damage to only work when visible
   */ takeDamage(damage) {
        // Only take damage when visible
        if (this.isCurrentlyVisible()) super.takeDamage(damage);
    }
}




var $cbsax = parcelRequire("cbsax");


var $hA6FJ = parcelRequire("hA6FJ");


var $cbsax = parcelRequire("cbsax");


//=============================================================================
// SPIRALER CONFIGURATION - All tweakable values in one place
//=============================================================================
const $d35fb2e9dbcf341d$var$SPIRALER_CONFIG = {
    // Basic stats
    health: 2,
    killPoints: 10,
    mass: 0.4,
    // Visual
    color: (0, $hA6FJ.Colors).GREEN,
    secondaryColor: (0, $hA6FJ.Colors).DARK_GREEN,
    strokeWidth: 1,
    size: 5,
    sides: 6,
    // Movement
    maxSpeed: 80,
    approachForce: 100,
    speedBoostForce: 50,
    velocityDamping: -0.1,
    // Waypoint behavior
    waypointReachDistance: 20,
    kamikazeSpeedThreshold: 40
};
class $d35fb2e9dbcf341d$export$e54db9330bb8b4c7 extends (0, $64cf1b418814e07b$export$b52f0fdf00738bd0) {
    constructor(position, waypoints){
        super(position, {
            health: $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.health,
            killPoints: $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.killPoints,
            mass: $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.mass,
            visualConfig: {
                points: [
                    ...(0, $aa0a0f3c701f5a9a$export$e636e17021965266)($d35fb2e9dbcf341d$var$SPIRALER_CONFIG.sides, $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.size)
                ],
                color: $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.color,
                secondaryColor: $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.secondaryColor,
                strokeWidth: $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.strokeWidth
            }
        }), this.currentWaypointIndex = 0, this.isKamikazeMode = false;
        this.waypoints = waypoints;
        // Initialize with velocity toward first waypoint if available
        if (this.body && this.waypoints && this.waypoints.length > 0) {
            const toFirstWaypoint = this.waypoints[0].sub((0, $cbsax.V)(this.body.position)).normalize();
            this.body.velocity = toFirstWaypoint.imul($d35fb2e9dbcf341d$var$SPIRALER_CONFIG.maxSpeed * 0.5);
        }
    }
    //===========================================================================
    // MAIN BEHAVIOR - Simple waypoint following with kamikaze mode
    //===========================================================================
    onTick() {
        if (!this.body) return;
        this.applyVelocityDamping();
        if (this.isKamikazeMode) this.handleKamikazeMode();
        else this.followWaypoints();
    }
    //===========================================================================
    // WAYPOINT FOLLOWING - Clear and simple
    //===========================================================================
    followWaypoints() {
        if (!this.waypoints || this.currentWaypointIndex >= this.waypoints.length) {
            // No waypoints or reached the end - switch to kamikaze mode
            this.isKamikazeMode = true;
            return;
        }
        const position = (0, $cbsax.V)(this.body.position);
        const targetWaypoint = this.waypoints[this.currentWaypointIndex];
        const toWaypoint = targetWaypoint.sub(position);
        const distanceToWaypoint = toWaypoint.magnitude;
        // Check if we've reached the current waypoint
        if (distanceToWaypoint < $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.waypointReachDistance) {
            this.moveToNextWaypoint();
            return;
        }
        // Use seek behavior to move toward current waypoint
        const result = (0, $2268ccc6fbd20d8c$export$9943f49a2c1c3cc7).seek(this, targetWaypoint, $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.approachForce);
        this.body.applyForce([
            result.force.x,
            result.force.y
        ]);
    }
    moveToNextWaypoint() {
        this.currentWaypointIndex++;
        // Check if we've exhausted all waypoints
        if (this.currentWaypointIndex >= this.waypoints.length) this.isKamikazeMode = true;
    }
    //===========================================================================
    // KAMIKAZE MODE - Continue current velocity toward center
    //===========================================================================
    handleKamikazeMode() {
        // The spiral path should naturally lead to the center
        // Just maintain speed and continue current direction
        const velocity = (0, $cbsax.V)(this.body.velocity);
        const currentSpeed = velocity.magnitude;
        // Boost speed if moving too slowly
        if (currentSpeed < $d35fb2e9dbcf341d$var$SPIRALER_CONFIG.kamikazeSpeedThreshold) {
            const currentDirection = velocity.magnitude > 0.1 ? velocity.normalize() : (0, $cbsax.V)(1, 0);
            const speedBoost = currentDirection.mul($d35fb2e9dbcf341d$var$SPIRALER_CONFIG.speedBoostForce);
            this.body.applyForce([
                speedBoost.x,
                speedBoost.y
            ]);
        }
    }
    //===========================================================================
    // HELPER METHODS - Support functions
    //===========================================================================
    applyVelocityDamping() {
        // Apply minimal velocity damping for smooth movement
        const velocity = (0, $cbsax.V)(this.body.velocity);
        const dampingForce = velocity.mul($d35fb2e9dbcf341d$var$SPIRALER_CONFIG.velocityDamping);
        this.body.applyForce([
            dampingForce.x,
            dampingForce.y
        ]);
    }
    //===========================================================================
    // PUBLIC INTERFACE - For debugging or external control
    //===========================================================================
    /**
   * Check if this spiraler has reached kamikaze mode
   */ isInKamikazeMode() {
        return this.isKamikazeMode;
    }
    /**
   * Get current waypoint progress (for debugging)
   */ getWaypointProgress() {
        return {
            current: this.currentWaypointIndex,
            total: this.waypoints?.length || 0
        };
    }
}


const $3dbb31baf31fd67f$var$SPIRALERS_PER_SWARM = 24;
const $3dbb31baf31fd67f$var$SPAWN_DELAY = 0.05; // Seconds between spawning each spiraler
const $3dbb31baf31fd67f$var$SPIRAL_LOOPS = 3; // Number of complete loops before reaching center
const $3dbb31baf31fd67f$var$SPIRAL_START_RADIUS = 300; // Starting distance from center
const $3dbb31baf31fd67f$var$SPIRAL_END_RADIUS = 10; // End very close to center for kamikaze
class $3dbb31baf31fd67f$export$85da391df88110a9 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(spawnPosition){
        super(), this.tags = [
            "spiralersSwarm"
        ], this.spiralers = [], this.waypoints = [];
        this.spawnPosition = spawnPosition.clone();
    }
    async onAdd() {
        // Generate waypoints for the swarm's spiral path
        this.generateSpiralWaypoints();
        // Spawn all spiralers with delay
        for(let i = 0; i < $3dbb31baf31fd67f$var$SPIRALERS_PER_SWARM; i++){
            this.spawnSpiraler();
            if (i < $3dbb31baf31fd67f$var$SPIRALERS_PER_SWARM - 1) await this.wait($3dbb31baf31fd67f$var$SPAWN_DELAY);
        }
        // Monitor for all spiralers being destroyed
        await this.waitUntil(()=>this.spiralers.every((s)=>s.isDestroyed()));
        this.destroy();
    }
    generateSpiralWaypoints() {
        // Generate a logarithmic spiral that contracts toward the center
        const numWaypoints = 100; // Many waypoints for smooth spiral
        // Calculate initial angle based on spawn position
        const initialAngle = Math.atan2(this.spawnPosition.y, this.spawnPosition.x);
        const initialRadius = this.spawnPosition.magnitude;
        for(let i = 0; i <= numWaypoints; i++){
            const t = i / numWaypoints; // 0 to 1
            // Logarithmic spiral parameters
            // Start from current angle and add rotations
            const angle = initialAngle + t * Math.PI * 2 * $3dbb31baf31fd67f$var$SPIRAL_LOOPS;
            // Interpolate radius from spawn distance to center
            const radius = initialRadius * Math.exp(-t * Math.log(initialRadius / $3dbb31baf31fd67f$var$SPIRAL_END_RADIUS));
            // Convert polar to cartesian
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;
            this.waypoints.push((0, $cbsax.V)(x, y));
        }
    }
    spawnSpiraler() {
        if (!this.game) return;
        const spiraler = new (0, $d35fb2e9dbcf341d$export$e54db9330bb8b4c7)(this.spawnPosition, this.waypoints);
        this.spiralers.push(spiraler);
        // Add to level
        this.getCurrentLevel()?.addChild(spiraler);
    }
}



var $hA6FJ = parcelRequire("hA6FJ");


var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");

//=============================================================================
// ZEPHYR CONFIGURATION - All tweakable values in one place
//=============================================================================
const $2b98169552cd60a3$var$ZEPHYR_CONFIG = {
    // Basic stats
    health: 3,
    killPoints: 125,
    mass: 0.2,
    size: 10,
    // Visual
    color: (0, $hA6FJ.Colors).YELLOW,
    secondaryColor: (0, $hA6FJ.Colors).ORANGE,
    strokeWidth: 3,
    shape: (0, $aa0a0f3c701f5a9a$export$e636e17021965266)(8, 10),
    // Pulse animation
    pulseSpeedScale: 8,
    pulseSpeedAlpha: 10,
    pulseAmountScale: 0.15,
    pulseAmountAlpha: 0.3,
    pulseBaseAlpha: 0.7,
    // Movement speeds
    enterSpeed: 180,
    evadeSpeed: 150,
    exitSpeed: 200,
    // Timing
    evadeDuration: 10,
    patternSwitchTime: 1.5,
    maxEnterTime: 2,
    enterDistance: 200,
    exitTime: 3,
    // Pattern-specific settings
    chaos: {
        directionChangeMin: 0.2,
        directionChangeMax: 0.5
    },
    figure8: {
        speed: 3,
        scale: 80,
        speedVariation: 0.3
    },
    spiral: {
        reverseTime: 0.8,
        baseRadius: 50,
        radiusVariation: 30,
        angularSpeed: 4
    },
    stopAndGo: {
        stopDuration: 0.3,
        moveDurationMin: 0.5,
        moveDurationMax: 0.8,
        speedMultiplier: 1.2
    },
    // Screen constraints
    screenMargin: 20
};
class $2b98169552cd60a3$export$df30d2cb22404a96 extends (0, $64cf1b418814e07b$export$b52f0fdf00738bd0) {
    constructor(position){
        super(position, {
            health: $2b98169552cd60a3$var$ZEPHYR_CONFIG.health,
            killPoints: $2b98169552cd60a3$var$ZEPHYR_CONFIG.killPoints,
            mass: $2b98169552cd60a3$var$ZEPHYR_CONFIG.mass,
            visualConfig: {
                points: $2b98169552cd60a3$var$ZEPHYR_CONFIG.shape,
                color: $2b98169552cd60a3$var$ZEPHYR_CONFIG.color,
                secondaryColor: $2b98169552cd60a3$var$ZEPHYR_CONFIG.secondaryColor,
                strokeWidth: $2b98169552cd60a3$var$ZEPHYR_CONFIG.strokeWidth
            }
        }), // State management
        this.phase = "entering", this.phaseTimer = 0, this.patternTimer = 0, this.currentPattern = "chaos", // Animation state
        this.pulseTime = 0, // Movement state
        this.targetDirection = (0, $cbsax.V)(0, 0), this.patternTime = 0, this.lastStopTime = 0, this.isStopped = false, this.spiralDirection = 1;
        // Initialize movement toward center
        this.targetDirection = (0, $cbsax.V)(0, 0).sub(position).normalize();
        this.selectNewPattern();
    }
    //===========================================================================
    // MAIN BEHAVIOR - All logic in one place, easy to read
    //===========================================================================
    onTick(dt) {
        this.updatePulseAnimation(dt);
        this.updateMovement(dt);
    }
    updatePulseAnimation(dt) {
        this.pulseTime += dt;
        if (!this.vectorSprite?.sprite) return;
        // Pulsing scale effect to draw attention
        const pulseScale = 1 + Math.sin(this.pulseTime * $2b98169552cd60a3$var$ZEPHYR_CONFIG.pulseSpeedScale) * $2b98169552cd60a3$var$ZEPHYR_CONFIG.pulseAmountScale;
        this.vectorSprite.sprite.scale.set(pulseScale, pulseScale);
        // Also pulse the alpha for extra sparkle
        const pulseAlpha = $2b98169552cd60a3$var$ZEPHYR_CONFIG.pulseBaseAlpha + Math.sin(this.pulseTime * $2b98169552cd60a3$var$ZEPHYR_CONFIG.pulseSpeedAlpha) * $2b98169552cd60a3$var$ZEPHYR_CONFIG.pulseAmountAlpha;
        this.vectorSprite.setAlpha(pulseAlpha);
    }
    updateMovement(dt) {
        if (!this.body) return;
        this.phaseTimer += dt;
        this.patternTime += dt;
        switch(this.phase){
            case "entering":
                this.handleEntering();
                break;
            case "evading":
                this.handleEvading(dt);
                break;
            case "exiting":
                this.handleExiting();
                break;
        }
    }
    //===========================================================================
    // PHASE HANDLERS - Clear separation of different behaviors
    //===========================================================================
    handleEntering() {
        // Move quickly toward center area
        const vel = this.targetDirection.mul($2b98169552cd60a3$var$ZEPHYR_CONFIG.enterSpeed);
        this.body.velocity = [
            vel.x,
            vel.y
        ];
        // Switch to evading once we're in the play area
        const distanceFromCenter = this.getPosition().magnitude;
        if (distanceFromCenter < $2b98169552cd60a3$var$ZEPHYR_CONFIG.enterDistance || this.phaseTimer > $2b98169552cd60a3$var$ZEPHYR_CONFIG.maxEnterTime) {
            this.phase = "evading";
            this.phaseTimer = 0;
            this.patternTimer = 0;
        }
    }
    handleEvading(dt) {
        // Check if it's time to escape
        if (this.phaseTimer >= $2b98169552cd60a3$var$ZEPHYR_CONFIG.evadeDuration) {
            this.phase = "exiting";
            this.selectExitDirection();
            return;
        }
        // Switch patterns periodically
        this.patternTimer += dt;
        if (this.patternTimer >= $2b98169552cd60a3$var$ZEPHYR_CONFIG.patternSwitchTime) {
            this.selectNewPattern();
            this.patternTimer = 0;
            this.patternTime = 0;
        }
        // Execute current pattern
        this.executeCurrentPattern(dt);
        // Keep within screen bounds
        this.constrainToScreen();
    }
    handleExiting() {
        // Accelerate in exit direction
        const vel = this.targetDirection.mul($2b98169552cd60a3$var$ZEPHYR_CONFIG.exitSpeed);
        this.body.velocity = [
            vel.x,
            vel.y
        ];
        // Self-destruct after moving far enough off-screen
        if (this.phaseTimer > $2b98169552cd60a3$var$ZEPHYR_CONFIG.exitTime) this.destroy();
    }
    //===========================================================================
    // EVASION PATTERNS - Each pattern clearly isolated
    //===========================================================================
    executeCurrentPattern(dt) {
        switch(this.currentPattern){
            case "chaos":
                this.executeChaosPattern();
                break;
            case "figure8":
                this.executeFigure8Pattern();
                break;
            case "spiral_reverse":
                this.executeSpiralReversePattern();
                break;
            case "stop_and_go":
                this.executeStopAndGoPattern();
                break;
        }
    }
    executeChaosPattern() {
        const cfg = $2b98169552cd60a3$var$ZEPHYR_CONFIG.chaos;
        // Change direction randomly
        if (this.patternTime > (0, $azFtk.rUniform)(cfg.directionChangeMin, cfg.directionChangeMax)) {
            const angle = (0, $azFtk.rUniform)(0, Math.PI * 2);
            this.targetDirection = (0, $cbsax.V)(Math.cos(angle), Math.sin(angle));
            this.patternTime = 0;
        }
        const vel = this.targetDirection.mul($2b98169552cd60a3$var$ZEPHYR_CONFIG.evadeSpeed);
        this.body.velocity = [
            vel.x,
            vel.y
        ];
    }
    executeFigure8Pattern() {
        const cfg = $2b98169552cd60a3$var$ZEPHYR_CONFIG.figure8;
        const t = this.patternTime * cfg.speed;
        // Lissajous curve for figure-8
        const vx = Math.cos(t) * cfg.scale;
        const vy = Math.sin(2 * t) * cfg.scale * 0.5;
        // Add speed variation
        const speedMod = 1 + Math.sin(t * 2) * cfg.speedVariation;
        this.body.velocity = [
            vx * speedMod,
            vy * speedMod
        ];
    }
    executeSpiralReversePattern() {
        const cfg = $2b98169552cd60a3$var$ZEPHYR_CONFIG.spiral;
        // Reverse spiral direction periodically
        if (this.patternTime > cfg.reverseTime) {
            this.spiralDirection *= -1;
            this.patternTime = 0;
        }
        const t = this.phaseTimer * cfg.angularSpeed;
        const radius = cfg.baseRadius + Math.sin(t) * cfg.radiusVariation;
        const angle = t * 2 * this.spiralDirection;
        const vx = Math.cos(angle) * radius;
        const vy = Math.sin(angle) * radius;
        this.body.velocity = [
            vx,
            vy
        ];
    }
    executeStopAndGoPattern() {
        const cfg = $2b98169552cd60a3$var$ZEPHYR_CONFIG.stopAndGo;
        if (this.isStopped) {
            // Stop for specified duration
            if (this.patternTime - this.lastStopTime > cfg.stopDuration) {
                this.isStopped = false;
                // Pick new random direction for burst
                const angle = (0, $azFtk.rUniform)(0, Math.PI * 2);
                this.targetDirection = (0, $cbsax.V)(Math.cos(angle), Math.sin(angle));
            } else this.body.velocity = [
                0,
                0
            ];
        } else // Move for random duration then stop
        if (this.patternTime - this.lastStopTime > (0, $azFtk.rUniform)(cfg.moveDurationMin, cfg.moveDurationMax)) {
            this.isStopped = true;
            this.lastStopTime = this.patternTime;
        } else {
            const vel = this.targetDirection.mul($2b98169552cd60a3$var$ZEPHYR_CONFIG.evadeSpeed * cfg.speedMultiplier);
            this.body.velocity = [
                vel.x,
                vel.y
            ];
        }
    }
    //===========================================================================
    // UTILITY METHODS - Support functions
    //===========================================================================
    selectNewPattern() {
        this.currentPattern = (0, $azFtk.choose)("chaos", "figure8", "spiral_reverse", "stop_and_go");
    }
    selectExitDirection() {
        if (!this.game) return;
        // Exit toward nearest screen edge
        const pos = this.getPosition();
        const viewport = this.game.camera.getWorldViewport();
        const distances = [
            {
                dir: (0, $cbsax.V)(0, -1),
                dist: pos.y - viewport.top
            },
            {
                dir: (0, $cbsax.V)(0, 1),
                dist: viewport.bottom - pos.y
            },
            {
                dir: (0, $cbsax.V)(-1, 0),
                dist: pos.x - viewport.left
            },
            {
                dir: (0, $cbsax.V)(1, 0),
                dist: viewport.right - pos.x
            }
        ];
        // Find closest edge
        distances.sort((a, b)=>a.dist - b.dist);
        this.targetDirection = distances[0].dir;
    }
    constrainToScreen() {
        if (!this.body || !this.game) return;
        const viewport = this.game.camera.getWorldViewport();
        const margin = $2b98169552cd60a3$var$ZEPHYR_CONFIG.screenMargin;
        const pos = (0, $cbsax.V)(this.body.position);
        const vel = (0, $cbsax.V)(this.body.velocity);
        // Bounce off screen edges
        if (pos.x <= viewport.left + margin && vel.x < 0) this.body.velocity[0] = Math.abs(vel.x);
        else if (pos.x >= viewport.right - margin && vel.x > 0) this.body.velocity[0] = -Math.abs(vel.x);
        if (pos.y <= viewport.top + margin && vel.y < 0) this.body.velocity[1] = Math.abs(vel.y);
        else if (pos.y >= viewport.bottom - margin && vel.y > 0) this.body.velocity[1] = -Math.abs(vel.y);
    }
}



// Difficulty progression constants
const $2482de655744cc87$var$MIN_SPAWN_INTERVAL = 1.5; // Minimum time between spawns (seconds)
const $2482de655744cc87$var$BASE_SPAWN_INTERVAL = 3; // Starting spawn interval for level 1 (seconds)
const $2482de655744cc87$var$SPAWN_INTERVAL_DECREASE_PER_LEVEL = 0.1; // How much faster spawning gets per level
// Spawn points progression constants
const $2482de655744cc87$var$BASE_SPAWN_POINTS = 20; // Starting spawn points for level 1
const $2482de655744cc87$var$ADDITIONAL_SPAWN_POINTS_PER_LEVEL = 10; // Additional spawn points per level
// Spawn positioning constants
const $2482de655744cc87$var$SPAWN_MARGIN = 15; // Distance outside viewport to spawn enemies (world units)
// Entity type spawn probabilities (must sum to 1.0)
const $2482de655744cc87$var$ENTITY_SPAWN_WEIGHTS = {
    asteroid: 0.14,
    interceptorSwarm: 0.16,
    spiralersSwarm: 0.16,
    squadron: 0.16,
    ghost: 0.16,
    carrierBomber: 0.16,
    zephyr: 0.06
};
// Spawn point costs for each entity type
const $2482de655744cc87$var$SPAWN_POINT_COSTS = {
    asteroid: 1,
    interceptorSwarm: 3,
    spiralersSwarm: 4,
    squadron: 4,
    ghost: 5,
    bomber: 5,
    zephyr: 6,
    carrier: 8
};
const $2482de655744cc87$var$ASTEROID_SIZE_WEIGHTS = [
    [
        (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).SMALL,
        0.4
    ],
    [
        (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).MEDIUM,
        0.3
    ],
    [
        (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).LARGE,
        0.2
    ],
    [
        (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).XL,
        0.08
    ],
    [
        (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).XXL,
        0.02
    ]
];
// Carrier/Bomber spawn distribution
const $2482de655744cc87$var$CARRIER_VS_BOMBER_RATIO = 0.3; // 30% carriers, 70% bombers when spawning this type
class $2482de655744cc87$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(level = 1){
        super(), this.id = "enemySpawner", this.tags = [
            "enemySpawner"
        ], this.timeSinceLastSpawn = 0, this.hasDispatchedFinished = false;
        // Balanced difficulty progression
        this.spawnInterval = (0, $jd0t2.clamp)($2482de655744cc87$var$BASE_SPAWN_INTERVAL - (level - 1) * $2482de655744cc87$var$SPAWN_INTERVAL_DECREASE_PER_LEVEL, $2482de655744cc87$var$MIN_SPAWN_INTERVAL, Infinity);
        this.spawnPointsRemaining = $2482de655744cc87$var$BASE_SPAWN_POINTS + (level - 1) * $2482de655744cc87$var$ADDITIONAL_SPAWN_POINTS_PER_LEVEL;
    }
    get isFinishedSpawning() {
        // Can't spawn anything if we don't have enough points for the cheapest entity
        const minCost = Math.min(...Object.values($2482de655744cc87$var$SPAWN_POINT_COSTS));
        return this.spawnPointsRemaining < minCost;
    }
    get enemiesRemaining() {
        const currentEnemyCount = this.getCurrentEnemyCount();
        // Estimate remaining enemies based on average spawn cost
        const avgSpawnCost = ($2482de655744cc87$var$SPAWN_POINT_COSTS.asteroid + $2482de655744cc87$var$SPAWN_POINT_COSTS.interceptorSwarm + $2482de655744cc87$var$SPAWN_POINT_COSTS.spiralersSwarm + $2482de655744cc87$var$SPAWN_POINT_COSTS.squadron + ($2482de655744cc87$var$SPAWN_POINT_COSTS.bomber * 0.7 + $2482de655744cc87$var$SPAWN_POINT_COSTS.carrier * 0.3)) / 5;
        const estimatedRemainingSpawns = Math.floor(this.spawnPointsRemaining / avgSpawnCost);
        return currentEnemyCount + estimatedRemainingSpawns;
    }
    get spawnPoints() {
        return this.spawnPointsRemaining;
    }
    onTick(dt) {
        if (!this.game) return;
        // Check if we just finished spawning
        if (this.isFinishedSpawning && !this.hasDispatchedFinished) {
            this.hasDispatchedFinished = true;
            this.dispatch("spawningFinished", {});
            return;
        }
        if (this.isFinishedSpawning) return;
        this.timeSinceLastSpawn += dt;
        // Check if it's time to spawn and we haven't spawned all enemies yet
        if (this.timeSinceLastSpawn >= this.spawnInterval) {
            this.spawnEntity();
            this.timeSinceLastSpawn = 0;
        }
    }
    getCurrentEnemyCount() {
        if (!this.game) return 0;
        return Array.from(this.game.entities.all).filter((entity)=>entity instanceof (0, $64cf1b418814e07b$export$b52f0fdf00738bd0)).length;
    }
    spawnEntity() {
        if (!this.game) return;
        const spawnPosition = this.getRandomSpawnPosition();
        // Try to select an entity type we can afford
        const entityType = this.selectAffordableEntityType();
        if (!entityType) return; // Can't afford anything
        // Spawn the entity and deduct appropriate cost
        switch(entityType){
            case "asteroid":
                this.spawnPointsRemaining -= $2482de655744cc87$var$SPAWN_POINT_COSTS.asteroid;
                this.spawnAsteroid(spawnPosition);
                break;
            case "interceptorSwarm":
                this.spawnPointsRemaining -= $2482de655744cc87$var$SPAWN_POINT_COSTS.interceptorSwarm;
                this.spawnInterceptorSwarm(spawnPosition);
                break;
            case "spiralersSwarm":
                this.spawnPointsRemaining -= $2482de655744cc87$var$SPAWN_POINT_COSTS.spiralersSwarm;
                this.spawnSpiralersSwarm(spawnPosition);
                break;
            case "squadron":
                this.spawnPointsRemaining -= $2482de655744cc87$var$SPAWN_POINT_COSTS.squadron;
                this.spawnSquadron(spawnPosition);
                break;
            case "ghost":
                this.spawnPointsRemaining -= $2482de655744cc87$var$SPAWN_POINT_COSTS.ghost;
                this.spawnGhost(spawnPosition);
                break;
            case "zephyr":
                this.spawnPointsRemaining -= $2482de655744cc87$var$SPAWN_POINT_COSTS.zephyr;
                this.spawnZephyr(spawnPosition);
                break;
            case "carrierBomber":
                // Deduct cost based on what we actually spawn
                const canAffordCarrier = this.spawnPointsRemaining >= $2482de655744cc87$var$SPAWN_POINT_COSTS.carrier;
                const willSpawnCarrier = canAffordCarrier && (0, $azFtk.rBool)($2482de655744cc87$var$CARRIER_VS_BOMBER_RATIO);
                this.spawnPointsRemaining -= willSpawnCarrier ? $2482de655744cc87$var$SPAWN_POINT_COSTS.carrier : $2482de655744cc87$var$SPAWN_POINT_COSTS.bomber;
                this.spawnCarrierOrBomber(spawnPosition);
                break;
        }
    }
    selectAffordableEntityType() {
        // Build weighted options for affordable entity types
        const affordableOptions = [];
        for (const [type, weight] of (0, $2JTRA.objectEntries)($2482de655744cc87$var$ENTITY_SPAWN_WEIGHTS)){
            // Check if we can afford this entity type
            if (type === "carrierBomber") // For carrier/bomber, we only need to afford the cheaper option (bomber)
            {
                if (this.spawnPointsRemaining >= $2482de655744cc87$var$SPAWN_POINT_COSTS.bomber) affordableOptions.push([
                    type,
                    weight
                ]);
            } else if (this.spawnPointsRemaining >= $2482de655744cc87$var$SPAWN_POINT_COSTS[type]) affordableOptions.push([
                type,
                weight
            ]);
        }
        if (affordableOptions.length === 0) return null;
        return (0, $azFtk.chooseWeighted)(affordableOptions);
    }
    spawnCarrierOrBomber(position) {
        if (!this.game) return;
        // Check if we have enough points for a carrier
        const canAffordCarrier = this.spawnPointsRemaining >= $2482de655744cc87$var$SPAWN_POINT_COSTS.carrier;
        // Decide between carrier and bomber based on ratio and affordability
        const shouldSpawnCarrier = canAffordCarrier && (0, $azFtk.rBool)($2482de655744cc87$var$CARRIER_VS_BOMBER_RATIO);
        const enemy = shouldSpawnCarrier ? new (0, $f212e463ad5bea6d$export$ca565857877400fb)(position) : new (0, $842e2007bfa800ea$export$bf780699f43fa3dd)(position);
        // Add enemy to the current level
        this.getCurrentLevel()?.addChild(enemy);
    }
    spawnSquadron(position) {
        // Create fighter squadron
        const squadron = new (0, $40c250bb64114ce6$export$45bbdbcdcdc2153a)(position);
        // Add squadron to the current level
        this.getCurrentLevel()?.addChild(squadron);
    }
    spawnAsteroid(position) {
        const asteroidSize = (0, $azFtk.chooseWeighted)($2482de655744cc87$var$ASTEROID_SIZE_WEIGHTS);
        const directionToCenter = (0, $cbsax.V)(0, 0).sub(position);
        const initialSpeed = (0, $azFtk.rUniform)(10, 30);
        // Give asteroids some initial velocity toward the center
        const initialVelocity = directionToCenter.normalize(initialSpeed);
        const asteroid = new (0, $488d8131288bea22$export$2e2bcd8739ae039)(position, asteroidSize, initialVelocity);
        // Add asteroid to the current level
        this.getCurrentLevel()?.addChild(asteroid);
    }
    spawnInterceptorSwarm(position) {
        // Create interceptor swarm
        const swarm = new (0, $ef66e81f19b42991$export$c797e43a25ed5f59)(position);
        // Add swarm to the current level
        this.getCurrentLevel()?.addChild(swarm);
    }
    spawnSpiralersSwarm(position) {
        // Create spiralers swarm
        const swarm = new (0, $3dbb31baf31fd67f$export$85da391df88110a9)(position);
        // Add swarm to the current level
        this.getCurrentLevel()?.addChild(swarm);
    }
    spawnGhost(position) {
        // Create ghost enemy (spawns invisible, will phase in at random location)
        const ghost = new (0, $27769911a4fb2955$export$607bf81307654a64)(position);
        // Add ghost to the current level
        this.getCurrentLevel()?.addChild(ghost);
    }
    spawnZephyr(position) {
        // Create zephyr enemy (high value evasive target)
        const zephyr = new (0, $2b98169552cd60a3$export$df30d2cb22404a96)(position);
        // Add zephyr to the current level
        this.getCurrentLevel()?.addChild(zephyr);
    }
    getRandomSpawnPosition() {
        if (!this.game) return (0, $cbsax.V)(0, 0);
        const viewport = this.game.camera.getWorldViewport();
        const side = (0, $azFtk.choose)("top", "right", "bottom", "left");
        switch(side){
            case "top":
                return (0, $cbsax.V)((0, $azFtk.rUniform)(viewport.left, viewport.left + viewport.width), viewport.top - $2482de655744cc87$var$SPAWN_MARGIN);
            case "right":
                return (0, $cbsax.V)(viewport.right + $2482de655744cc87$var$SPAWN_MARGIN, (0, $azFtk.rUniform)(viewport.top, viewport.top + viewport.height));
            case "bottom":
                return (0, $cbsax.V)((0, $azFtk.rUniform)(viewport.left, viewport.left + viewport.width), viewport.bottom + $2482de655744cc87$var$SPAWN_MARGIN);
            case "left":
                return (0, $cbsax.V)(viewport.left - $2482de655744cc87$var$SPAWN_MARGIN, (0, $azFtk.rUniform)(viewport.top, viewport.top + viewport.height));
            default:
                throw new Error("Invalid spawn side: " + side);
        }
    }
}



var $azFtk = parcelRequire("azFtk");


// Sound parameters for different asteroid sizes
// Asteroids should sound rocky and crunchy, different from enemy explosions
const $1e752d62de033aea$var$ASTEROID_SETTINGS = {
    [(0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).SMALL]: {
        baseFrequency: 300,
        duration: 0.15,
        volume: 0.15,
        noiseGain: 0.5,
        filterFreq: 800,
        crackleIntensity: 0.5
    },
    [(0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).MEDIUM]: {
        baseFrequency: 250,
        duration: 0.25,
        volume: 0.2,
        noiseGain: 0.6,
        filterFreq: 700,
        crackleIntensity: 0.4
    },
    [(0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).LARGE]: {
        baseFrequency: 200,
        duration: 0.4,
        volume: 0.25,
        noiseGain: 0.7,
        filterFreq: 600,
        crackleIntensity: 0.35
    },
    [(0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).XL]: {
        baseFrequency: 150,
        duration: 0.6,
        volume: 0.3,
        noiseGain: 0.8,
        filterFreq: 500,
        crackleIntensity: 0.3
    },
    [(0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).XXL]: {
        baseFrequency: 100,
        duration: 0.8,
        volume: 0.35,
        noiseGain: 0.9,
        filterFreq: 400,
        crackleIntensity: 0.25
    }
};
class $1e752d62de033aea$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super();
        this.tags = [
            "asteroidDestroyedSoundGenerator"
        ];
        this.id = "asteroidDestroyedSoundGenerator";
        // We'll get the audio context from the game when added
        this.audioContext = null;
    }
    onAdd() {
        if (!this.game?.audio) {
            console.warn("No audio context available in game");
            return;
        }
        this.audioContext = this.game.audio;
    }
    /**
   * Handle asteroid destroyed events
   */ onAsteroidDestroyed(eventData) {
        if (!this.audioContext || !this.game?.masterGain) return;
        this.synthesizeRockBreakingSound(eventData.asteroidSize);
    }
    synthesizeRockBreakingSound(asteroidSize) {
        const settings = $1e752d62de033aea$var$ASTEROID_SETTINGS[asteroidSize] || $1e752d62de033aea$var$ASTEROID_SETTINGS[(0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).MEDIUM];
        const now = this.audioContext.currentTime;
        // Create rock-breaking sound components
        this.createCracklingNoise(now, settings);
        this.createRockCrunchTone(now, settings);
        this.createDebrisScatter(now, settings);
    }
    createCracklingNoise(now, settings) {
        // Create crackling texture with filtered noise bursts
        const bufferSize = this.audioContext.sampleRate * settings.duration;
        const buffer = this.audioContext.createBuffer(1, bufferSize, this.audioContext.sampleRate);
        const data = buffer.getChannelData(0);
        // Generate crackling pattern - not smooth noise like explosions
        for(let i = 0; i < bufferSize; i++){
            const progress = i / bufferSize;
            const envelope = Math.pow(1 - progress, 1.5); // Sharper decay than explosions
            // Create crackling by modulating noise intensity
            const cracklePhase = progress * settings.crackleIntensity * 100;
            const crackleModulation = Math.sin(cracklePhase) * 0.5 + 0.5;
            const noiseLevel = crackleModulation > 0.7 ? 1.0 : 0.3; // Sharp on/off crackling
            data[i] = (0, $azFtk.rUniform)(-1, 1) * envelope * noiseLevel;
        }
        // Create buffer source
        const noiseSource = this.audioContext.createBufferSource();
        noiseSource.buffer = buffer;
        // Bandpass filter for less harsh, more boomy texture
        const noiseFilter = this.audioContext.createBiquadFilter();
        noiseFilter.type = "bandpass";
        noiseFilter.frequency.setValueAtTime(settings.filterFreq * 0.6, now); // Lower center frequency
        noiseFilter.frequency.exponentialRampToValueAtTime(settings.filterFreq * 0.3, now + settings.duration);
        noiseFilter.Q.setValueAtTime(1, now); // Lower Q for wider, less sharp filtering
        // Gain for volume control
        const noiseGain = this.audioContext.createGain();
        noiseGain.gain.setValueAtTime(settings.noiseGain, now);
        noiseGain.gain.exponentialRampToValueAtTime(0.01, now + settings.duration);
        // Connect and play
        noiseSource.connect(noiseFilter);
        noiseFilter.connect(noiseGain);
        noiseGain.connect(this.game.masterGain);
        noiseSource.start(now);
        noiseSource.stop(now + settings.duration);
        // Cleanup
        noiseSource.addEventListener("ended", ()=>{
            noiseSource.disconnect();
            noiseFilter.disconnect();
            noiseGain.disconnect();
        });
    }
    createRockCrunchTone(now, settings) {
        // Low-frequency impact tone for the "crunch"
        const oscillator = this.audioContext.createOscillator();
        oscillator.type = "triangle"; // Softer than sawtooth for rock texture
        // Filter for muffled rock impact
        const filter = this.audioContext.createBiquadFilter();
        filter.type = "lowpass";
        filter.frequency.setValueAtTime(settings.filterFreq * 0.8, now);
        filter.frequency.exponentialRampToValueAtTime(settings.filterFreq * 0.2, now + settings.duration);
        filter.Q.setValueAtTime(0.7, now); // Lower Q for more natural sound
        // Gain for impact envelope
        const gainNode = this.audioContext.createGain();
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime(settings.volume, now + 0.02); // Slightly slower attack than laser
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + settings.duration * 0.7); // Longer sustain
        // Frequency sweep for breaking/cracking effect - keep in 60-300Hz range
        const startFreq = Math.min(settings.baseFrequency * 1.2, 300); // Cap at 300Hz
        const endFreq = Math.max(settings.baseFrequency * 0.6, 60); // Floor at 60Hz
        oscillator.frequency.setValueAtTime(startFreq, now);
        oscillator.frequency.exponentialRampToValueAtTime(endFreq, now + settings.duration * 0.8);
        // Connect audio graph
        oscillator.connect(filter);
        filter.connect(gainNode);
        gainNode.connect(this.game.masterGain);
        // Start and stop
        oscillator.start(now);
        oscillator.stop(now + settings.duration);
        // Cleanup
        oscillator.addEventListener("ended", ()=>{
            oscillator.disconnect();
            filter.disconnect();
            gainNode.disconnect();
        });
    }
    createDebrisScatter(now, settings) {
        // Lower-frequency debris scatter sound (less harsh)
        const debrisDelay = settings.duration * 0.1; // Start shortly after main impact
        const debrisDuration = settings.duration * 0.6; // Shorter than main sound
        const oscillator = this.audioContext.createOscillator();
        oscillator.type = "triangle"; // Softer waveform
        // Bandpass filter for debris texture (less harsh than highpass)
        const filter = this.audioContext.createBiquadFilter();
        filter.type = "bandpass";
        filter.frequency.setValueAtTime(settings.filterFreq * 1.2, now + debrisDelay); // Much lower than before
        filter.frequency.exponentialRampToValueAtTime(settings.filterFreq * 0.8, now + debrisDelay + debrisDuration);
        filter.Q.setValueAtTime(1, now + debrisDelay); // Lower Q for softer filtering
        // Gain for debris envelope (quieter than main impact)
        const gainNode = this.audioContext.createGain();
        gainNode.gain.setValueAtTime(0, now + debrisDelay);
        gainNode.gain.linearRampToValueAtTime(settings.volume * 0.2, now + debrisDelay + 0.01);
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + debrisDelay + debrisDuration);
        // More moderate frequency for scattered debris
        const debrisFreq = settings.baseFrequency * 1.8; // Less high than before
        oscillator.frequency.setValueAtTime(debrisFreq, now + debrisDelay);
        oscillator.frequency.exponentialRampToValueAtTime(debrisFreq * 1.2, now + debrisDelay + debrisDuration);
        // Connect audio graph
        oscillator.connect(filter);
        filter.connect(gainNode);
        gainNode.connect(this.game.masterGain);
        // Start and stop
        oscillator.start(now + debrisDelay);
        oscillator.stop(now + debrisDelay + debrisDuration);
        // Cleanup
        oscillator.addEventListener("ended", ()=>{
            oscillator.disconnect();
            filter.disconnect();
            gainNode.disconnect();
        });
    }
}



var $azFtk = parcelRequire("azFtk");

// Sound parameters for different impact types
const $bf9549401b8888a4$var$IMPACT_SETTINGS = {
    asteroid: {
        baseFrequency: 800,
        duration: 0.08,
        volume: 0.12,
        noiseGain: 0.6,
        filterFreq: 1800,
        waveType: "square"
    },
    enemy: {
        baseFrequency: 900,
        duration: 0.06,
        volume: 0.12,
        noiseGain: 0.25,
        filterFreq: 2000,
        waveType: "triangle"
    },
    bigBomb: {
        baseFrequency: 600,
        duration: 0.1,
        volume: 0.18,
        noiseGain: 0.4,
        filterFreq: 1500,
        waveType: "sawtooth"
    }
};
class $bf9549401b8888a4$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super();
        this.tags = [
            "bulletImpactSoundGenerator"
        ];
        this.id = "bulletImpactSoundGenerator";
        // We'll get the audio context from the game when added
        this.audioContext = null;
    }
    onAdd() {
        if (!this.game?.audio) {
            console.warn("No audio context available in game");
            return;
        }
        this.audioContext = this.game.audio;
    }
    /**
   * Handle bullet impact events (non-fatal hits)
   */ onBulletImpact(eventData) {
        if (!this.audioContext || !this.game?.masterGain) return;
        this.synthesizeImpactSound(eventData.targetType, eventData.remainingHealth);
    }
    synthesizeImpactSound(targetType, remainingHealth) {
        const settings = $bf9549401b8888a4$var$IMPACT_SETTINGS[targetType] || $bf9549401b8888a4$var$IMPACT_SETTINGS.enemy;
        const now = this.audioContext.currentTime;
        // Create sharp impact sound components
        this.createImpactClick(now, settings);
        this.createImpactSpark(now, settings, remainingHealth);
    }
    createImpactClick(now, settings) {
        // Sharp click for bullet impact
        const oscillator = this.audioContext.createOscillator();
        oscillator.type = settings.waveType;
        // Very brief filter for sharp attack
        const filter = this.audioContext.createBiquadFilter();
        filter.type = "highpass";
        filter.frequency.setValueAtTime(settings.filterFreq, now);
        filter.frequency.exponentialRampToValueAtTime(settings.filterFreq * 0.3, now + settings.duration);
        filter.Q.setValueAtTime(3, now); // High Q for sharp character
        // Sharp attack/decay envelope
        const gainNode = this.audioContext.createGain();
        gainNode.gain.setValueAtTime(0, now);
        // Reduce oscillator volume for asteroids (more clicky, less tonal)
        const oscillatorVolume = settings.noiseGain > 0.5 ? settings.volume * 0.3 : settings.volume;
        gainNode.gain.linearRampToValueAtTime(oscillatorVolume, now + 0.005); // Very fast attack
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + settings.duration); // Quick decay
        // Quick frequency sweep down for impact character
        oscillator.frequency.setValueAtTime(settings.baseFrequency, now);
        oscillator.frequency.exponentialRampToValueAtTime(settings.baseFrequency * 0.6, now + settings.duration * 0.5);
        // Connect audio graph
        oscillator.connect(filter);
        filter.connect(gainNode);
        gainNode.connect(this.game.masterGain);
        // Start and stop
        oscillator.start(now);
        oscillator.stop(now + settings.duration);
        // Cleanup
        oscillator.addEventListener("ended", ()=>{
            oscillator.disconnect();
            filter.disconnect();
            gainNode.disconnect();
        });
    }
    createImpactSpark(now, settings, remainingHealth) {
        // Brief noise burst for impact texture
        const sparkDelay = 0.01; // Start just after the click
        const sparkDuration = settings.duration * 0.6;
        // Create short noise buffer
        const bufferSize = this.audioContext.sampleRate * sparkDuration;
        const buffer = this.audioContext.createBuffer(1, bufferSize, this.audioContext.sampleRate);
        const data = buffer.getChannelData(0);
        // Generate brief noise burst with sharp decay
        for(let i = 0; i < bufferSize; i++){
            const progress = i / bufferSize;
            const envelope = Math.pow(1 - progress, 3); // Sharp exponential decay
            data[i] = (0, $azFtk.rUniform)(-1, 1) * envelope;
        }
        // Create buffer source
        const noiseSource = this.audioContext.createBufferSource();
        noiseSource.buffer = buffer;
        // High-pass filter for sparkle
        const sparkFilter = this.audioContext.createBiquadFilter();
        sparkFilter.type = "highpass";
        sparkFilter.frequency.setValueAtTime(settings.filterFreq * 1.5, now + sparkDelay);
        sparkFilter.Q.setValueAtTime(1, now + sparkDelay);
        // Volume based on remaining health (lower health = louder impact)
        const healthFactor = Math.max(0.3, 1.0 - remainingHealth / 10); // Normalize health impact
        const sparkGain = this.audioContext.createGain();
        sparkGain.gain.setValueAtTime(settings.noiseGain * healthFactor, now + sparkDelay);
        sparkGain.gain.exponentialRampToValueAtTime(0.01, now + sparkDelay + sparkDuration);
        // Connect and play
        noiseSource.connect(sparkFilter);
        sparkFilter.connect(sparkGain);
        sparkGain.connect(this.game.masterGain);
        noiseSource.start(now + sparkDelay);
        noiseSource.stop(now + sparkDelay + sparkDuration);
        // Cleanup
        noiseSource.addEventListener("ended", ()=>{
            noiseSource.disconnect();
            sparkFilter.disconnect();
            sparkGain.disconnect();
        });
    }
}



var $azFtk = parcelRequire("azFtk");

// Sound parameters for different enemy sizes
const $5d78fa3449a4462a$var$EXPLOSION_SETTINGS = {
    interceptor: {
        baseFrequency: 400,
        duration: 0.2,
        volume: 0.2,
        noiseGain: 0.3,
        filterFreq: 1500
    },
    spiraler: {
        baseFrequency: 350,
        duration: 0.22,
        volume: 0.22,
        noiseGain: 0.35,
        filterFreq: 1350
    },
    ghost: {
        baseFrequency: 320,
        duration: 0.25,
        volume: 0.24,
        noiseGain: 0.4,
        filterFreq: 1300
    },
    zephyr: {
        baseFrequency: 800,
        duration: 0.4,
        volume: 0.35,
        noiseGain: 0.2,
        filterFreq: 2000
    },
    fighter: {
        baseFrequency: 300,
        duration: 0.25,
        volume: 0.25,
        noiseGain: 0.4,
        filterFreq: 1200
    },
    basic: {
        baseFrequency: 200,
        duration: 0.35,
        volume: 0.3,
        noiseGain: 0.5,
        filterFreq: 1000
    },
    bomber: {
        baseFrequency: 120,
        duration: 0.5,
        volume: 0.4,
        noiseGain: 0.6,
        filterFreq: 800
    },
    carrier: {
        baseFrequency: 80,
        duration: 0.7,
        volume: 0.5,
        noiseGain: 0.7,
        filterFreq: 600
    },
    boss: {
        baseFrequency: 60,
        duration: 1.0,
        volume: 0.6,
        noiseGain: 0.8,
        filterFreq: 500
    }
};
class $5d78fa3449a4462a$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super();
        this.tags = [
            "enemyDestroyedSoundGenerator"
        ];
        this.id = "enemyDestroyedSoundGenerator";
        // We'll get the audio context from the game when added
        this.audioContext = null;
    }
    onAdd() {
        if (!this.game?.audio) {
            console.warn("No audio context available in game");
            return;
        }
        this.audioContext = this.game.audio;
    }
    /**
   * Handle enemy destroyed events
   */ onEnemyDestroyed(eventData) {
        if (!this.audioContext || !this.game?.masterGain) return;
        this.synthesizeExplosionSound(eventData.enemyType);
    }
    synthesizeExplosionSound(enemyType) {
        const settings = $5d78fa3449a4462a$var$EXPLOSION_SETTINGS[enemyType] || $5d78fa3449a4462a$var$EXPLOSION_SETTINGS["basic"];
        const now = this.audioContext.currentTime;
        // Create main explosion components
        this.createExplosionBurst(now, settings);
        this.createExplosionTone(now, settings);
    }
    createExplosionBurst(now, settings) {
        // White noise burst for explosion texture
        const bufferSize = this.audioContext.sampleRate * settings.duration;
        const buffer = this.audioContext.createBuffer(1, bufferSize, this.audioContext.sampleRate);
        const data = buffer.getChannelData(0);
        // Generate white noise with envelope
        for(let i = 0; i < bufferSize; i++){
            const progress = i / bufferSize;
            const envelope = Math.pow(1 - progress, 2); // Exponential decay
            data[i] = (0, $azFtk.rUniform)(-1, 1) * envelope;
        }
        // Create buffer source
        const noiseSource = this.audioContext.createBufferSource();
        noiseSource.buffer = buffer;
        // Filter for tonal shaping
        const noiseFilter = this.audioContext.createBiquadFilter();
        noiseFilter.type = "bandpass";
        noiseFilter.frequency.setValueAtTime(settings.filterFreq, now);
        noiseFilter.Q.setValueAtTime(2, now);
        // Gain for volume control
        const noiseGain = this.audioContext.createGain();
        noiseGain.gain.setValueAtTime(settings.noiseGain, now);
        noiseGain.gain.exponentialRampToValueAtTime(0.01, now + settings.duration);
        // Connect and play
        noiseSource.connect(noiseFilter);
        noiseFilter.connect(noiseGain);
        noiseGain.connect(this.game.masterGain);
        noiseSource.start(now);
        noiseSource.stop(now + settings.duration);
        // Cleanup
        noiseSource.addEventListener("ended", ()=>{
            noiseSource.disconnect();
            noiseFilter.disconnect();
            noiseGain.disconnect();
        });
    }
    createExplosionTone(now, settings) {
        // Pitched tone for impact character
        const oscillator = this.audioContext.createOscillator();
        oscillator.type = "sawtooth"; // Aggressive sound
        // Filter for frequency shaping
        const filter = this.audioContext.createBiquadFilter();
        filter.type = "lowpass";
        filter.frequency.setValueAtTime(settings.filterFreq, now);
        filter.frequency.exponentialRampToValueAtTime(settings.filterFreq * 0.3, now + settings.duration);
        filter.Q.setValueAtTime(1, now);
        // Gain for volume envelope
        const gainNode = this.audioContext.createGain();
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime(settings.volume, now + 0.01); // Quick attack
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + settings.duration * 0.8); // Decay
        // Frequency sweep for explosion character
        const startFreq = settings.baseFrequency * 1.5;
        const endFreq = settings.baseFrequency * 0.5;
        oscillator.frequency.setValueAtTime(startFreq, now);
        oscillator.frequency.exponentialRampToValueAtTime(endFreq, now + settings.duration * 0.6);
        // Connect audio graph
        oscillator.connect(filter);
        filter.connect(gainNode);
        gainNode.connect(this.game.masterGain);
        // Start and stop
        oscillator.start(now);
        oscillator.stop(now + settings.duration);
        // Cleanup
        oscillator.addEventListener("ended", ()=>{
            oscillator.disconnect();
            filter.disconnect();
            gainNode.disconnect();
        });
    }
}



var $jd0t2 = parcelRequire("jd0t2");

var $azFtk = parcelRequire("azFtk");

// Sound parameters for different explosion types
const $7ca470daa47cdc6e$var$EXPLOSION_SETTINGS = {
    bomb: {
        baseFrequency: 80,
        duration: 0.8,
        volume: 0.4,
        noiseGain: 0.6,
        filterFreq: 400,
        subBassFreq: 40,
        subBassGain: 0.3
    },
    bigBomb: {
        baseFrequency: 60,
        duration: 1.2,
        volume: 0.5,
        noiseGain: 0.8,
        filterFreq: 300,
        subBassFreq: 30,
        subBassGain: 0.4
    },
    missile: {
        baseFrequency: 120,
        duration: 0.6,
        volume: 0.35,
        noiseGain: 0.5,
        filterFreq: 600,
        subBassFreq: 60,
        subBassGain: 0.2
    },
    bulletImpact: {
        baseFrequency: 300,
        duration: 0.2,
        volume: 0.1,
        noiseGain: 0.2,
        filterFreq: 1000,
        subBassFreq: 0,
        subBassGain: 0
    }
};
class $7ca470daa47cdc6e$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super();
        this.tags = [
            "explosionSoundGenerator"
        ];
        this.id = "explosionSoundGenerator";
        // We'll get the audio context from the game when added
        this.audioContext = null;
    }
    onAdd() {
        if (!this.game?.audio) {
            console.warn("No audio context available in game");
            return;
        }
        this.audioContext = this.game.audio;
    }
    /**
   * Handle explosion events
   */ onExplosion(eventData) {
        if (!this.audioContext || !this.game?.masterGain) return;
        this.synthesizeExplosionSound(eventData.explosionType, eventData.radius);
    }
    synthesizeExplosionSound(explosionType, radius) {
        const settings = $7ca470daa47cdc6e$var$EXPLOSION_SETTINGS[explosionType];
        const now = this.audioContext.currentTime;
        // Scale volume based on radius if provided
        const radiusScale = radius ? (0, $jd0t2.clamp)(radius / 30, 0, 2.0) : 1.0;
        const scaledVolume = settings.volume * radiusScale;
        // Create main explosion components
        this.createExplosionBoom(now, settings, scaledVolume);
        this.createExplosionRumble(now, settings, scaledVolume);
        if (settings.subBassFreq > 0) this.createSubBassImpact(now, settings, scaledVolume);
    }
    createExplosionBoom(now, settings, scaledVolume) {
        // Main explosion noise burst
        const bufferSize = this.audioContext.sampleRate * settings.duration;
        const buffer = this.audioContext.createBuffer(1, bufferSize, this.audioContext.sampleRate);
        const data = buffer.getChannelData(0);
        // Generate explosion noise with complex envelope
        for(let i = 0; i < bufferSize; i++){
            const progress = i / bufferSize;
            // Complex envelope: sharp attack, sustained body, gradual decay
            let envelope;
            if (progress < 0.05) // Sharp attack
            envelope = progress / 0.05;
            else if (progress < 0.3) // Sustained explosion body
            envelope = 1.0 - (progress - 0.05) * 0.2;
            else // Gradual decay
            envelope = 0.95 * Math.pow(1 - (progress - 0.3) / 0.7, 1.5);
            data[i] = (0, $azFtk.rUniform)(-1, 1) * envelope;
        }
        // Create buffer source
        const noiseSource = this.audioContext.createBufferSource();
        noiseSource.buffer = buffer;
        // Low-pass filter for explosion body
        const explosionFilter = this.audioContext.createBiquadFilter();
        explosionFilter.type = "lowpass";
        explosionFilter.frequency.setValueAtTime(settings.filterFreq * 2, now);
        explosionFilter.frequency.exponentialRampToValueAtTime(settings.filterFreq * 0.3, now + settings.duration);
        explosionFilter.Q.setValueAtTime(1, now);
        // Gain for volume control
        const noiseGain = this.audioContext.createGain();
        noiseGain.gain.setValueAtTime(scaledVolume * settings.noiseGain, now);
        // Connect and play
        noiseSource.connect(explosionFilter);
        explosionFilter.connect(noiseGain);
        noiseGain.connect(this.game.masterGain);
        noiseSource.start(now);
        noiseSource.stop(now + settings.duration);
        // Cleanup
        noiseSource.addEventListener("ended", ()=>{
            noiseSource.disconnect();
            explosionFilter.disconnect();
            noiseGain.disconnect();
        });
    }
    createExplosionRumble(now, settings, scaledVolume) {
        // Low-frequency rumble tone
        const oscillator = this.audioContext.createOscillator();
        oscillator.type = "sawtooth";
        // Filter for rumble character
        const rumbleFilter = this.audioContext.createBiquadFilter();
        rumbleFilter.type = "lowpass";
        rumbleFilter.frequency.setValueAtTime(settings.filterFreq, now);
        rumbleFilter.frequency.exponentialRampToValueAtTime(80, now + settings.duration);
        rumbleFilter.Q.setValueAtTime(2, now);
        // Gain envelope
        const gainNode = this.audioContext.createGain();
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime(scaledVolume * 0.5, now + 0.02); // Quick attack
        gainNode.gain.setValueAtTime(scaledVolume * 0.5, now + 0.1); // Brief sustain
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + settings.duration * 0.8);
        // Frequency modulation for unstable rumble
        const startFreq = settings.baseFrequency;
        oscillator.frequency.setValueAtTime(startFreq, now);
        // Add some frequency wobble
        const wobbleRate = 8; // Hz
        const wobbleAmount = startFreq * 0.1;
        for(let i = 0; i < 10; i++){
            const time = now + i * 0.1;
            const wobble = Math.sin(i * wobbleRate) * wobbleAmount;
            oscillator.frequency.setValueAtTime(startFreq + wobble, time);
        }
        // Connect audio graph
        oscillator.connect(rumbleFilter);
        rumbleFilter.connect(gainNode);
        gainNode.connect(this.game.masterGain);
        // Start and stop
        oscillator.start(now);
        oscillator.stop(now + settings.duration);
        // Cleanup
        oscillator.addEventListener("ended", ()=>{
            oscillator.disconnect();
            rumbleFilter.disconnect();
            gainNode.disconnect();
        });
    }
    createSubBassImpact(now, settings, scaledVolume) {
        // Very low frequency impact for large explosions
        const oscillator = this.audioContext.createOscillator();
        oscillator.type = "sine"; // Pure tone for sub-bass
        // Gain envelope for punch
        const gainNode = this.audioContext.createGain();
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime(scaledVolume * settings.subBassGain, now + 0.01); // Very fast attack
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + settings.duration * 0.5); // Quick decay
        // Sub-bass frequency
        oscillator.frequency.setValueAtTime(settings.subBassFreq, now);
        oscillator.frequency.exponentialRampToValueAtTime(settings.subBassFreq * 0.5, now + settings.duration * 0.3);
        // Connect directly to master (no filtering needed for sub-bass)
        oscillator.connect(gainNode);
        gainNode.connect(this.game.masterGain);
        // Start and stop
        oscillator.start(now);
        oscillator.stop(now + settings.duration * 0.5);
        // Cleanup
        oscillator.addEventListener("ended", ()=>{
            oscillator.disconnect();
            gainNode.disconnect();
        });
    }
}



var $biKyI = parcelRequire("biKyI");


var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $jd0t2 = parcelRequire("jd0t2");


var $cbsax = parcelRequire("cbsax");



function $75f7392647bba92f$export$7facb4053bb05489(entity) {
    return typeof entity.getShieldDamage === "function" && typeof entity.onShieldHit === "function";
}




var $hA6FJ = parcelRequire("hA6FJ");

var $3of0i = parcelRequire("3of0i");

var $jd0t2 = parcelRequire("jd0t2");


var $cbsax = parcelRequire("cbsax");





// TODO: Import this directly. Can't right now due to circular dependency issues
const $d3f2648ce3bb7524$var$SHIELD_RADIUS = 40;
// Pulse visual constants
const $d3f2648ce3bb7524$var$SIDES = 32;
const $d3f2648ce3bb7524$var$PULSE_SIZE = 40; // Amount to expand radius
const $d3f2648ce3bb7524$var$MIN_RADIUS = $d3f2648ce3bb7524$var$SHIELD_RADIUS;
const $d3f2648ce3bb7524$var$MAX_RADIUS = $d3f2648ce3bb7524$var$SHIELD_RADIUS + $d3f2648ce3bb7524$var$PULSE_SIZE;
const $d3f2648ce3bb7524$var$DURATION = 0.15; // seconds
const $d3f2648ce3bb7524$var$INITIAL_STROKE_WIDTH = 1;
const $d3f2648ce3bb7524$var$FINAL_STROKE_WIDTH = 1;
const $d3f2648ce3bb7524$var$MAX_IMPULSE = 20000;
const $d3f2648ce3bb7524$var$INITIAL_ALPHA = 0.5;
class $d3f2648ce3bb7524$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(impactPosition){
        super();
        this.tags = [
            "shieldPulse",
            "effect"
        ];
        // Create initial pulse ring
        const initialPoints = (0, $aa0a0f3c701f5a9a$export$e636e17021965266)($d3f2648ce3bb7524$var$SIDES, $d3f2648ce3bb7524$var$MIN_RADIUS);
        this.pulseRenderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(initialPoints, (0, $hA6FJ.Colors).WHITE, $d3f2648ce3bb7524$var$INITIAL_STROKE_WIDTH);
        this.pulseRenderer.setAlpha($d3f2648ce3bb7524$var$INITIAL_ALPHA);
        this.pulseRenderer.addFilter(new (0, $96a77950dbebc930$export$761854c12ba66091)((segments, context)=>segments.map((segment)=>{
                const t = context.t ?? 0; // Use context t or default to 0
                const scale = (0, $jd0t2.lerp)(1, $d3f2648ce3bb7524$var$MAX_RADIUS / $d3f2648ce3bb7524$var$MIN_RADIUS, t ** 0.5);
                return {
                    ...segment,
                    color: (0, $3of0i.colorLerp)((0, $hA6FJ.Colors).WHITE, (0, $4f09d4bcf4dda17d$export$b0165e911d653b8a), t),
                    alpha: (0, $jd0t2.lerp)($d3f2648ce3bb7524$var$INITIAL_ALPHA, 0, t ** 2),
                    thickness: (0, $jd0t2.lerp)($d3f2648ce3bb7524$var$INITIAL_STROKE_WIDTH, $d3f2648ce3bb7524$var$FINAL_STROKE_WIDTH, t ** 2),
                    start: segment.start.mul(scale),
                    end: segment.start.mul(scale)
                };
            }), $d3f2648ce3bb7524$var$DURATION));
        this.pulseRenderer.setPosition(impactPosition);
        this.addChild(this.pulseRenderer);
    }
    async onAdd() {
        // Apply impulse effect immediately when added
        this.applyImpulseEffect();
        await this.waitRender($d3f2648ce3bb7524$var$DURATION);
        this.destroy();
    }
    applyImpulseEffect() {
        if (!this.game) return;
        // Get entities that can be pushed - filter entities with bodies for shield damagers
        const pushableEntities = Array.from(this.game.entities.withBody).filter((0, $75f7392647bba92f$export$7facb4053bb05489));
        const pulsePosition = (0, $cbsax.V)(0, 0); // shield position
        for (const entity of pushableEntities){
            // Get entity position from physics body (no sketchy casting)
            const entityPosition = (0, $cbsax.V)(entity.body.position);
            // Calculate distance using Vector math
            // Note: This is distance to entity center, not edge. For more precision,
            // we could subtract shield radius (~40px) from impact distance.
            const distance = entityPosition.sub(pulsePosition).magnitude;
            // Only affect entities within impulse radius
            if (distance <= $d3f2648ce3bb7524$var$MAX_RADIUS && distance > 0) {
                // Calculate impulse direction (away from pulse center)
                const impulseDirection = entityPosition.sub(pulsePosition).normalize();
                // Calculate impulse strength (stronger when closer)
                const impulseStrength = $d3f2648ce3bb7524$var$MAX_IMPULSE * (1 - distance / $d3f2648ce3bb7524$var$MAX_RADIUS);
                // Apply the impulse force
                const impulseForce = impulseDirection.mul(impulseStrength);
                entity.body.applyImpulse(impulseForce);
            }
        }
    }
}


const $4f09d4bcf4dda17d$export$b0165e911d653b8a = (0, $hA6FJ.Colors).CYAN;
const $4f09d4bcf4dda17d$export$af292d740dac792b = 40;
const $4f09d4bcf4dda17d$var$SHIELD_SIDES = 24;
const $4f09d4bcf4dda17d$var$SHIELD_BASE_STROKE_WIDTH = 1;
const $4f09d4bcf4dda17d$var$SHIELD_MAX_STROKE_WIDTH = 3.5;
const $4f09d4bcf4dda17d$var$SHIELD_HEALTH_THRESHOLD_LOW = 0.3;
const $4f09d4bcf4dda17d$var$SHIELD_DEFAULT_ALPHA = 1.0;
const $4f09d4bcf4dda17d$var$SHIELD_HEALTH = 50;
// Hit effect constants
const $4f09d4bcf4dda17d$var$SHIELD_HIT_EFFECT_DURATION = 0.15; // seconds - used for flash, thickness, and invulnerability
const $4f09d4bcf4dda17d$var$SHIELD_HIT_THICKNESS_MULTIPLIER = 2.5; // Relative thickness boost when hit
const $4f09d4bcf4dda17d$var$SHIELD_FLICKER_FREQUENCY = 8; // flickers per second when low health
// Wobble effect constants
const $4f09d4bcf4dda17d$var$SHIELD_WOBBLE_AMPLITUDE = 0.15; // Very subtle wobble for alive feel
const $4f09d4bcf4dda17d$var$SHIELD_WOBBLE_FREQUENCY = 1.0; // Slower, gentler wobble
// Shield dust explosion constants
const $4f09d4bcf4dda17d$var$SHIELD_DUST_PARTICLE_COUNT = 40;
const $4f09d4bcf4dda17d$var$SHIELD_DUST_EXPLOSION_SPEED = 80;
/**
 * Create shield shape - circular-looking polygon with consistent shield color
 */ function $4f09d4bcf4dda17d$var$createShieldShape() {
    return {
        points: (0, $aa0a0f3c701f5a9a$export$e636e17021965266)($4f09d4bcf4dda17d$var$SHIELD_SIDES, $4f09d4bcf4dda17d$export$af292d740dac792b),
        color: $4f09d4bcf4dda17d$export$b0165e911d653b8a,
        secondaryColor: $4f09d4bcf4dda17d$export$b0165e911d653b8a
    };
}
/**
 * Get the color of a damager entity for dust explosion effects
 */ function $4f09d4bcf4dda17d$var$getDamagerColor(damager) {
    // Try to get color from various entity types
    if (damager && typeof damager === "object" && "getVisualConfig" in damager) return damager.getVisualConfig?.().shape?.color || (0, $hA6FJ.Colors).WHITE;
    return (0, $hA6FJ.Colors).WHITE; // Default fallback
}
class $4f09d4bcf4dda17d$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super(), // Shield state management
        this.maxHealth = $4f09d4bcf4dda17d$var$SHIELD_HEALTH, this.currentHealth = $4f09d4bcf4dda17d$var$SHIELD_HEALTH, // Hit effect timing
        this.isInvulnerable = false;
        this.tags = [
            "shield"
        ];
        // Get shield shape and create renderer with base thickness
        const shieldShape = $4f09d4bcf4dda17d$var$createShieldShape();
        this.shieldRenderer = this.addChild((0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(shieldShape.points, shieldShape.color, $4f09d4bcf4dda17d$var$SHIELD_BASE_STROKE_WIDTH));
        this.shieldRenderer.setAlpha($4f09d4bcf4dda17d$var$SHIELD_DEFAULT_ALPHA);
        // Set thickness based on health
        this.shieldRenderer.addFilter(new (0, $96a77950dbebc930$export$761854c12ba66091)((0, $511204bfc17c1b95$export$8169ab519a488f4b)(()=>{
            return (0, $jd0t2.lerp)($4f09d4bcf4dda17d$var$SHIELD_BASE_STROKE_WIDTH, $4f09d4bcf4dda17d$var$SHIELD_MAX_STROKE_WIDTH, this.currentHealth / this.maxHealth);
        })));
        // Create and add flicker filter
        this.flickerFilter = this.shieldRenderer.addFilter(new (0, $6224414522095aec$export$5d7fbc7579ec29d0)($4f09d4bcf4dda17d$var$SHIELD_FLICKER_FREQUENCY, 0.3));
        // Add gentle wobble for alive feel
        this.shieldRenderer.addFilter(new (0, $96a77950dbebc930$export$761854c12ba66091)((0, $511204bfc17c1b95$export$2faa1da9a27daaca)($4f09d4bcf4dda17d$var$SHIELD_WOBBLE_AMPLITUDE, $4f09d4bcf4dda17d$var$SHIELD_WOBBLE_FREQUENCY)));
        // Add physics body for collision detection
        this.body = new (0, $biKyI.Body)({
            mass: 0,
            type: (0, $biKyI.Body).STATIC
        });
        const shape = new (0, $biKyI.Circle)({
            radius: $4f09d4bcf4dda17d$export$af292d740dac792b
        });
        shape.collisionGroup = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Turret");
        shape.collisionMask = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Bomb", "Enemy");
        this.body.addShape(shape);
        this.body.position = [
            0,
            0
        ];
    }
    onBeginContact({ other: other }) {
        if ((0, $75f7392647bba92f$export$7facb4053bb05489)(other)) {
            // Get positions for effects
            const shieldPosition = this.getPosition();
            const damagerPosition = other instanceof (0, $2oYNi.default) ? other.getPosition() : (0, $cbsax.V)(0, 0);
            const outwardDirection = damagerPosition.sub(shieldPosition).normalize();
            // Always create dust explosion and handle damager response
            this.createDustExplosion(damagerPosition, outwardDirection, other);
            other.onShieldHit();
            if (!this.isInvulnerable) {
                // Full hit response: damage + effects
                const damage = other.getShieldDamage();
                this.takeDamage(damage);
                this.applyHitEffects();
                this.getCurrentLevel()?.addChild(new (0, $d3f2648ce3bb7524$export$2e2bcd8739ae039)(this.getPosition()));
            }
        }
    }
    takeDamage(damage) {
        if (!this.game) return;
        this.currentHealth = (0, $jd0t2.clampUp)(this.currentHealth - damage);
        const healthPercent = this.currentHealth / this.maxHealth;
        // Update flicker intensity based on health percentage
        this.updateFlickerIntensity(healthPercent);
        if (this.currentHealth <= 0) this.die();
    }
    createDustExplosion(damagerPosition, outwardDirection, damager) {
        const shieldColor = $4f09d4bcf4dda17d$export$b0165e911d653b8a;
        const damagerColor = $4f09d4bcf4dda17d$var$getDamagerColor(damager);
        this.getCurrentLevel()?.addChild(new (0, $7c2e27e1fc77ebd1$export$79ac126fea2e1154)({
            position: damagerPosition,
            colors: [
                shieldColor,
                damagerColor
            ],
            particleCount: $4f09d4bcf4dda17d$var$SHIELD_DUST_PARTICLE_COUNT,
            explosionSpeed: $4f09d4bcf4dda17d$var$SHIELD_DUST_EXPLOSION_SPEED,
            direction: outwardDirection
        }));
    }
    applyHitEffects() {
        if (!this.game) return;
        // Apply flash and thicken effects using single VectorFilter (like Asteroid.ts)
        this.shieldRenderer.addFilter(new (0, $96a77950dbebc930$export$761854c12ba66091)([
            (0, $511204bfc17c1b95$export$2eef470e6a9eaa50)((0, $hA6FJ.Colors).WHITE),
            (0, $511204bfc17c1b95$export$8169ab519a488f4b)((oldThickness)=>oldThickness * $4f09d4bcf4dda17d$var$SHIELD_HIT_THICKNESS_MULTIPLIER)
        ], $4f09d4bcf4dda17d$var$SHIELD_HIT_EFFECT_DURATION));
        // Start invulnerability period using BaseEntity timer
        this.isInvulnerable = true;
        this.wait($4f09d4bcf4dda17d$var$SHIELD_HIT_EFFECT_DURATION).then(()=>{
            this.isInvulnerable = false;
        });
    }
    updateFlickerIntensity(healthPercent) {
        // Calculate flicker intensity based on how low health is
        // 0 intensity when above threshold, 1.0 intensity when at 0 health
        if (healthPercent >= $4f09d4bcf4dda17d$var$SHIELD_HEALTH_THRESHOLD_LOW) this.flickerFilter.intensity = 0; // No flicker when healthy
        else // Linear interpolation: full health at threshold = 0 intensity, 0 health = 1.0 intensity
        this.flickerFilter.intensity = 1 - healthPercent / $4f09d4bcf4dda17d$var$SHIELD_HEALTH_THRESHOLD_LOW;
    }
    die() {
        console.log("Shield destroyed! Game Over!");
        // Dispatch game over event
        this.dispatch("gameOver", {});
        this.destroy();
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $jd0t2 = parcelRequire("jd0t2");


var $cbsax = parcelRequire("cbsax");



var $biKyI = parcelRequire("biKyI");


var $hA6FJ = parcelRequire("hA6FJ");


var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");







// Bullet constants
const $1e64ab7d5b0f964b$var$DEFAULT_BULLET_LIFETIME = 3.0; // seconds
const $1e64ab7d5b0f964b$var$DEFAULT_BULLET_DAMAGE = 1;
// Bullet impact shape constants
const $1e64ab7d5b0f964b$var$BULLET_IMPACT_SIZE = 3;
const $1e64ab7d5b0f964b$var$BULLET_IMPACT_SIDES = 6;
/**
 * Create a small bullet impact shape - a hexagon with random rotation
 */ function $1e64ab7d5b0f964b$var$createBulletImpactShape(color) {
    // Add random rotation offset
    const rotationOffset = (0, $azFtk.rDirection)();
    return {
        points: (0, $aa0a0f3c701f5a9a$export$e636e17021965266)($1e64ab7d5b0f964b$var$BULLET_IMPACT_SIDES, $1e64ab7d5b0f964b$var$BULLET_IMPACT_SIZE, rotationOffset),
        color: color,
        secondaryColor: color
    };
}
const $1e64ab7d5b0f964b$var$DEFAULT_BULLET_SPEED = 300; // pixels per second
const $1e64ab7d5b0f964b$var$BULLET_MASS = 0.03; // physics mass
const $1e64ab7d5b0f964b$var$BULLET_COLLISION_RADIUS = 2; // collision detection radius
const $1e64ab7d5b0f964b$var$BULLET_VISUAL_HALF_WIDTH = 6; // half width of bullet visual sprite
const $1e64ab7d5b0f964b$var$BULLET_STROKE_WIDTH = 1; // stroke width for bullet sprite
// Bullet impact explosion constants
const $1e64ab7d5b0f964b$var$BULLET_IMPACT_LIFETIME = 0.2;
const $1e64ab7d5b0f964b$var$BULLET_IMPACT_VELOCITY_SCALE = 25;
// Dust explosion constants
const $1e64ab7d5b0f964b$var$DUST_PARTICLE_COUNT = 5;
const $1e64ab7d5b0f964b$var$DUST_EXPLOSION_SPEED = 40;
/**
 * Get the primary color of a target entity for dust explosion effects
 */ function $1e64ab7d5b0f964b$var$getTargetColor(target) {
    if (target instanceof (0, $64cf1b418814e07b$export$b52f0fdf00738bd0)) return target.config.visualConfig.color;
    if (target instanceof (0, $488d8131288bea22$export$2e2bcd8739ae039)) return (0, $hA6FJ.Colors).WHITE; // Asteroids use white color
    return (0, $hA6FJ.Colors).ORANGE; // Default fallback color
}
class $1e64ab7d5b0f964b$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(position, direction, speed = $1e64ab7d5b0f964b$var$DEFAULT_BULLET_SPEED, damage = $1e64ab7d5b0f964b$var$DEFAULT_BULLET_DAMAGE){
        super(), this.lifetime = $1e64ab7d5b0f964b$var$DEFAULT_BULLET_LIFETIME, this.damage = $1e64ab7d5b0f964b$var$DEFAULT_BULLET_DAMAGE;
        // Create line segment renderer for bullet visual
        this.renderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromSegments([
            {
                start: (0, $cbsax.V)(-$1e64ab7d5b0f964b$var$BULLET_VISUAL_HALF_WIDTH, 0),
                end: (0, $cbsax.V)($1e64ab7d5b0f964b$var$BULLET_VISUAL_HALF_WIDTH, 0),
                color: (0, $hA6FJ.Colors).YELLOW,
                thickness: $1e64ab7d5b0f964b$var$BULLET_STROKE_WIDTH
            }
        ]);
        this.addChild(this.renderer);
        this.body = new (0, $biKyI.Body)({
            mass: $1e64ab7d5b0f964b$var$BULLET_MASS
        });
        const shape = new (0, $biKyI.Circle)({
            radius: $1e64ab7d5b0f964b$var$BULLET_COLLISION_RADIUS
        });
        shape.collisionGroup = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Bullet");
        shape.collisionMask = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Enemy", "Bomb");
        this.body.addShape(shape);
        this.body.position = [
            position.x,
            position.y
        ];
        const velocity = direction.normalize().imul(speed);
        this.body.velocity = velocity;
        this.damage = damage;
    }
    onTick(dt) {
        this.lifetime -= dt;
        if (this.lifetime <= 0) this.destroy();
    }
    onRender(dt) {
        if (this.body && this.renderer) {
            this.renderer.setPosition(this.body.position);
            // Rotate sprite to match bullet direction
            const velocity = (0, $cbsax.V)(this.body.velocity);
            this.renderer.setRotation(velocity.angle);
        }
    }
    onBeginContact({ other: other }) {
        if (!this.body) return;
        if ((0, $dcc338a8816f0aac$export$7aa19ba7efd56036)(other)) {
            // Dispatch explosion event for sound effects
            this.dispatch("explosion", {
                explosionType: "bulletImpact",
                position: {
                    x: this.body.position[0],
                    y: this.body.position[1]
                },
                radius: 5,
                lifetime: $1e64ab7d5b0f964b$var$BULLET_IMPACT_LIFETIME
            });
            // Create bullet impact explosion using bullet color (no velocity inheritance for impacts)
            const impactShape = $1e64ab7d5b0f964b$var$createBulletImpactShape((0, $hA6FJ.Colors).YELLOW);
            this.getCurrentLevel()?.addChild(new (0, $3427e84844ca2b22$export$2e2bcd8739ae039)({
                position: (0, $cbsax.V)(this.body.position),
                polygon: impactShape.points,
                color: impactShape.color,
                lifetime: $1e64ab7d5b0f964b$var$BULLET_IMPACT_LIFETIME,
                velocityScale: $1e64ab7d5b0f964b$var$BULLET_IMPACT_VELOCITY_SCALE
            }));
            // Create dust explosion using both bullet and target colors
            const bulletColor = (0, $hA6FJ.Colors).YELLOW; // Current bullet color
            const targetColor = $1e64ab7d5b0f964b$var$getTargetColor(other);
            const dustExplosion = new (0, $7c2e27e1fc77ebd1$export$79ac126fea2e1154)({
                position: (0, $cbsax.V)(this.body.position),
                colors: [
                    bulletColor,
                    targetColor
                ],
                particleCount: $1e64ab7d5b0f964b$var$DUST_PARTICLE_COUNT,
                explosionSpeed: $1e64ab7d5b0f964b$var$DUST_EXPLOSION_SPEED
            });
            // Add dust explosion to the current level
            this.getCurrentLevel()?.addChild(dustExplosion);
            // Hit the target and destroy the bullet
            other.takeHit(this.damage, (0, $dcc338a8816f0aac$export$31e26a3201c91bbb).Bullet);
            this.destroy();
        }
    }
}



var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");

const $7b92ca9e973a94a8$var$LASER_BASE_FREQUENCY = 200; // Hz
const $7b92ca9e973a94a8$var$LASER_FREQUENCY_SWEEP = 600; // Hz sweep range
const $7b92ca9e973a94a8$var$LASER_DURATION = 0.05; // seconds
const $7b92ca9e973a94a8$var$LASER_VOLUME = 0.15; // volume level
const $7b92ca9e973a94a8$var$LOWPASS_START_FREQUENCY = 1800;
const $7b92ca9e973a94a8$var$LOWPASS_END_FREQUENCY = 400;
class $7b92ca9e973a94a8$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    /**
   * Override getPosition to return parent's position since sound generators don't have their own position
   */ getPosition() {
        if (this.parent && "getPosition" in this.parent) return this.parent.getPosition();
        return (0, $cbsax.V)(0, 0);
    }
    /**
   * Called by the turret when it fires a shot
   */ onShoot() {
        if (!this.game?.audio || !this.game?.masterGain) return;
        this.synthesizeLaserSound();
    }
    synthesizeLaserSound() {
        if (!this.game?.audio || !this.game?.masterGain) return;
        const ctx = this.game.audio;
        const now = ctx.currentTime;
        // Create oscillator for the main laser tone
        const oscillator = ctx.createOscillator();
        oscillator.type = "square"; // Classic arcade sound
        // Create gain node for volume control
        const gainNode = ctx.createGain();
        // Create filter for tonal shaping
        const filter = ctx.createBiquadFilter();
        filter.type = "lowpass";
        filter.frequency.setValueAtTime($7b92ca9e973a94a8$var$LOWPASS_START_FREQUENCY, now);
        filter.Q.setValueAtTime(1, now);
        // Connect audio graph: oscillator -> filter -> gain -> master
        oscillator.connect(filter);
        filter.connect(gainNode);
        gainNode.connect(this.game.masterGain);
        // Frequency sweep: start high, sweep down quickly
        const startFreq = ($7b92ca9e973a94a8$var$LASER_BASE_FREQUENCY + $7b92ca9e973a94a8$var$LASER_FREQUENCY_SWEEP) * (0, $azFtk.rNormal)(1, 0.1);
        const endFreq = $7b92ca9e973a94a8$var$LASER_BASE_FREQUENCY * (0, $azFtk.rNormal)(1, 0.1);
        oscillator.frequency.setValueAtTime(startFreq * (0, $azFtk.rNormal)(1, 0.1), now);
        oscillator.frequency.exponentialRampToValueAtTime(endFreq * (0, $azFtk.rNormal)(1, 0.1), now + $7b92ca9e973a94a8$var$LASER_DURATION * 0.7);
        // Volume envelope: quick attack, moderate decay
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime($7b92ca9e973a94a8$var$LASER_VOLUME, now + 0.01); // 10ms attack
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + $7b92ca9e973a94a8$var$LASER_DURATION); // decay to near zero
        // Filter sweep for extra character
        filter.frequency.exponentialRampToValueAtTime($7b92ca9e973a94a8$var$LOWPASS_END_FREQUENCY, now + $7b92ca9e973a94a8$var$LASER_DURATION);
        // Start and stop the oscillator
        oscillator.start(now);
        oscillator.stop(now + $7b92ca9e973a94a8$var$LASER_DURATION);
        // Clean up nodes after sound finishes
        oscillator.addEventListener("ended", ()=>{
            oscillator.disconnect();
            gainNode.disconnect();
            filter.disconnect();
        });
    }
    constructor(...args){
        super(...args), this.tags = [
            "turretSoundGenerator"
        ];
    }
}


// Turret constants
const $fa5e78094187c70e$var$DEFAULT_FIRE_RATE = 0.08; // seconds between shots
const $fa5e78094187c70e$var$RAPID_FIRE_MULTIPLIER = 0.5; // multiplier for rapid fire upgrade
const $fa5e78094187c70e$var$SPRITE_STROKE_WIDTH = 2; // stroke width for turret rendering
// Damage constants
const $fa5e78094187c70e$var$BASE_DAMAGE = 1; // base bullet damage
const $fa5e78094187c70e$var$DAMAGE_BOOST_1_MULTIPLIER = 1.5; // 50% more damage
const $fa5e78094187c70e$var$DAMAGE_BOOST_2_MULTIPLIER = 2.0; // 100% more damage
const $fa5e78094187c70e$var$BULLET_SPEED = 500; // bullet speed in units per second
// Rotation constants
const $fa5e78094187c70e$var$ROTATION_LERP_FACTOR = 8; // higher = faster rotation response
const $fa5e78094187c70e$var$MAX_ROTATION_SPEED = 6; // maximum radians per second
// Turret visual shape constants
const $fa5e78094187c70e$var$TURRET_SIDES = 6;
const $fa5e78094187c70e$var$TURRET_RADIUS = 5;
const $fa5e78094187c70e$var$TURRET_BARREL_LENGTH = 10;
const $fa5e78094187c70e$var$TURRET_BARREL_HALF_WIDTH = 1;
/**
 * Create a turret shape - hexagon
 */ function $fa5e78094187c70e$var$createTurretShape() {
    return {
        points: (0, $aa0a0f3c701f5a9a$export$e636e17021965266)($fa5e78094187c70e$var$TURRET_SIDES, $fa5e78094187c70e$var$TURRET_RADIUS),
        color: (0, $hA6FJ.Colors).CYAN,
        secondaryColor: (0, $hA6FJ.Colors).CYAN
    };
}
/**
 * Create a turret barrel shape - simple rectangle
 */ function $fa5e78094187c70e$var$createTurretBarrelShape() {
    return {
        points: [
            (0, $cbsax.V)(0, -$fa5e78094187c70e$var$TURRET_BARREL_HALF_WIDTH),
            (0, $cbsax.V)($fa5e78094187c70e$var$TURRET_BARREL_LENGTH, -$fa5e78094187c70e$var$TURRET_BARREL_HALF_WIDTH),
            (0, $cbsax.V)($fa5e78094187c70e$var$TURRET_BARREL_LENGTH, $fa5e78094187c70e$var$TURRET_BARREL_HALF_WIDTH),
            (0, $cbsax.V)(0, $fa5e78094187c70e$var$TURRET_BARREL_HALF_WIDTH)
        ],
        color: (0, $hA6FJ.Colors).WHITE,
        secondaryColor: (0, $hA6FJ.Colors).WHITE
    };
}
class $fa5e78094187c70e$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super(), this.lastShotTime = 0, this.fireRate = $fa5e78094187c70e$var$DEFAULT_FIRE_RATE, // Rotation system
        this.currentRotation = 0, this.targetRotation = 0;
        this.tags = [
            "turret"
        ];
        // Get turret shapes
        const bodyShape = $fa5e78094187c70e$var$createTurretShape();
        const barrelShape = $fa5e78094187c70e$var$createTurretBarrelShape();
        // Create line segment renderers for visual representation
        this.bodyRenderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(bodyShape.points, bodyShape.color, $fa5e78094187c70e$var$SPRITE_STROKE_WIDTH);
        this.barrelRenderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(barrelShape.points, barrelShape.color, $fa5e78094187c70e$var$SPRITE_STROKE_WIDTH);
        // Add renderers as children
        this.addChild(this.bodyRenderer);
        this.addChild(this.barrelRenderer);
        // Create sound generator as a child entity
        this.soundGenerator = new (0, $7b92ca9e973a94a8$export$2e2bcd8739ae039)();
        this.addChild(this.soundGenerator);
    }
    onRender(dt) {
        // Position renderers at turret location
        const position = this.getPosition();
        this.bodyRenderer.setPosition(position);
        this.barrelRenderer.setPosition(position);
    }
    onTick(dt) {
        if (!this.game) return;
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        const direction = mouseWorldPos.sub(this.getPosition());
        // Update target rotation based on mouse position
        this.targetRotation = direction.angle;
        // Smooth rotation towards target with exponential easing and speed limit
        const angleDiff = (0, $jd0t2.angleDelta)(this.currentRotation, this.targetRotation);
        const lerpFactor = 1 - Math.exp(-$fa5e78094187c70e$var$ROTATION_LERP_FACTOR * dt);
        const desiredRotationChange = angleDiff * lerpFactor;
        // Clamp rotation speed to maximum
        const maxRotationChange = $fa5e78094187c70e$var$MAX_ROTATION_SPEED * dt;
        const clampedRotationChange = (0, $jd0t2.clamp)(desiredRotationChange, -maxRotationChange, maxRotationChange);
        this.currentRotation += clampedRotationChange;
        // Apply rotation to both renderers
        this.bodyRenderer.setRotation(this.currentRotation);
        this.barrelRenderer.setRotation(this.currentRotation);
        // Apply rapid fire upgrade
        const upgradeManager = this.game.entities.getById("upgradeManager");
        const effectiveFireRate = upgradeManager?.has("rapidFire") ? this.fireRate * $fa5e78094187c70e$var$RAPID_FIRE_MULTIPLIER : this.fireRate;
        // Auto-fire - no need to hold mouse button
        // Only shoot if there are enemies
        const enemies = this.game.entities.getTagged("levelEntity");
        if (enemies.length > 0 && this.game.elapsedTime - this.lastShotTime > effectiveFireRate) {
            const shootDirection = (0, $jd0t2.polarToVec)(this.currentRotation, direction.magnitude);
            this.shoot(shootDirection);
            this.lastShotTime = this.game.elapsedTime;
        }
    }
    getPosition() {
        // Return position from the body renderer
        return this.bodyRenderer.getPosition();
    }
    shoot(direction) {
        // Calculate damage based on purchased upgrades
        const upgradeManager = this.game?.entities.getById("upgradeManager");
        let damageMultiplier = 1;
        if (upgradeManager?.has("damageBoost1")) damageMultiplier = $fa5e78094187c70e$var$DAMAGE_BOOST_1_MULTIPLIER; // 50% more damage
        if (upgradeManager?.has("damageBoost2")) damageMultiplier = $fa5e78094187c70e$var$DAMAGE_BOOST_2_MULTIPLIER; // 100% more damage (replaces level 1)
        const baseDamage = $fa5e78094187c70e$var$BASE_DAMAGE;
        const finalDamage = baseDamage * damageMultiplier;
        const bullet = new (0, $1e64ab7d5b0f964b$export$2e2bcd8739ae039)(this.getPosition(), direction, $fa5e78094187c70e$var$BULLET_SPEED, finalDamage);
        // Add bullet to the current level
        this.getCurrentLevel()?.addChild(bullet);
        // Trigger sound effect
        this.soundGenerator.onShoot();
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $c4Qw3 = parcelRequire("c4Qw3");

var $cbsax = parcelRequire("cbsax");


class $6478774c9b3a419d$export$1949f3e5f26776fe extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(){
        super(), this.pausable = false;
        this.sprite = (0, $c4Qw3.createGraphics)("cursor");
    }
    onTick() {
        if (!this.game) return;
        // Convert turret position (world origin) to screen coordinates
        const turretScreenPos = this.game.camera.toScreen((0, $cbsax.V)(0, 0));
        // Mouse position is already in screen coordinates
        const mouseScreenPos = this.game.io.mousePosition;
        // Calculate direction vector from turret to mouse
        const direction = (0, $cbsax.V)(mouseScreenPos.x - turretScreenPos.x, mouseScreenPos.y - turretScreenPos.y);
        const directionNormalized = direction.normalize();
        // Start line just past the shield radius
        const shieldScreenRadius = (0, $4f09d4bcf4dda17d$export$af292d740dac792b) * this.game.camera.z;
        const startPos = (0, $cbsax.V)(turretScreenPos.x + directionNormalized.x * shieldScreenRadius, turretScreenPos.y + directionNormalized.y * shieldScreenRadius);
        // Extend line to screen edge
        const [screenWidth, screenHeight] = this.game.camera.getViewportSize();
        const maxDistance = Math.max(screenWidth, screenHeight) * 2; // Ensure it reaches edge
        const endPos = (0, $cbsax.V)(startPos.x + directionNormalized.x * maxDistance, startPos.y + directionNormalized.y * maxDistance);
        this.sprite.clear();
        // Create dotted line by drawing multiple small segments
        const dashLength = 8;
        const gapLength = 6;
        const totalDistance = startPos.sub(endPos).magnitude;
        for(let distance = 0; distance < totalDistance; distance += dashLength + gapLength){
            const segmentStart = (0, $cbsax.V)(startPos.x + directionNormalized.x * distance, startPos.y + directionNormalized.y * distance);
            const segmentEnd = (0, $cbsax.V)(startPos.x + directionNormalized.x * Math.min(distance + dashLength, totalDistance), startPos.y + directionNormalized.y * Math.min(distance + dashLength, totalDistance));
            this.sprite.moveTo(segmentStart.x, segmentStart.y).lineTo(segmentEnd.x, segmentEnd.y).stroke({
                color: (0, $hA6FJ.Colors).CYAN,
                width: (0, $hA6FJ.LineArt).LINE_WIDTH.STANDARD,
                alpha: 0.6
            });
        }
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $cbsax = parcelRequire("cbsax");


const $b4153caf44c479c0$var$DURATION = 3;
const $b4153caf44c479c0$var$FADE_OUT_DURATION = 1;
class $b4153caf44c479c0$export$3ba95a887317c488 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    constructor(levelNumber){
        super();
        // Text will be set in onAdd when we have access to the current level
        this.levelText = this.addChild(new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: `LEVEL ${levelNumber}`,
            scale: 4,
            color: (0, $hA6FJ.Colors).CYAN,
            strokeWidth: 3,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            layer: "ui"
        }));
    }
    async onAdd() {
        await this.wait($b4153caf44c479c0$var$DURATION);
        await this.waitRender($b4153caf44c479c0$var$FADE_OUT_DURATION, (dt, t)=>{
            this.levelText.textSprite.alpha = 1 - t;
        });
        await this.wait(); // one more frame to ensure the text is fully faded out
        this.destroy();
    }
    onRender() {
        const viewportSize = this.game.camera.getViewportSize();
        const centerX = viewportSize.x / 2;
        const upperY = viewportSize.y * 0.25;
        this.levelText.position = new (0, $cbsax.V2d)(centerX, upperY);
    }
}



var $azFtk = parcelRequire("azFtk");




var $biKyI = parcelRequire("biKyI");


var $hA6FJ = parcelRequire("hA6FJ");

var $cbsax = parcelRequire("cbsax");



// Bomb physics constants
const $a6431f147b47ae9b$var$BOMB_RADIUS = 4;
const $a6431f147b47ae9b$var$BOMB_MASS = 0.5;
const $a6431f147b47ae9b$var$INITIAL_VELOCITY_MULTIPLIER = 2;
// Bomb rendering constants
const $a6431f147b47ae9b$var$BOMB_POLYGON_POINTS = 8;
const $a6431f147b47ae9b$var$BOMB_STROKE_WIDTH = 1;
const $a6431f147b47ae9b$var$BOMB_ROTATION_SPEED = 0.05;
// Bomb explosion constants
const $a6431f147b47ae9b$var$BOMB_EXPLOSION_RADIUS = 25;
const $a6431f147b47ae9b$var$BOMB_EXPLOSION_LIFETIME = 1.2;
const $a6431f147b47ae9b$var$BOMB_DAMAGE = 10;
class $a6431f147b47ae9b$export$c5a0ca915ee7870f extends (0, $f99fab462ba2bee7$export$ebb779659660811c) {
    constructor(position){
        super(position), this.munitionType = (0, $f99fab462ba2bee7$export$4b63755fcb155410).BOMB, this.damage = $a6431f147b47ae9b$var$BOMB_DAMAGE;
        this.tags = [
            "bomb",
            "levelEntity"
        ];
    }
    createBody(position) {
        const body = new (0, $biKyI.Body)({
            mass: $a6431f147b47ae9b$var$BOMB_MASS
        });
        const shape = new (0, $biKyI.Circle)({
            radius: $a6431f147b47ae9b$var$BOMB_RADIUS
        });
        shape.collisionGroup = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Bomb");
        shape.collisionMask = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Turret", "Bullet", "Explosion");
        body.addShape(shape);
        body.position = [
            position.x,
            position.y
        ];
        // Add initial velocity toward center
        const directionToCenter = (0, $cbsax.V)(0, 0).sub(position).normalize().imul($a6431f147b47ae9b$var$INITIAL_VELOCITY_MULTIPLIER);
        body.velocity = [
            directionToCenter.x,
            directionToCenter.y
        ];
        return body;
    }
    setupVisual() {
        const visualConfig = this.getVisualConfig();
        this.renderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(visualConfig.points, visualConfig.strokeColor, visualConfig.strokeWidth || 1);
        this.addChild(this.renderer);
    }
    getMovementBehavior() {
        this.gravityMovement = new (0, $ab37fbc46984111b$export$e4141852802c2c80)();
        return this.gravityMovement;
    }
    getVisualConfig() {
        // Create a spiky star shape by alternating inner and outer radii
        const points = [];
        const outerRadius = $a6431f147b47ae9b$var$BOMB_RADIUS;
        const innerRadius = $a6431f147b47ae9b$var$BOMB_RADIUS * 0.5;
        const spikes = $a6431f147b47ae9b$var$BOMB_POLYGON_POINTS;
        for(let i = 0; i < spikes * 2; i++){
            const angle = i * Math.PI / spikes;
            const radius = i % 2 === 0 ? outerRadius : innerRadius;
            points.push((0, $cbsax.V)(Math.cos(angle) * radius, Math.sin(angle) * radius));
        }
        return {
            points: points,
            strokeColor: (0, $hA6FJ.Colors).RED,
            strokeWidth: $a6431f147b47ae9b$var$BOMB_STROKE_WIDTH
        };
    }
    getExplosionConfig() {
        return {
            radius: $a6431f147b47ae9b$var$BOMB_EXPLOSION_RADIUS,
            lifetime: $a6431f147b47ae9b$var$BOMB_EXPLOSION_LIFETIME,
            color: (0, $hA6FJ.Colors).PINK,
            damage: this.damage
        };
    }
    updateVisualPosition() {
        if (this.body && this.renderer) {
            this.renderer.setPosition(this.body.position);
            // Add spinning rotation
            this.renderer.setRotation(this.renderer.getRotation() + $a6431f147b47ae9b$var$BOMB_ROTATION_SPEED);
        }
    }
    getExplosionType() {
        return "bomb";
    }
    /**
   * Get the renderer for applying visual effects
   * @example bomb.getRenderer().addFilter(new FlashFilter(...))
   */ getRenderer() {
        return this.renderer;
    }
}




var $biKyI = parcelRequire("biKyI");


var $hA6FJ = parcelRequire("hA6FJ");


var $cbsax = parcelRequire("cbsax");





var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");
const $d3dad9e079ac3198$var$DEFAULT_SPEED = 60; // pixels per second
const $d3dad9e079ac3198$var$DEFAULT_TURN_SPEED = 2.0; // radians per second
const $d3dad9e079ac3198$var$DEFAULT_LIFETIME = 10.0; // seconds before self-destruct
class $d3dad9e079ac3198$export$2b15691bfc9d8464 {
    constructor(speed = $d3dad9e079ac3198$var$DEFAULT_SPEED, turnSpeed = $d3dad9e079ac3198$var$DEFAULT_TURN_SPEED, lifetime = $d3dad9e079ac3198$var$DEFAULT_LIFETIME){
        this.timeAlive = 0;
        this.speed = speed;
        this.turnSpeed = turnSpeed;
        this.lifetime = lifetime;
    }
    update(munition, dt) {
        if (!munition.body || !munition.game) return;
        this.timeAlive += dt;
        // Self-destruct after lifetime expires
        if (this.timeAlive >= this.lifetime) {
            munition.explode();
            return;
        }
        // Find the turret to track
        const turrets = munition.game.entities.getTagged("turret");
        if (turrets.length === 0) return;
        const turret = turrets[0];
        const targetPos = (0, $cbsax.V)(turret.body?.position || [
            0,
            0
        ]);
        const currentPos = (0, $cbsax.V)(munition.body.position);
        // Calculate direction to target
        const directionToTarget = targetPos.sub(currentPos).normalize();
        // Get current velocity direction
        const currentVel = (0, $cbsax.V)(munition.body.velocity);
        if (currentVel.magnitude < 0.1) {
            // If not moving, start moving toward target
            munition.body.velocity = [
                directionToTarget.x * this.speed,
                directionToTarget.y * this.speed
            ];
            return;
        }
        // Calculate current angle and target angle
        const currentAngle = currentVel.angle;
        const targetAngle = directionToTarget.angle;
        // Calculate the shortest angular distance
        let angleDiff = (0, $jd0t2.normalizeAngle)(targetAngle - currentAngle);
        // Apply turn speed limit
        const turnAmount = (0, $jd0t2.clamp)(angleDiff, -this.turnSpeed * dt, this.turnSpeed * dt);
        const newAngle = currentAngle + turnAmount;
        // Set new velocity with constant speed
        const newVelocity = (0, $cbsax.V)(1, 0).rotate(newAngle).imul(this.speed);
        munition.body.velocity = newVelocity;
    }
}


// Missile physics constants
const $6a47ee8bc05e131a$var$MISSILE_RADIUS = 3;
const $6a47ee8bc05e131a$var$MISSILE_MASS = 0.3;
const $6a47ee8bc05e131a$var$MISSILE_SPEED = 60;
const $6a47ee8bc05e131a$var$MISSILE_TURN_SPEED = 2.0;
const $6a47ee8bc05e131a$var$MISSILE_LIFETIME = 10.0;
// Missile rendering constants
const $6a47ee8bc05e131a$var$MISSILE_STROKE_WIDTH = 1;
const $6a47ee8bc05e131a$var$MISSILE_FLASH_RATE = 0.1; // seconds
const $6a47ee8bc05e131a$var$MISSILE_COLOR_1 = (0, $hA6FJ.Colors).CYAN;
const $6a47ee8bc05e131a$var$MISSILE_COLOR_2 = (0, $hA6FJ.Colors).PINK;
// Missile trail constants
const $6a47ee8bc05e131a$var$TRAIL_INTERVAL = 0.2; // seconds
const $6a47ee8bc05e131a$var$TRAIL_LIFETIME = 0.3; // seconds
const $6a47ee8bc05e131a$var$TRAIL_VELOCITY_SCALE = 10;
const $6a47ee8bc05e131a$var$TRAIL_SIZE = 2;
const $6a47ee8bc05e131a$var$TRAIL_HEXAGON_SIDES = 6;
// Missile explosion constants
const $6a47ee8bc05e131a$var$MISSILE_EXPLOSION_RADIUS = 20;
const $6a47ee8bc05e131a$var$MISSILE_EXPLOSION_LIFETIME = 1.0;
const $6a47ee8bc05e131a$var$MISSILE_DAMAGE = 1;
class $6a47ee8bc05e131a$export$2da2b8b1d50a67d extends (0, $f99fab462ba2bee7$export$ebb779659660811c) {
    constructor(position){
        super(position), this.munitionType = (0, $f99fab462ba2bee7$export$4b63755fcb155410).MISSILE, this.damage = $6a47ee8bc05e131a$var$MISSILE_DAMAGE, this.flashTimer = 0, this.currentColorIndex = 0, this.trailTimer = 0;
        this.tags = [
            "missile",
            "levelEntity"
        ];
    }
    createBody(position) {
        const body = new (0, $biKyI.Body)({
            mass: $6a47ee8bc05e131a$var$MISSILE_MASS
        });
        const shape = new (0, $biKyI.Circle)({
            radius: $6a47ee8bc05e131a$var$MISSILE_RADIUS
        });
        shape.collisionGroup = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Bomb");
        shape.collisionMask = (0, $5cb9574f3b2dfe63$export$d41d774dcb8e51f0)("Turret", "Bullet", "Explosion");
        body.addShape(shape);
        body.position = [
            position.x,
            position.y
        ];
        // Start with minimal velocity - tracking will take over
        body.velocity = [
            0,
            0
        ];
        return body;
    }
    setupVisual() {
        const visualConfig = this.getVisualConfig();
        this.renderer = (0, $39e6ece9400a3f87$export$2e2bcd8739ae039).fromPolygon(visualConfig.points, visualConfig.strokeColor, visualConfig.strokeWidth || 1);
        this.addChild(this.renderer);
    }
    getMovementBehavior() {
        this.trackingMovement = new (0, $d3dad9e079ac3198$export$2b15691bfc9d8464)($6a47ee8bc05e131a$var$MISSILE_SPEED, $6a47ee8bc05e131a$var$MISSILE_TURN_SPEED, $6a47ee8bc05e131a$var$MISSILE_LIFETIME);
        return this.trackingMovement;
    }
    getVisualConfig() {
        // Create an arrow/triangle shape pointing up (missiles are directional)
        const points = [
            (0, $cbsax.V)(0, -$6a47ee8bc05e131a$var$MISSILE_RADIUS),
            (0, $cbsax.V)($6a47ee8bc05e131a$var$MISSILE_RADIUS, $6a47ee8bc05e131a$var$MISSILE_RADIUS),
            (0, $cbsax.V)(-$6a47ee8bc05e131a$var$MISSILE_RADIUS, $6a47ee8bc05e131a$var$MISSILE_RADIUS)
        ];
        return {
            points: points,
            strokeColor: $6a47ee8bc05e131a$var$MISSILE_COLOR_1,
            strokeWidth: $6a47ee8bc05e131a$var$MISSILE_STROKE_WIDTH
        };
    }
    getExplosionConfig() {
        return {
            radius: $6a47ee8bc05e131a$var$MISSILE_EXPLOSION_RADIUS,
            lifetime: $6a47ee8bc05e131a$var$MISSILE_EXPLOSION_LIFETIME,
            color: this.currentColorIndex === 0 ? $6a47ee8bc05e131a$var$MISSILE_COLOR_1 : $6a47ee8bc05e131a$var$MISSILE_COLOR_2,
            damage: this.damage
        };
    }
    onTick(dt) {
        super.onTick(dt);
        if (!this.body || this.exploded) return;
        // Handle color flashing
        this.flashTimer += dt;
        if (this.flashTimer >= $6a47ee8bc05e131a$var$MISSILE_FLASH_RATE) {
            this.flashTimer = 0;
            this.currentColorIndex = (this.currentColorIndex + 1) % 2;
            const newColor = this.currentColorIndex === 0 ? $6a47ee8bc05e131a$var$MISSILE_COLOR_1 : $6a47ee8bc05e131a$var$MISSILE_COLOR_2;
            if (this.renderer?.sprite) {
                // Update renderer segments with new color
                const visualConfig = this.getVisualConfig();
                const newSegments = (0, $686b22f01240f09f$export$34e53d4e8f1e555c)(visualConfig.points, newColor, visualConfig.strokeWidth);
                this.renderer.setSegments(newSegments);
            }
        }
        // Create trail particles
        this.trailTimer += dt;
        if (this.trailTimer >= $6a47ee8bc05e131a$var$TRAIL_INTERVAL) {
            this.trailTimer = 0;
            this.createTrailEffect();
        }
    }
    createTrailEffect() {
        if (!this.body) return;
        // Get current velocity for trail inheritance
        const missileVelocity = (0, $cbsax.V)(this.body.velocity).imul(-0.2); // Trail moves opposite direction
        this.getCurrentLevel()?.addChild(new (0, $3427e84844ca2b22$export$2e2bcd8739ae039)({
            position: (0, $cbsax.V)(this.body.position),
            polygon: (0, $aa0a0f3c701f5a9a$export$e636e17021965266)($6a47ee8bc05e131a$var$TRAIL_HEXAGON_SIDES, $6a47ee8bc05e131a$var$TRAIL_SIZE),
            colors: [
                (0, $hA6FJ.Colors).ORANGE,
                (0, $hA6FJ.Colors).RED
            ],
            lifetime: $6a47ee8bc05e131a$var$TRAIL_LIFETIME,
            velocityScale: $6a47ee8bc05e131a$var$TRAIL_VELOCITY_SCALE,
            inheritedVelocity: missileVelocity
        }));
    }
    updateVisualPosition() {
        if (this.body && this.renderer) {
            this.renderer.setPosition(this.body.position);
            // Rotate missile to face movement direction
            const velocity = (0, $cbsax.V)(this.body.velocity);
            if (velocity.magnitude > 0.1) {
                const angle = velocity.angle + Math.PI / 2; // Add 90° since triangle points up
                this.renderer.setRotation(angle);
            }
        }
    }
    getExplosionType() {
        return "missile";
    }
}


class $f86caf8142d43229$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$fda5971927322b04) {
    onKeyDown({ key: key }) {
        if (!this.game) return;
        switch(key){
            case "KeyA":
                // Spawn asteroid at cursor
                this.getCurrentLevel()?.addChild(new (0, $488d8131288bea22$export$2e2bcd8739ae039)(this.game.camera.toWorld(this.game.io.mousePosition), (0, $7ea8b61c3c164d40$export$8f41e2a7b075abec).MEDIUM));
                break;
            case "KeyM":
                // Spawn random munition at cursor
                const cursorWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
                const randomChoice = (0, $azFtk.choose)(0, 1, 2);
                let munition;
                switch(randomChoice){
                    case 0:
                        munition = new (0, $a6431f147b47ae9b$export$c5a0ca915ee7870f)(cursorWorldPos);
                        break;
                    case 1:
                        munition = new (0, $136eb7a42ae5ab76$export$e35b65c41e9877e0)(cursorWorldPos);
                        break;
                    case 2:
                        munition = new (0, $6a47ee8bc05e131a$export$2da2b8b1d50a67d)(cursorWorldPos);
                        break;
                    default:
                        munition = new (0, $a6431f147b47ae9b$export$c5a0ca915ee7870f)(cursorWorldPos);
                }
                this.getCurrentLevel()?.addChild(munition);
                break;
            case "KeyL":
                // Auto-win current level
                this.dispatch("levelComplete", {
                    level: this.getGameFlowManager()?.currentLevel || 1,
                    enemiesKilled: 0
                });
                break;
            default:
                break;
        }
    }
    constructor(...args){
        super(...args), this.pausable = false // Work even when paused for debugging
        ;
    }
}


// Camera settings - starts at higher zoom and gradually zooms out each level
const $335edf1edb60137f$var$BASE_CAMERA_ZOOM = 2.5;
const $335edf1edb60137f$var$ZOOM_DECREASE_PER_LEVEL = 0.05;
// Constants for level completion
const $335edf1edb60137f$var$LEVEL_COMPLETE_DELAY = 1.5; // seconds
class $335edf1edb60137f$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(level){
        super(), this.id = "currentLevel", this.spawningFinished = false, this.levelCompleteTimer = 0, this.levelConditionsMet = false;
        this.levelNumber = level;
    }
    onAdd() {
        this.setupLevel();
    }
    onTick(dt) {
        if (!this.game) return;
        // Check if level conditions are met
        if (!this.levelConditionsMet) {
            const remainingLevelEntities = this.game.entities.getTagged("levelEntity");
            if (this.spawningFinished && remainingLevelEntities.length === 0) this.levelConditionsMet = true;
        }
        // If conditions are met, tick the timer
        if (this.levelConditionsMet) {
            this.levelCompleteTimer += dt;
            if (this.levelCompleteTimer >= $335edf1edb60137f$var$LEVEL_COMPLETE_DELAY) this.completeLevel();
        }
    }
    onSpawningFinished() {
        this.spawningFinished = true;
    }
    setupLevel() {
        if (!this.game) return;
        // Create Earth at center (background layer)
        this.addChild(new (0, $4957dda0a15a616e$export$2e2bcd8739ae039)());
        // Create turret and set up camera
        const turret = this.addChild(new (0, $fa5e78094187c70e$export$2e2bcd8739ae039)());
        this.game.camera.center(turret.getPosition());
        // Create shield at same position as turret
        this.addChild(new (0, $4f09d4bcf4dda17d$export$2e2bcd8739ae039)());
        // Create aim line for targeting feedback
        this.addChild(new (0, $6478774c9b3a419d$export$1949f3e5f26776fe)());
        // Calculate zoom level - gradually zoom out each level
        const zoomLevel = (0, $jd0t2.clampUp)($335edf1edb60137f$var$BASE_CAMERA_ZOOM - (this.levelNumber - 1) * $335edf1edb60137f$var$ZOOM_DECREASE_PER_LEVEL);
        this.game.camera.z = zoomLevel;
        // Create enemy spawner
        this.addChild(new (0, $2482de655744cc87$export$2e2bcd8739ae039)(this.levelNumber));
        // Create sound generators
        this.addChild(new (0, $5d78fa3449a4462a$export$2e2bcd8739ae039)());
        this.addChild(new (0, $1e752d62de033aea$export$2e2bcd8739ae039)());
        this.addChild(new (0, $bf9549401b8888a4$export$2e2bcd8739ae039)());
        this.addChild(new (0, $7ca470daa47cdc6e$export$2e2bcd8739ae039)());
        // Add debug/testing utilities
        this.addChild(new (0, $f86caf8142d43229$export$2e2bcd8739ae039)());
        // Show level intro
        this.addChild(new (0, $b4153caf44c479c0$export$3ba95a887317c488)(this.levelNumber));
        // Dispatch level start event for music system
        this.dispatch("levelStart", {
            level: this.levelNumber
        });
    }
    completeLevel() {
        // Dispatch level completion
        this.dispatch("levelComplete", {
            level: this.levelNumber,
            enemiesKilled: 0
        });
        // Level will auto-destroy all children when destroyed
        this.destroy();
    }
}




var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $c4Qw3 = parcelRequire("c4Qw3");

var $cbsax = parcelRequire("cbsax");



const $bb77b6f1fa69716f$var$LEVEL_DISPLAY_OFFSET = 1; // Offset to convert current level to completed levels count
class $bb77b6f1fa69716f$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(finalScore = 0, finalLevel = 1){
        super(), this.finalScore = finalScore, this.finalLevel = finalLevel, this.pausable = false, this.handleMainMenu = ()=>{
            if (!this.game) return;
            // Store game reference before destroying anything
            const game = this.game;
            // Use setTimeout to avoid race conditions
            setTimeout(()=>{
                // Destroy the game flow manager (and all game entities)
                const gameFlowManager = game.entities.getById("gameFlowManager");
                gameFlowManager?.destroy();
                // Add main menu
                game.addEntity(new (0, $020abb3a6f66f4df$export$2e2bcd8739ae039)());
                // Unpause the game
                game.unpause();
            }, 0);
        };
        // Create background
        this.background = (0, $c4Qw3.createGraphics)("menuBackground");
        // Create "GAME OVER" title
        this.gameOverText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: "GAME OVER",
            scale: 6.0,
            strokeWidth: 4,
            color: (0, $hA6FJ.Colors).RED,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
        // Create final score text
        this.finalScoreText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: `FINAL SCORE: ${this.finalScore.toLocaleString()}`,
            scale: 2.5,
            strokeWidth: 2,
            color: (0, $hA6FJ.Colors).RED,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
        // Create levels completed text
        const levelsCompleted = this.finalLevel - $bb77b6f1fa69716f$var$LEVEL_DISPLAY_OFFSET;
        this.levelsCompletedText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: `LEVELS COMPLETED: ${levelsCompleted}`,
            scale: 2.5,
            strokeWidth: 2,
            color: (0, $hA6FJ.Colors).RED,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
        // Create main menu button
        this.mainMenuButton = new (0, $285b9fda6215663d$export$b963714923cb1ea4)({
            text: "MAIN MENU",
            style: "primary",
            size: "large",
            onClick: this.handleMainMenu,
            layer: "menu",
            color: (0, $hA6FJ.Colors).RED
        });
    }
    onAdd() {
        // Set sprite for positioning
        this.sprite = this.background;
        // Add all UI elements
        this.addChild(this.gameOverText);
        this.addChild(this.finalScoreText);
        this.addChild(this.levelsCompletedText);
        this.addChild(this.mainMenuButton);
        // Check for high score
        this.checkHighScore();
        // Position everything
        this.updatePositions();
        // Draw the background
        this.drawBackground();
    }
    checkHighScore() {
        const highScoreManager = this.game?.entities.getById("highScoreManager");
        if (!highScoreManager) return;
        // Submit the score
        const levelsCompleted = this.finalLevel - $bb77b6f1fa69716f$var$LEVEL_DISPLAY_OFFSET;
        const entry = highScoreManager.submitScore(this.finalScore, levelsCompleted);
        if (entry) {
            // It's a high score!
            const rank = highScoreManager.getScoreRank(this.finalScore);
            this.highScoreText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
                text: rank === 1 ? "NEW HIGH SCORE!" : `HIGH SCORE #${rank}!`,
                scale: 3.0,
                strokeWidth: 2,
                color: (0, $hA6FJ.Colors).YELLOW,
                anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
                verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
                layer: "menu"
            });
            this.addChild(this.highScoreText);
        }
    }
    drawBackground() {
        if (!this.game) return;
        // Get screen dimensions
        const screenWidth = this.game.renderer.app.renderer.width;
        const screenHeight = this.game.renderer.app.renderer.height;
        // Create a centered background box
        const boxWidth = 500;
        const boxHeight = 400;
        this.background.clear();
        // Draw black background with some transparency
        this.background.rect(-boxWidth / 2, -boxHeight / 2, boxWidth, boxHeight);
        this.background.fill({
            color: 0x000000,
            alpha: 0.9
        });
        // Draw border
        this.background.rect(-boxWidth / 2, -boxHeight / 2, boxWidth, boxHeight);
        this.background.stroke({
            color: (0, $hA6FJ.Colors).RED,
            width: 3
        });
        // Position background at center of screen
        this.background.position.set(screenWidth / 2, screenHeight / 2);
    }
    updatePositions() {
        if (!this.game) return;
        // Get screen dimensions
        const screenWidth = this.game.renderer.app.renderer.width;
        const screenHeight = this.game.renderer.app.renderer.height;
        const centerX = screenWidth / 2;
        const centerY = screenHeight / 2;
        // Position elements vertically
        if (this.highScoreText) {
            // Adjust layout when high score is shown
            this.gameOverText.position = (0, $cbsax.V)(centerX, centerY - 140);
            this.highScoreText.position = (0, $cbsax.V)(centerX, centerY - 80);
            this.finalScoreText.position = (0, $cbsax.V)(centerX, centerY - 20);
            this.levelsCompletedText.position = (0, $cbsax.V)(centerX, centerY + 20);
            this.mainMenuButton.setPosition((0, $cbsax.V)(centerX, centerY + 90));
        } else {
            // Normal layout
            this.gameOverText.position = (0, $cbsax.V)(centerX, centerY - 120);
            this.finalScoreText.position = (0, $cbsax.V)(centerX, centerY - 40);
            this.levelsCompletedText.position = (0, $cbsax.V)(centerX, centerY);
            this.mainMenuButton.setPosition((0, $cbsax.V)(centerX, centerY + 80));
        }
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $c4Qw3 = parcelRequire("c4Qw3");

var $cbsax = parcelRequire("cbsax");
const $16d35e5a2854df84$var$MARGIN = 10;
const $16d35e5a2854df84$var$INDICATOR_LENGTH = 30;
class $16d35e5a2854df84$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(){
        super();
        this.sprite = (0, $c4Qw3.createGraphics)("ui");
    }
    onTick(dt) {
        this.sprite.clear();
        const camera = this.game.camera;
        const screenSize = camera.getViewportSize();
        const screenCenter = new (0, $cbsax.V2d)(screenSize.x / 2, screenSize.y / 2);
        const levelEntities = this.game.entities.getTagged("levelEntity");
        for (const entity of levelEntities){
            // Cast to BaseEntity to access getPosition
            const baseEntity = entity;
            if (!baseEntity.sprite && !baseEntity.body) continue; // Skip entities without position
            const worldPos = baseEntity.getPosition();
            if (!worldPos || camera.worldPointIsVisible(worldPos)) continue;
            const screenPos = camera.toScreen(worldPos);
            const direction = screenPos.sub(screenCenter).normalize();
            const edgePos = this.calculateEdgePosition(screenPos, screenCenter, screenSize);
            this.drawIndicator(edgePos, direction);
        }
    }
    calculateEdgePosition(targetPos, center, screenSize) {
        const direction = targetPos.sub(center);
        const halfWidth = screenSize.x / 2;
        const halfHeight = screenSize.y / 2;
        const scaleX = Math.abs(direction.x) > 0 ? halfWidth / Math.abs(direction.x) : Infinity;
        const scaleY = Math.abs(direction.y) > 0 ? halfHeight / Math.abs(direction.y) : Infinity;
        const scale = Math.min(scaleX, scaleY);
        return center.add(direction.mul(scale));
    }
    drawIndicator(edgePosition, direction) {
        const base = edgePosition.sub(direction.mul($16d35e5a2854df84$var$MARGIN));
        const tip = edgePosition.add(direction.mul($16d35e5a2854df84$var$INDICATOR_LENGTH));
        this.sprite.moveTo(base.x, base.y);
        this.sprite.lineTo(tip.x, tip.y);
        this.sprite.stroke({
            color: (0, $hA6FJ.Colors).RED,
            width: 2
        });
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $cbsax = parcelRequire("cbsax");




class $7fa25b5efc3d1664$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(){
        super(), this.pausable = false // Continue to work even when paused
        , this.tags = [
            "pauseMenu"
        ], this.handleVolumeChange = (newVolume)=>{
            this.currentVolume = newVolume;
            // Update game master gain
            if (this.game?.masterGain) this.game.masterGain.gain.value = newVolume;
            // Save to localStorage
            localStorage.setItem("gameVolume", newVolume.toString());
            // Update percentage display
            this.volumePercentage.text = `${Math.round(newVolume * 100)}%`;
        }, this.handleResume = ()=>{
            this.game?.unpause();
            this.destroy();
        }, this.handleMainMenu = ()=>{
            if (!this.game) return;
            // Store game reference before destroying anything
            const game = this.game;
            // Use setTimeout to ensure this happens on the next frame
            // This prevents race conditions with other event handlers
            setTimeout(()=>{
                // Destroy all pause menus manually
                const pauseMenus = game.entities.getTagged("pauseMenu") || [];
                for (const pauseMenu of pauseMenus)pauseMenu.destroy();
                // Destroy the game flow manager (and all game entities)
                const gameFlowManager = game.entities.getById("gameFlowManager");
                if (gameFlowManager) gameFlowManager.destroy();
                // Add main menu
                game.addEntity(new (0, $020abb3a6f66f4df$export$2e2bcd8739ae039)());
                // Unpause the game
                game.unpause();
            }, 0);
        };
        // Load saved volume or use default
        const savedVolume = localStorage.getItem("gameVolume");
        this.currentVolume = savedVolume !== null ? parseFloat(savedVolume) : 0.5;
        // Create background
        this.background = new (0, $iuB9z.Graphics)();
        this.background.layerName = "menuBackground";
        // Create title
        this.titleText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: "PAUSED",
            scale: 5.0,
            strokeWidth: 3,
            color: (0, $hA6FJ.Colors).CYAN,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
        // Create volume label
        this.volumeLabel = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: "VOLUME",
            scale: 2.0,
            strokeWidth: 2,
            color: (0, $hA6FJ.Colors).WHITE,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).LEFT,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
        // Create volume percentage display
        this.volumePercentage = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: `${Math.round(this.currentVolume * 100)}%`,
            scale: 2.0,
            strokeWidth: 2,
            color: (0, $hA6FJ.Colors).CYAN,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).RIGHT,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
        // Create volume slider
        this.volumeSlider = new (0, $e2325cc4ccd00a20$export$1538832b887d48e7)({
            value: this.currentVolume,
            min: 0,
            max: 1,
            step: 0.1,
            width: 200,
            onChange: this.handleVolumeChange,
            layer: "menu"
        });
        // Create resume button
        this.resumeButton = new (0, $285b9fda6215663d$export$b963714923cb1ea4)({
            text: "RESUME",
            style: "primary",
            size: "large",
            onClick: this.handleResume,
            layer: "menu"
        });
        // Create main menu button
        this.mainMenuButton = new (0, $285b9fda6215663d$export$b963714923cb1ea4)({
            text: "MAIN MENU",
            style: "secondary",
            size: "large",
            onClick: this.handleMainMenu,
            layer: "menu"
        });
        // Create instruction text
        this.instructionText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: "PRESS ESC TO RESUME",
            scale: 1.5,
            strokeWidth: 2,
            color: (0, $hA6FJ.Colors).WHITE,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
    }
    onAdd() {
        // Set initial volume if game is available
        if (this.game?.masterGain) this.game.masterGain.gain.value = this.currentVolume;
        // Set sprite for positioning
        this.sprite = this.background;
        // Add all UI elements (background first so it's behind everything else)
        this.sprites = [
            this.background
        ];
        this.addChild(this.titleText);
        this.addChild(this.volumeLabel);
        this.addChild(this.volumePercentage);
        this.addChild(this.volumeSlider);
        this.addChild(this.resumeButton);
        this.addChild(this.mainMenuButton);
        this.addChild(this.instructionText);
        // Position everything
        this.updatePositions();
        // Draw the background
        this.drawBackground();
    }
    drawBackground() {
        if (!this.game) return;
        // Get screen dimensions
        const screenWidth = this.game.renderer.app.renderer.width;
        const screenHeight = this.game.renderer.app.renderer.height;
        // Create a centered background box
        const boxWidth = 500;
        const boxHeight = 400;
        this.background.clear();
        // Draw black background with some transparency
        this.background.rect(-boxWidth / 2, -boxHeight / 2, boxWidth, boxHeight);
        this.background.fill({
            color: 0x000000,
            alpha: 0.9
        });
        // Draw border
        this.background.rect(-boxWidth / 2, -boxHeight / 2, boxWidth, boxHeight);
        this.background.stroke({
            color: (0, $hA6FJ.Colors).CYAN,
            width: 3
        });
        // Position background at center of screen
        this.background.position.set(screenWidth / 2, screenHeight / 2);
    }
    updatePositions() {
        if (!this.game) return;
        // Get screen dimensions
        const screenWidth = this.game.renderer.app.renderer.width;
        const screenHeight = this.game.renderer.app.renderer.height;
        const centerX = screenWidth / 2;
        const centerY = screenHeight / 2;
        // Position title (relative to center since background is at center)
        this.titleText.position = (0, $cbsax.V)(centerX, centerY - 150);
        // Position volume controls (grouped together)
        const volumeY = centerY - 50;
        this.volumeLabel.position = (0, $cbsax.V)(centerX - 180, volumeY);
        this.volumeSlider.setPosition((0, $cbsax.V)(centerX, volumeY));
        this.volumePercentage.position = (0, $cbsax.V)(centerX + 180, volumeY);
        // Position buttons with better spacing
        this.resumeButton.setPosition((0, $cbsax.V)(centerX - 110, centerY + 50));
        this.mainMenuButton.setPosition((0, $cbsax.V)(centerX + 110, centerY + 50));
        // Position instruction text
        this.instructionText.position = (0, $cbsax.V)(centerX, centerY + 140);
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $cbsax = parcelRequire("cbsax");

const $8fd431a44c893245$var$MARGIN = 20; // Margin in pixels for positioning
class $8fd431a44c893245$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(){
        super();
        // Create score text (top-left)
        this.text = this.addChild(new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: "SCORE: 0",
            position: new (0, $cbsax.V2d)($8fd431a44c893245$var$MARGIN, $8fd431a44c893245$var$MARGIN),
            scale: 2.4,
            color: (0, $hA6FJ.Colors).CYAN,
            strokeWidth: 2,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).LEFT,
            layer: "ui"
        }));
    }
    onRender() {
        // Update score
        const currentScore = this.getCurrentScore();
        this.text.text = `SCORE: ${currentScore}`;
    }
    getCurrentScore() {
        const scoreManager = this.game?.entities.getById("scoreManager");
        return scoreManager?.score ?? 0;
    }
}



var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $azFtk = parcelRequire("azFtk");

var $cbsax = parcelRequire("cbsax");


var $iuB9z = parcelRequire("iuB9z");

var $hA6FJ = parcelRequire("hA6FJ");

var $2oYNi = parcelRequire("2oYNi");

var $cbsax = parcelRequire("cbsax");

class $30a3866151deae99$export$d965bc619eb93629 extends (0, $2oYNi.default) {
    constructor(options){
        super(), this.options = options, this.pausable = false, this.descriptionTexts = [], this.isHovered = false, this.isPressed = false, this.cardWidth = 200, this.cardHeight = 250, this.padding = (0, $hA6FJ.Spacing).MD, this.bounds = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        this.onClickCallback = options.onClick;
        // Create background graphics
        this.background = new (0, $iuB9z.Graphics)();
        if (options.layer) this.background.layerName = options.layer;
        // Create border graphics (separate for glow effect)
        this.border = new (0, $iuB9z.Graphics)();
        if (options.layer) this.border.layerName = options.layer;
        // Create title text
        this.titleText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: options.name.toUpperCase(),
            scale: 2.4,
            strokeWidth: 2,
            color: this.getRarityColor(),
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).TOP,
            layer: options.layer
        });
        // Create description text (may need to wrap)
        const descriptionLines = this.wrapText(options.description, 15);
        for (const line of descriptionLines){
            const text = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
                text: line,
                scale: 2.2,
                strokeWidth: 3,
                color: (0, $hA6FJ.Colors).CYAN,
                anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
                verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).TOP,
                layer: options.layer
            });
            this.descriptionTexts.push(text);
        }
        // Create rarity text
        this.rarityText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: options.rarity.toUpperCase(),
            scale: 1.5,
            strokeWidth: 2,
            color: this.getRarityColor(),
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).BOTTOM,
            layer: options.layer
        });
        // Position if provided
        if (options.position) this.updatePosition(options.position);
    }
    getRarityColor() {
        switch(this.options.rarity){
            case "common":
                return (0, $hA6FJ.Colors).GREEN;
            case "rare":
                return (0, $hA6FJ.Colors).PURPLE;
            case "epic":
                return (0, $hA6FJ.Colors).ORANGE;
            default:
                return (0, $hA6FJ.Colors).WHITE;
        }
    }
    wrapText(text, maxCharsPerLine) {
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words)if ((currentLine + " " + word).trim().length <= maxCharsPerLine || currentLine === "") currentLine = currentLine ? currentLine + " " + word : word;
        else {
            lines.push(currentLine);
            currentLine = word;
        }
        if (currentLine) lines.push(currentLine);
        return lines;
    }
    updatePosition(position) {
        this.background.position.set(position.x, position.y);
        this.border.position.set(position.x, position.y);
        // Update title position
        this.titleText.position = position.add((0, $cbsax.V)(0, -this.cardHeight / 2 + this.padding));
        // Update description positions
        const descriptionStartY = -this.cardHeight / 2 + 70;
        this.descriptionTexts.forEach((text, index)=>{
            text.position = position.add((0, $cbsax.V)(0, descriptionStartY + index * 32));
        });
        // Update rarity position
        this.rarityText.position = position.add((0, $cbsax.V)(0, this.cardHeight / 2 - this.padding));
        this.updateBounds();
    }
    updateBounds() {
        if (this.sprite) {
            const position = this.getPosition();
            this.bounds = {
                x: position.x - this.cardWidth / 2,
                y: position.y - this.cardHeight / 2,
                width: this.cardWidth,
                height: this.cardHeight
            };
        }
    }
    isPointInside(x, y) {
        return x >= this.bounds.x && x <= this.bounds.x + this.bounds.width && y >= this.bounds.y && y <= this.bounds.y + this.bounds.height;
    }
    redrawCard() {
        const rarityColor = this.getRarityColor();
        // Clear graphics
        this.background.clear();
        this.border.clear();
        // Draw background
        this.background.rect(-this.cardWidth / 2, -this.cardHeight / 2, this.cardWidth, this.cardHeight);
        this.background.fill({
            color: (0, $hA6FJ.Colors).BLACK,
            alpha: 0.8
        });
        // Draw border
        const borderWidth = this.isPressed ? 3 : this.isHovered ? 4 : 2;
        this.border.rect(-this.cardWidth / 2, -this.cardHeight / 2, this.cardWidth, this.cardHeight);
        this.border.stroke({
            color: rarityColor,
            width: borderWidth
        });
        // Add glow effect when hovered
        if (this.isHovered && !this.isPressed) {
            this.border.rect(-this.cardWidth / 2, -this.cardHeight / 2, this.cardWidth, this.cardHeight);
            this.border.stroke({
                color: rarityColor,
                width: 8,
                alpha: 0.3
            });
        }
        // Update text thickness on hover
        const textStrokeWidth = this.isHovered ? 4 : 3;
        this.titleText.strokeWidth = textStrokeWidth;
        for (const text of this.descriptionTexts)text.strokeWidth = this.isHovered ? 4 : 3;
        this.rarityText.strokeWidth = textStrokeWidth;
    }
    onAdd() {
        this.sprite = this.background;
        this.sprites = [
            this.background,
            this.border
        ];
        // Add all text elements
        this.addChildren(this.titleText, this.rarityText, ...this.descriptionTexts);
        this.redrawCard();
    }
    onRender() {
        // Check hover state
        if (this.game) {
            const mousePos = this.game.io.mousePosition;
            const wasHovered = this.isHovered;
            this.isHovered = this.isPointInside(mousePos.x, mousePos.y);
            if (wasHovered !== this.isHovered) this.redrawCard();
        }
    }
    onMouseDown() {
        if (this.game) {
            const mousePos = this.game.io.mousePosition;
            if (this.isPointInside(mousePos.x, mousePos.y)) {
                this.isPressed = true;
                this.redrawCard();
            }
        }
    }
    onMouseUp() {
        if (this.isPressed) {
            this.isPressed = false;
            this.redrawCard();
        }
    }
    onClick() {
        if (this.game) {
            const mousePos = this.game.io.mousePosition;
            if (this.isPointInside(mousePos.x, mousePos.y)) this.onClickCallback?.(this.options.id);
        }
    }
    setPosition(position) {
        this.updatePosition(position);
    }
}


// Number of upgrade options to present to the player
const $c36ec241bb0565ba$var$MAX_UPGRADE_OPTIONS = 3;
class $c36ec241bb0565ba$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(completedLevel){
        super(), this.completedLevel = completedLevel, this.upgradeCards = [], this.availableUpgrades = [], this.handleUpgradeChoice = (upgradeId)=>{
            this.dispatch("upgradeChosen", {
                upgrade: upgradeId
            });
            this.destroy();
        };
        // Create title text
        this.titleText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: `LEVEL ${this.completedLevel} COMPLETE!`,
            scale: 4.0,
            strokeWidth: 3,
            color: (0, $hA6FJ.Colors).CYAN,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
        // Create subtitle
        this.subtitleText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: "CHOOSE AN UPGRADE:",
            scale: 2.0,
            strokeWidth: 2,
            color: (0, $hA6FJ.Colors).WHITE,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
            layer: "menu"
        });
    }
    onAdd() {
        // Initialize available upgrades
        if (!this.game) return;
        const upgradeManager = this.game.entities.getById("upgradeManager");
        if (!upgradeManager) {
            console.error("UpgradeManager not found!");
            return;
        }
        const availableUpgrades = upgradeManager.getAvailableUpgrades();
        this.availableUpgrades = (0, $azFtk.shuffle)(availableUpgrades.map(([id, data])=>({
                id: id,
                ...data
            })) || []).slice(0, $c36ec241bb0565ba$var$MAX_UPGRADE_OPTIONS);
        // Create upgrade cards
        for (const upgrade of this.availableUpgrades){
            const card = new (0, $30a3866151deae99$export$d965bc619eb93629)({
                id: upgrade.id,
                name: upgrade.name,
                description: upgrade.description,
                rarity: upgrade.rarity,
                onClick: this.handleUpgradeChoice,
                layer: "menu"
            });
            this.upgradeCards.push(card);
            this.addChild(card);
        }
        // Add text elements
        this.addChild(this.titleText);
        this.addChild(this.subtitleText);
        // Position everything
        this.updatePositions();
    }
    updatePositions() {
        if (!this.game) return;
        // Get screen dimensions
        const screenWidth = this.game.renderer.app.renderer.width;
        const screenHeight = this.game.renderer.app.renderer.height;
        const centerX = screenWidth / 2;
        const centerY = screenHeight / 2;
        // Position title and subtitle
        this.titleText.position = (0, $cbsax.V)(centerX, centerY - 200);
        this.subtitleText.position = (0, $cbsax.V)(centerX, centerY - 140);
        // Position upgrade cards horizontally
        const cardSpacing = 240; // Card width + spacing
        const totalWidth = (this.upgradeCards.length - 1) * cardSpacing;
        const startX = centerX - totalWidth / 2;
        this.upgradeCards.forEach((card, index)=>{
            card.setPosition((0, $cbsax.V)(startX + index * cardSpacing, centerY + 20));
        });
    }
}



class $20710d7d967346e0$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$f3a7dc1d15b0c59c) {
    get score() {
        return this._score;
    }
    onScoreAdded(eventData) {
        this._score += eventData.points;
    }
    resetScore() {
        this._score = 0;
    }
    constructor(...args){
        super(...args), this.id = "scoreManager", this._score = 0;
    }
}



var $2JTRA = parcelRequire("2JTRA");

// Upgrade effect constants
const $c94f4f6b3294734e$var$RAPID_FIRE_MULTIPLIER = 2;
const $c94f4f6b3294734e$var$DAMAGE_BOOST_1_PERCENTAGE = 50;
const $c94f4f6b3294734e$var$DAMAGE_BOOST_2_PERCENTAGE = 100;
const $c94f4f6b3294734e$var$TRIPLE_SHOT_COUNT = 3;
const $c94f4f6b3294734e$var$SHIELD_CAPACITY_1_PERCENTAGE = 50;
const $c94f4f6b3294734e$var$SHIELD_CAPACITY_2_PERCENTAGE = 100;
const $c94f4f6b3294734e$var$SHIELD_RECHARGE_MULTIPLIER = 2;
const $c94f4f6b3294734e$export$dc06ca6a3a329ec6 = {
    rapidFire: {
        name: "Rapid Fire",
        description: `Fire bullets ${$c94f4f6b3294734e$var$RAPID_FIRE_MULTIPLIER}x as fast`,
        rarity: "common"
    },
    damageBoost1: {
        name: "Damage Boost I",
        description: `Bullets deal ${$c94f4f6b3294734e$var$DAMAGE_BOOST_1_PERCENTAGE}% more damage`,
        rarity: "common"
    },
    damageBoost2: {
        name: "Damage Boost II",
        description: `Bullets deal ${$c94f4f6b3294734e$var$DAMAGE_BOOST_2_PERCENTAGE}% more damage`,
        rarity: "rare",
        dependencies: [
            "damageBoost1"
        ]
    },
    tripleShot: {
        name: "Triple Shot",
        description: `Fire ${$c94f4f6b3294734e$var$TRIPLE_SHOT_COUNT} bullets at once`,
        rarity: "rare",
        dependencies: [
            "rapidFire"
        ]
    },
    piercingBullets: {
        name: "Piercing Bullets",
        description: "Bullets go through enemies",
        rarity: "rare",
        dependencies: [
            "damageBoost1"
        ]
    },
    shieldCapacity1: {
        name: "Shield Boost I",
        description: `Increase shield capacity by ${$c94f4f6b3294734e$var$SHIELD_CAPACITY_1_PERCENTAGE}%`,
        rarity: "common"
    },
    shieldCapacity2: {
        name: "Shield Boost II",
        description: `Increase shield capacity by ${$c94f4f6b3294734e$var$SHIELD_CAPACITY_2_PERCENTAGE}%`,
        rarity: "rare",
        dependencies: [
            "shieldCapacity1"
        ]
    },
    fastRecharge: {
        name: "Fast Recharge",
        description: `Shield recharges ${$c94f4f6b3294734e$var$SHIELD_RECHARGE_MULTIPLIER}x as fast`,
        rarity: "common",
        dependencies: [
            "shieldCapacity1"
        ]
    },
    autoTarget: {
        name: "Auto Target",
        description: "Auto-aim at nearest enemy",
        rarity: "epic",
        dependencies: [
            "tripleShot",
            "piercingBullets"
        ]
    },
    bombMagnet: {
        name: "Bomb Magnet",
        description: "Attract nearby bombs for easier shooting",
        rarity: "rare",
        dependencies: [
            "fastRecharge"
        ]
    }
};


class $8eae00bb716cefcf$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$f3a7dc1d15b0c59c) {
    get chosenUpgrades() {
        return this._chosenUpgrades;
    }
    onUpgradeChosen(eventData) {
        const upgradeId = eventData.upgrade;
        if (!this._chosenUpgrades.includes(upgradeId)) {
            this._chosenUpgrades.push(upgradeId);
            console.log(`Upgrade added: ${upgradeId}. Total upgrades: ${this._chosenUpgrades.length}`);
        } else console.log(`Upgrade ${upgradeId} already chosen, skipping duplicate`);
    }
    /**
   * Check if an upgrade has been purchased
   */ has(upgradeId) {
        return this._chosenUpgrades.includes(upgradeId);
    }
    reset() {
        this._chosenUpgrades = [];
    }
    /**
   * Get upgrades available for purchase based on tech tree dependencies
   */ getAvailableUpgrades() {
        return (0, $2JTRA.objectEntries)((0, $c94f4f6b3294734e$export$dc06ca6a3a329ec6)).filter(([id, upgrade])=>{
            // Skip if already owned
            if (this.has(id)) return false;
            // Check if all dependencies are met
            if ("dependencies" in upgrade && upgrade.dependencies) return upgrade.dependencies.every((dep)=>this.has(dep));
            // No dependencies, so it's available
            return true;
        });
    }
    constructor(...args){
        super(...args), this.id = "upgradeManager", this._chosenUpgrades = [];
    }
}


// Game flow constants
const $211c0dd201189301$var$INITIAL_LEVEL = 1;
class $211c0dd201189301$export$2e2bcd8739ae039 extends (0, $03951e13c89b8446$export$f3a7dc1d15b0c59c) {
    get currentLevel() {
        return this._currentLevel;
    }
    onAdd() {
        if (!this.game) return;
        // Set up core game systems as children
        this.addChild(new (0, $20710d7d967346e0$export$2e2bcd8739ae039)());
        this.addChild(new (0, $8fd431a44c893245$export$2e2bcd8739ae039)());
        this.addChild(new (0, $8eae00bb716cefcf$export$2e2bcd8739ae039)());
        this.addChild(new (0, $16d35e5a2854df84$export$2e2bcd8739ae039)());
        // Start the first level
        this.createLevel(this._currentLevel);
    }
    onLevelComplete({ level: level }) {
        // Add upgrade menu as child of GameFlowManager
        this.addChild(new (0, $c36ec241bb0565ba$export$2e2bcd8739ae039)(level));
    }
    onUpgradeChosen({}) {
        // The UpgradeManager already handles this via its onUpgradeChosen method
        this.startNextLevel();
    }
    onGameOver({}) {
        console.log("Game Over! Showing game over screen...");
        // Set game over state
        this._isGameOver = true;
        // Destroy the turret to stop shooting
        const turrets = this.game?.entities.getTagged("turret") || [];
        for (const turret of turrets)turret.destroy();
        // Get final stats
        const scoreManager = this.game?.entities.getById("scoreManager");
        const finalScore = scoreManager?.score || 0;
        const finalLevel = this._currentLevel;
        // Show game over screen (now has its own Main Menu button)
        this.addChild(new (0, $bb77b6f1fa69716f$export$2e2bcd8739ae039)(finalScore, finalLevel));
    }
    onKeyDown({ key: key }) {
        if (!this.game) return;
        // Don't process any game controls after game over
        if (this._isGameOver) return;
        switch(key){
            case "Escape":
                this.game.togglePause();
                break;
            default:
                break;
        }
    }
    onPause() {
        // Show pause menu when game is paused
        this.game?.addEntity(new (0, $7fa25b5efc3d1664$export$2e2bcd8739ae039)());
    }
    onUnpause() {
        // Hide pause menu when game is unpaused
        const pauseMenus = this.game?.entities.getTagged("pauseMenu") || [];
        for (const pauseMenu of pauseMenus)pauseMenu.destroy();
    }
    startNextLevel() {
        this._currentLevel++;
        this.createLevel(this._currentLevel);
    }
    createLevel(level) {
        this.addChild(new (0, $335edf1edb60137f$export$2e2bcd8739ae039)(level));
    }
    getCurrentLevel() {
        return this.game?.entities.getById("currentLevel");
    }
    constructor(...args){
        super(...args), this.id = "gameFlowManager", this.pausable = false // Continue to work even when paused
        , this.persistenceLevel = (0, $e2Ri5.PersistenceLevel).Game // Survive level transitions
        , this._currentLevel = $211c0dd201189301$var$INITIAL_LEVEL, this._isGameOver = false;
    }
}


class $020abb3a6f66f4df$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    constructor(){
        super(), this.lastTopScore = -1, this.handleStartGame = ()=>{
            if (!this.game) return;
            // Create game flow manager (automatically starts game via onAdd)
            this.game.addEntity(new (0, $211c0dd201189301$export$2e2bcd8739ae039)());
            // Remove the main menu
            this.destroy();
        };
        // Create title text
        this.title = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
            text: "UTOPIA MUST DANCE",
            position: (0, $cbsax.V)(0, -100),
            scale: 7.0,
            strokeWidth: 4,
            color: (0, $hA6FJ.Colors).CYAN,
            anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
            layer: "menu"
        });
        // Create start button
        this.startButton = new (0, $285b9fda6215663d$export$b963714923cb1ea4)({
            text: "START GAME",
            position: (0, $cbsax.V)(0, 50),
            style: "primary",
            size: "large",
            onClick: this.handleStartGame,
            layer: "menu"
        });
    // High score text will be created dynamically in updateHighScores()
    }
    onAdd() {
        // Add child entities
        this.addChild(this.title);
        this.addChild(this.startButton);
        // Update high scores and conditionally add high score UI
        this.refreshHighScores();
        // Center the menu on screen using actual screen dimensions
        this.updatePositions();
        // Dispatch menu start event for music system
        this.dispatch("menuStart", {});
    }
    onTick() {
        // Check if high score has changed and refresh if needed
        const highScoreManager = this.game?.entities.getById("highScoreManager");
        if (highScoreManager) {
            const currentTopScore = highScoreManager.getHighScore();
            if (currentTopScore !== this.lastTopScore) {
                this.refreshHighScores();
                this.updatePositions();
            }
        }
    }
    onResize() {
        // Re-center menu items when viewport changes
        this.updatePositions();
    }
    refreshHighScores() {
        // Clear existing high score UI elements
        this.clearHighScoreUI();
        // Rebuild high score UI
        this.updateHighScores();
        // Update the tracked value
        const highScoreManager = this.game?.entities.getById("highScoreManager");
        this.lastTopScore = highScoreManager?.getHighScore() ?? 0;
    }
    clearHighScoreUI() {
        // Remove high score text if it was added
        if (this.highScoreText) {
            const index = this.children.indexOf(this.highScoreText);
            if (index >= 0) {
                this.children.splice(index, 1);
                this.highScoreText.parent = undefined;
            }
            this.highScoreText = undefined;
        }
    }
    updateHighScores() {
        const highScoreManager = this.game?.entities.getById("highScoreManager");
        if (!highScoreManager) return;
        const highScore = highScoreManager.getHighScore();
        // Only show high score if there is one
        if (highScore > 0) {
            this.highScoreText = new (0, $b061550ace257732$export$8afd1fcb6a3a9ae4)({
                text: `HIGH SCORE: ${highScore.toLocaleString()}`,
                scale: 1.5,
                strokeWidth: 1,
                color: (0, $hA6FJ.Colors).YELLOW,
                anchor: (0, $b061550ace257732$export$f299601a0229bca4).CENTER,
                verticalAnchor: (0, $b061550ace257732$export$9d7381bdbf04641c).CENTER,
                layer: "menu"
            });
            this.addChild(this.highScoreText);
        }
    }
    updatePositions() {
        if (!this.game) return;
        // Get actual screen dimensions
        const screenWidth = this.game.renderer.app.renderer.width;
        const screenHeight = this.game.renderer.app.renderer.height;
        const centerX = screenWidth / 2;
        const centerY = screenHeight / 2;
        // Position high score at top of screen
        if (this.highScoreText) this.highScoreText.position = (0, $cbsax.V)(centerX, 30);
        // Center the main menu elements
        this.title.position = (0, $cbsax.V)(centerX, centerY - 80);
        this.startButton.setPosition((0, $cbsax.V)(centerX, centerY + 20));
    }
}



var $e2Ri5 = parcelRequire("e2Ri5");

var $2oYNi = parcelRequire("2oYNi");
const $3c83c0a2a6ba5d2f$var$STORAGE_KEY = "utopia-must-dance-highscores";
const $3c83c0a2a6ba5d2f$var$MAX_ENTRIES = 10;
class $3c83c0a2a6ba5d2f$export$7898e979bd6ca6be extends (0, $2oYNi.default) {
    constructor(){
        super(), this.id = "highScoreManager", this.persistenceLevel = (0, $e2Ri5.PersistenceLevel).Permanent, this.currentGameStart = 0, this.currentEnemiesDefeated = 0;
        this.highScoreData = this.loadHighScores();
    }
    onAdd() {
        this.currentGameStart = Date.now();
        this.currentEnemiesDefeated = 0;
    }
    /**
   * Loads high scores from localStorage.
   * Returns default data if no scores exist or if data is corrupted.
   */ loadHighScores() {
        try {
            const storedData = localStorage.getItem($3c83c0a2a6ba5d2f$var$STORAGE_KEY);
            if (storedData) {
                const parsed = JSON.parse(storedData);
                // Validate the data structure
                if (this.isValidHighScoreData(parsed)) return parsed;
            }
        } catch (error) {
            console.warn("Failed to load high scores:", error);
        }
        // Return default empty data
        return {
            entries: [],
            totalGamesPlayed: 0,
            totalEnemiesDefeated: 0,
            totalTimePlayed: 0
        };
    }
    /**
   * Validates that loaded data has the expected structure.
   */ isValidHighScoreData(data) {
        return data && Array.isArray(data.entries) && typeof data.totalGamesPlayed === "number" && typeof data.totalEnemiesDefeated === "number" && typeof data.totalTimePlayed === "number";
    }
    /**
   * Saves high scores to localStorage.
   */ saveHighScores() {
        try {
            localStorage.setItem($3c83c0a2a6ba5d2f$var$STORAGE_KEY, JSON.stringify(this.highScoreData));
        } catch (error) {
            console.error("Failed to save high scores:", error);
        }
    }
    /**
   * Checks if a score qualifies as a high score.
   */ isHighScore(score) {
        if (this.highScoreData.entries.length < $3c83c0a2a6ba5d2f$var$MAX_ENTRIES) return true;
        const lowestHighScore = this.highScoreData.entries[this.highScoreData.entries.length - 1].score;
        return score > lowestHighScore;
    }
    /**
   * Gets the current high score (top score).
   */ getHighScore() {
        return this.highScoreData.entries[0]?.score || 0;
    }
    /**
   * Gets all high score entries.
   */ getHighScores() {
        return [
            ...this.highScoreData.entries
        ];
    }
    /**
   * Gets the rank for a given score (1-based).
   * Returns 0 if the score doesn't make the leaderboard.
   */ getScoreRank(score) {
        for(let i = 0; i < this.highScoreData.entries.length; i++){
            if (score > this.highScoreData.entries[i].score) return i + 1;
        }
        if (this.highScoreData.entries.length < $3c83c0a2a6ba5d2f$var$MAX_ENTRIES) return this.highScoreData.entries.length + 1;
        return 0;
    }
    /**
   * Submits a new high score entry.
   */ submitScore(score, levelsCompleted) {
        const timeSurvived = (Date.now() - this.currentGameStart) / 1000; // Convert to seconds
        // Update lifetime stats
        this.highScoreData.totalGamesPlayed++;
        this.highScoreData.totalEnemiesDefeated += this.currentEnemiesDefeated;
        this.highScoreData.totalTimePlayed += timeSurvived;
        // Check if it's a high score
        if (!this.isHighScore(score)) {
            this.saveHighScores(); // Still save the updated stats
            return null;
        }
        // Create new entry
        const newEntry = {
            score: score,
            levelsCompleted: levelsCompleted,
            timeSurvived: timeSurvived,
            enemiesDefeated: this.currentEnemiesDefeated,
            date: new Date().toISOString()
        };
        // Insert the new entry in the correct position
        let inserted = false;
        for(let i = 0; i < this.highScoreData.entries.length; i++)if (score > this.highScoreData.entries[i].score) {
            this.highScoreData.entries.splice(i, 0, newEntry);
            inserted = true;
            break;
        }
        // If not inserted yet, add to the end
        if (!inserted) this.highScoreData.entries.push(newEntry);
        // Keep only top MAX_ENTRIES
        this.highScoreData.entries = this.highScoreData.entries.slice(0, $3c83c0a2a6ba5d2f$var$MAX_ENTRIES);
        // Save to localStorage
        this.saveHighScores();
        return newEntry;
    }
    /**
   * Gets lifetime statistics.
   */ getLifetimeStats() {
        const avgScore = this.highScoreData.entries.length > 0 ? this.highScoreData.entries.reduce((sum, entry)=>sum + entry.score, 0) / this.highScoreData.entries.length : 0;
        return {
            totalGamesPlayed: this.highScoreData.totalGamesPlayed,
            totalEnemiesDefeated: this.highScoreData.totalEnemiesDefeated,
            totalTimePlayed: this.highScoreData.totalTimePlayed,
            averageScore: Math.round(avgScore)
        };
    }
    /**
   * Clears all high scores (for debugging/testing).
   */ clearHighScores() {
        this.highScoreData = {
            entries: [],
            totalGamesPlayed: 0,
            totalEnemiesDefeated: 0,
            totalTimePlayed: 0
        };
        this.saveHighScores();
    }
    // Track enemy defeats during the current game
    onEnemyDestroyed() {
        this.currentEnemiesDefeated++;
    }
    onAsteroidDestroyed() {
        this.currentEnemiesDefeated++;
    }
    // Reset tracking for new game
    onLevelStart(eventData) {
        if (eventData.level === 1) {
            this.currentGameStart = Date.now();
            this.currentEnemiesDefeated = 0;
        }
    }
}


async function $1519c0f4dd754269$var$main() {
    // Make edges smooth
    (0, $iuB9z.TextureStyle).defaultOptions.scaleMode = "linear";
    const game = new (0, $kdszX.default)();
    await game.init({
        rendererOptions: {
            backgroundColor: (0, $hA6FJ.Colors).BLACK
        }
    });
    // Make the game accessible from the console
    window.DEBUG = {
        game: game
    };
    // Add cleanup handler for when user navigates away
    const cleanup = ()=>{
        game.destroy();
    };
    window.addEventListener("beforeunload", cleanup);
    window.addEventListener("pagehide", cleanup);
    // Add bloom controller for vector CRT display simulation with tempo sync
    game.addEntity(new (0, $a50b9ffa17eb6abf$export$2e2bcd8739ae039)());
    // Initialize high score manager (persistent singleton)
    game.addEntity(new (0, $3c83c0a2a6ba5d2f$export$7898e979bd6ca6be)());
    game.addEntity(new (0, $d8075dea9d554460$export$ae818792347e2c5a)());
    game.addEntity(new (0, $020abb3a6f66f4df$export$2e2bcd8739ae039)());
}
window.addEventListener("load", $1519c0f4dd754269$var$main);


//# sourceMappingURL=path0.26bf5b8c.js.map
